(function(){"use strict";try{if(typeof document<"u"){var a=document.createElement("style");a.appendChild(document.createTextNode("._tooltip_5svgn_1{width:260px}._popover_5svgn_5{background:var(--dixa-color-neutral-000);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);box-shadow:var(--dixa-effect-box-shadow-300);box-sizing:border-box;z-index:100}._bar_1n5dj_1{overflow:hidden}._section_1n5dj_5{position:relative}._sectionHidden_1n5dj_8{display:none!important}._sectionInheritRadius_1n5dj_11{border-radius:inherit}._valueOutside_1n5dj_15{position:absolute;left:calc(100% + var(--dixa-size-spacer-100));z-index:1}:root{--dixa-analytics-color-default-1: var(--dixa-color-purple-700);--dixa-analytics-color-default-2: var(--dixa-color-blue-300);--dixa-analytics-color-default-3: var(--dixa-color-red-500);--dixa-analytics-color-default-4: var(--dixa-color-orange-300);--dixa-analytics-color-default-5: var(--dixa-color-purple-500);--dixa-analytics-color-default-6: var(--dixa-color-green-400);--dixa-analytics-color-default-7: var(--dixa-color-neutral-600);--dixa-analytics-color-default-8: var(--dixa-color-neutral-400);--dixa-analytics-color-rating-1: var(--dixa-color-red-600);--dixa-analytics-color-rating-2: var(--dixa-color-red-400);--dixa-analytics-color-rating-3: var(--dixa-color-orange-300);--dixa-analytics-color-rating-4: var(--dixa-color-green-500);--dixa-analytics-color-rating-5: var(--dixa-color-green-600)}[data-color-mode=dark]{--dixa-analytics-color-default-1: var(--dixa-color-blue-300);--dixa-analytics-color-default-2: var(--dixa-color-blue-700);--dixa-analytics-color-default-3: var(--dixa-color-red-400);--dixa-analytics-color-default-4: var(--dixa-color-orange-600);--dixa-analytics-color-default-5: var(--dixa-color-purple-500);--dixa-analytics-color-default-6: var(--dixa-color-green-500);--dixa-analytics-color-default-7: var(--dixa-color-neutral-400);--dixa-analytics-color-default-8: var(--dixa-color-neutral-800);--dixa-analytics-color-rating-1: var(--dixa-color-red-400);--dixa-analytics-color-rating-2: var(--dixa-color-red-600);--dixa-analytics-color-rating-3: var(--dixa-color-orange-600);--dixa-analytics-color-rating-4: var(--dixa-color-green-400);--dixa-analytics-color-rating-5: var(--dixa-color-green-300)}._container_1t2a7_1{overflow:hidden}._root_6kwn9_1{display:grid;column-gap:var(--dixa-size-spacer-200);row-gap:var(--dixa-size-spacer-300);white-space:nowrap}._root_6kwn9_1:not(._rootBounded_6kwn9_7):not(._rootFluid_6kwn9_7){grid-template-columns:repeat(auto-fit,minmax(min(100% / 2 - var(--dixa-size-spacer-200) * (2 - 1) / 2,max(96px,100% / 6 - var(--dixa-size-spacer-200) * (6 - 1) / 6)),1fr))}._rootFluid_6kwn9_7,._rootBounded_6kwn9_7{grid-template-columns:repeat(auto-fit,minmax(96px,1fr))}._rootBounded_6kwn9_7{max-width:calc(6 * 96px + var(--dixa-size-spacer-200) * (6 - 1))}._wrapper_1w7q6_1{display:inline-flex;align-self:flex-start}._text_1w7q6_6{font-size:var(--dixa-typography-size-600)}._colorIndicator_luubh_1{width:6px;height:6px;border-radius:50%;flex-shrink:0}._root_7a8ds_48{display:flex;flex-direction:column;gap:var(--dixa-size-spacer-300);padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);box-shadow:var(--dixa-effect-box-shadow-300);background-color:light-dark(var(--dixa-color-neutral-900),var(--dixa-color-neutral-200));color:light-dark(var(--dixa-color-neutral-000),var(--dixa-typography-color-primary))}@supports not (color: light-dark(white,black)){._root_7a8ds_48{background-color:var(--dixa-color-neutral-900)}}@supports not (color: light-dark(white,black)){._root_7a8ds_48{color:var(--dixa-color-neutral-000)}}._legendItem_1mjjb_48{flex-shrink:0;overflow:hidden;white-space:nowrap;cursor:pointer;opacity:1}._legendItemInactive_1mjjb_55{opacity:.4}._legendIcon_1mjjb_59{flex-shrink:0;width:12px;border-radius:var(--dixa-size-border-radius-50);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);box-sizing:border-box}._legendIconBar_1mjjb_66{height:12px}._legendIconLine_1mjjb_69{height:4px}._trigger_1mrk9_1{width:100%;height:100%}._cell_hfkay_1{display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;cursor:default;opacity:1;transition:opacity .2s ease-in-out}._cell_hfkay_1:hover ._cellText_hfkay_11{color:var(--dixa-typography-color-primary)}._cellDimmed_hfkay_14{opacity:var(--dixa-effect-opacity-200)}._cellContent_hfkay_18{display:flex;align-items:center;justify-content:center;width:100%;height:100%}._cellText_hfkay_11{transition:color .2s ease-in-out}._grid_1qk2p_1{display:grid;grid-auto-rows:minmax(var(--dixa-size-spacer-500),1fr);flex-grow:1}._row_1qk2p_7{display:grid;grid-auto-columns:1fr;grid-auto-flow:column;align-items:center;text-align:center}._legend_bx9pd_48{position:relative}._trigger_bx9pd_52{position:absolute;top:-50%;right:0}._popover_bx9pd_58{width:256px;max-height:298px;padding:var(--dixa-size-spacer-300);z-index:100;box-sizing:border-box;background:var(--dixa-color-neutral-000);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);box-shadow:var(--dixa-effect-box-shadow-300);margin:0 var(--dixa-size-spacer-200);overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._breakdown_bx9pd_77{display:flex;flex-direction:column;gap:var(--dixa-size-spacer-250);list-style:none;margin:0;padding:0}._breakdown_bx9pd_77 li{display:grid;grid-template-columns:1fr auto;gap:var(--dixa-size-spacer-200)}._breakdown_bx9pd_77 li>:first-child{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}._tooltip_h4i5v_1{max-width:300px}._trigger_h4i5v_5{position:absolute;top:0;left:0;width:100%;height:100%;opacity:0}._tableWrapper_1xmkm_1{overflow:auto}._tableWrapperEmpty_1xmkm_4{flex-grow:1}._thCell_1xmkm_8{white-space:nowrap}._tdCell_1xmkm_12{position:relative;max-width:240px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}._tooltip_1xmkm_20{max-width:300px}")),document.head.appendChild(a)}}catch(r){console.error("vite-plugin-css-injected-by-js",r)}})();
import * as D from "react";
import to, { useCallback as G, createContext as Ct, useMemo as K, createElement as H, useContext as ro, forwardRef as he, Children as ct, isValidElement as Qt, cloneElement as cr, Fragment as Rl, useEffect as te, useRef as ne, useState as Z, useLayoutEffect as At, useReducer as od, memo as Ce } from "react";
import { IconButton as no, ButtonList as Tr, FlexBox as Y, Text as W, Tooltip as Ot, Box as ao, ButtonGroup as Sl, Button as Pl, EmptyState as El, Divider as sd, Badge as cd, Table as Re, HelpIcon as ud, Pagination as ld } from "@dixa/lib-shared-habla";
import * as fd from "react-dom";
import dd, { flushSync as Al } from "react-dom";
import qe from "classnames";
import { usePrevious as Ol, useInterval as hd, useList as pd, useUpdateEffect as Tt, useMap as vd } from "react-use";
import { Sector as Fo, LabelList as gd, Cell as No, ResponsiveContainer as md, XAxis as bd, YAxis as yd, CartesianGrid as _d, ReferenceLine as xd, Label as wd, Legend as Cd, Tooltip as Rd, PieChart as Sd, AreaChart as Pd, LineChart as Ed, BarChart as Ad, Line as Od, Bar as Td, Area as $d, Pie as qd } from "recharts";
import ut from "moment-timezone";
import { colors as Tl, typography as jd } from "@dixa/lib-shared-tokens";
import { TagChips as Id } from "lib-shared-tagging";
var kt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Se(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Md(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      var a = !1;
      try {
        a = this instanceof n;
      } catch {
      }
      return a ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var Lt = { exports: {} }, vt = {};
var ko;
function Dd() {
  if (ko) return vt;
  ko = 1;
  var e = to, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, c, u) {
    var d, l = {}, h = null, f = null;
    u !== void 0 && (h = "" + u), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (f = c.ref);
    for (d in c) n.call(c, d) && !i.hasOwnProperty(d) && (l[d] = c[d]);
    if (s && s.defaultProps) for (d in c = s.defaultProps, c) l[d] === void 0 && (l[d] = c[d]);
    return { $$typeof: t, type: s, key: h, ref: f, props: l, _owner: a.current };
  }
  return vt.Fragment = r, vt.jsx = o, vt.jsxs = o, vt;
}
var gt = {};
var Lo;
function Fd() {
  return Lo || (Lo = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = to, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), l = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), g = Symbol.iterator, p = "@@iterator";
    function m(v) {
      if (v === null || typeof v != "object")
        return null;
      var O = g && v[g] || v[p];
      return typeof O == "function" ? O : null;
    }
    var b = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function _(v) {
      {
        for (var O = arguments.length, j = new Array(O > 1 ? O - 1 : 0), N = 1; N < O; N++)
          j[N - 1] = arguments[N];
        C("error", v, j);
      }
    }
    function C(v, O, j) {
      {
        var N = b.ReactDebugCurrentFrame, z = N.getStackAddendum();
        z !== "" && (O += "%s", j = j.concat([z]));
        var U = j.map(function(V) {
          return String(V);
        });
        U.unshift("Warning: " + O), Function.prototype.apply.call(console[v], console, U);
      }
    }
    var R = !1, P = !1, A = !1, T = !1, x = !1, w;
    w = Symbol.for("react.module.reference");
    function E(v) {
      return !!(typeof v == "string" || typeof v == "function" || v === n || v === i || x || v === a || v === u || v === d || T || v === f || R || P || A || typeof v == "object" && v !== null && (v.$$typeof === h || v.$$typeof === l || v.$$typeof === o || v.$$typeof === s || v.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      v.$$typeof === w || v.getModuleId !== void 0));
    }
    function S(v, O, j) {
      var N = v.displayName;
      if (N)
        return N;
      var z = O.displayName || O.name || "";
      return z !== "" ? j + "(" + z + ")" : j;
    }
    function I(v) {
      return v.displayName || "Context";
    }
    function $(v) {
      if (v == null)
        return null;
      if (typeof v.tag == "number" && _("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof v == "function")
        return v.displayName || v.name || null;
      if (typeof v == "string")
        return v;
      switch (v) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case u:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof v == "object")
        switch (v.$$typeof) {
          case s:
            var O = v;
            return I(O) + ".Consumer";
          case o:
            var j = v;
            return I(j._context) + ".Provider";
          case c:
            return S(v, v.render, "ForwardRef");
          case l:
            var N = v.displayName || null;
            return N !== null ? N : $(v.type) || "Memo";
          case h: {
            var z = v, U = z._payload, V = z._init;
            try {
              return $(V(U));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, F = 0, q, k, L, Q, ae, re, pe;
    function oe() {
    }
    oe.__reactDisabledLog = !0;
    function ue() {
      {
        if (F === 0) {
          q = console.log, k = console.info, L = console.warn, Q = console.error, ae = console.group, re = console.groupCollapsed, pe = console.groupEnd;
          var v = {
            configurable: !0,
            enumerable: !0,
            value: oe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: v,
            log: v,
            warn: v,
            error: v,
            group: v,
            groupCollapsed: v,
            groupEnd: v
          });
        }
        F++;
      }
    }
    function ve() {
      {
        if (F--, F === 0) {
          var v = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, v, {
              value: q
            }),
            info: M({}, v, {
              value: k
            }),
            warn: M({}, v, {
              value: L
            }),
            error: M({}, v, {
              value: Q
            }),
            group: M({}, v, {
              value: ae
            }),
            groupCollapsed: M({}, v, {
              value: re
            }),
            groupEnd: M({}, v, {
              value: pe
            })
          });
        }
        F < 0 && _("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var X = b.ReactCurrentDispatcher, ge;
    function le(v, O, j) {
      {
        if (ge === void 0)
          try {
            throw Error();
          } catch (z) {
            var N = z.stack.trim().match(/\n( *(at )?)/);
            ge = N && N[1] || "";
          }
        return `
` + ge + v;
      }
    }
    var ie = !1, _e;
    {
      var Te = typeof WeakMap == "function" ? WeakMap : Map;
      _e = new Te();
    }
    function Fe(v, O) {
      if (!v || ie)
        return "";
      {
        var j = _e.get(v);
        if (j !== void 0)
          return j;
      }
      var N;
      ie = !0;
      var z = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var U;
      U = X.current, X.current = null, ue();
      try {
        if (O) {
          var V = function() {
            throw Error();
          };
          if (Object.defineProperty(V.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(V, []);
            } catch (de) {
              N = de;
            }
            Reflect.construct(v, [], V);
          } else {
            try {
              V.call();
            } catch (de) {
              N = de;
            }
            v.call(V.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (de) {
            N = de;
          }
          v();
        }
      } catch (de) {
        if (de && N && typeof de.stack == "string") {
          for (var B = de.stack.split(`
`), ce = N.stack.split(`
`), J = B.length - 1, ee = ce.length - 1; J >= 1 && ee >= 0 && B[J] !== ce[ee]; )
            ee--;
          for (; J >= 1 && ee >= 0; J--, ee--)
            if (B[J] !== ce[ee]) {
              if (J !== 1 || ee !== 1)
                do
                  if (J--, ee--, ee < 0 || B[J] !== ce[ee]) {
                    var xe = `
` + B[J].replace(" at new ", " at ");
                    return v.displayName && xe.includes("<anonymous>") && (xe = xe.replace("<anonymous>", v.displayName)), typeof v == "function" && _e.set(v, xe), xe;
                  }
                while (J >= 1 && ee >= 0);
              break;
            }
        }
      } finally {
        ie = !1, X.current = U, ve(), Error.prepareStackTrace = z;
      }
      var rt = v ? v.displayName || v.name : "", He = rt ? le(rt) : "";
      return typeof v == "function" && _e.set(v, He), He;
    }
    function fe(v, O, j) {
      return Fe(v, !1);
    }
    function $e(v) {
      var O = v.prototype;
      return !!(O && O.isReactComponent);
    }
    function se(v, O, j) {
      if (v == null)
        return "";
      if (typeof v == "function")
        return Fe(v, $e(v));
      if (typeof v == "string")
        return le(v);
      switch (v) {
        case u:
          return le("Suspense");
        case d:
          return le("SuspenseList");
      }
      if (typeof v == "object")
        switch (v.$$typeof) {
          case c:
            return fe(v.render);
          case l:
            return se(v.type, O, j);
          case h: {
            var N = v, z = N._payload, U = N._init;
            try {
              return se(U(z), O, j);
            } catch {
            }
          }
        }
      return "";
    }
    var Ne = Object.prototype.hasOwnProperty, Ft = {}, Nt = b.ReactDebugCurrentFrame;
    function Qe(v) {
      if (v) {
        var O = v._owner, j = se(v.type, v._source, O ? O.type : null);
        Nt.setExtraStackFrame(j);
      } else
        Nt.setExtraStackFrame(null);
    }
    function Rr(v, O, j, N, z) {
      {
        var U = Function.call.bind(Ne);
        for (var V in v)
          if (U(v, V)) {
            var B = void 0;
            try {
              if (typeof v[V] != "function") {
                var ce = Error((N || "React class") + ": " + j + " type `" + V + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof v[V] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ce.name = "Invariant Violation", ce;
              }
              B = v[V](O, V, N, j, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (J) {
              B = J;
            }
            B && !(B instanceof Error) && (Qe(z), _("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", N || "React class", j, V, typeof B), Qe(null)), B instanceof Error && !(B.message in Ft) && (Ft[B.message] = !0, Qe(z), _("Failed %s type: %s", j, B.message), Qe(null));
          }
      }
    }
    var et = Array.isArray;
    function Sr(v) {
      return et(v);
    }
    function Lf(v) {
      {
        var O = typeof Symbol == "function" && Symbol.toStringTag, j = O && v[Symbol.toStringTag] || v.constructor.name || "Object";
        return j;
      }
    }
    function Bf(v) {
      try {
        return So(v), !1;
      } catch {
        return !0;
      }
    }
    function So(v) {
      return "" + v;
    }
    function Po(v) {
      if (Bf(v))
        return _("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Lf(v)), So(v);
    }
    var Eo = b.ReactCurrentOwner, Vf = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ao, Oo;
    function Hf(v) {
      if (Ne.call(v, "ref")) {
        var O = Object.getOwnPropertyDescriptor(v, "ref").get;
        if (O && O.isReactWarning)
          return !1;
      }
      return v.ref !== void 0;
    }
    function zf(v) {
      if (Ne.call(v, "key")) {
        var O = Object.getOwnPropertyDescriptor(v, "key").get;
        if (O && O.isReactWarning)
          return !1;
      }
      return v.key !== void 0;
    }
    function Uf(v, O) {
      typeof v.ref == "string" && Eo.current;
    }
    function Wf(v, O) {
      {
        var j = function() {
          Ao || (Ao = !0, _("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", O));
        };
        j.isReactWarning = !0, Object.defineProperty(v, "key", {
          get: j,
          configurable: !0
        });
      }
    }
    function Gf(v, O) {
      {
        var j = function() {
          Oo || (Oo = !0, _("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", O));
        };
        j.isReactWarning = !0, Object.defineProperty(v, "ref", {
          get: j,
          configurable: !0
        });
      }
    }
    var Kf = function(v, O, j, N, z, U, V) {
      var B = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: v,
        key: O,
        ref: j,
        props: V,
        // Record the component responsible for creating this element.
        _owner: U
      };
      return B._store = {}, Object.defineProperty(B._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(B, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: N
      }), Object.defineProperty(B, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: z
      }), Object.freeze && (Object.freeze(B.props), Object.freeze(B)), B;
    };
    function Yf(v, O, j, N, z) {
      {
        var U, V = {}, B = null, ce = null;
        j !== void 0 && (Po(j), B = "" + j), zf(O) && (Po(O.key), B = "" + O.key), Hf(O) && (ce = O.ref, Uf(O, z));
        for (U in O)
          Ne.call(O, U) && !Vf.hasOwnProperty(U) && (V[U] = O[U]);
        if (v && v.defaultProps) {
          var J = v.defaultProps;
          for (U in J)
            V[U] === void 0 && (V[U] = J[U]);
        }
        if (B || ce) {
          var ee = typeof v == "function" ? v.displayName || v.name || "Unknown" : v;
          B && Wf(V, ee), ce && Gf(V, ee);
        }
        return Kf(v, B, ce, z, N, Eo.current, V);
      }
    }
    var Pr = b.ReactCurrentOwner, To = b.ReactDebugCurrentFrame;
    function tt(v) {
      if (v) {
        var O = v._owner, j = se(v.type, v._source, O ? O.type : null);
        To.setExtraStackFrame(j);
      } else
        To.setExtraStackFrame(null);
    }
    var Er;
    Er = !1;
    function Ar(v) {
      return typeof v == "object" && v !== null && v.$$typeof === t;
    }
    function $o() {
      {
        if (Pr.current) {
          var v = $(Pr.current.type);
          if (v)
            return `

Check the render method of \`` + v + "`.";
        }
        return "";
      }
    }
    function Xf(v) {
      return "";
    }
    var qo = {};
    function Jf(v) {
      {
        var O = $o();
        if (!O) {
          var j = typeof v == "string" ? v : v.displayName || v.name;
          j && (O = `

Check the top-level render call using <` + j + ">.");
        }
        return O;
      }
    }
    function jo(v, O) {
      {
        if (!v._store || v._store.validated || v.key != null)
          return;
        v._store.validated = !0;
        var j = Jf(O);
        if (qo[j])
          return;
        qo[j] = !0;
        var N = "";
        v && v._owner && v._owner !== Pr.current && (N = " It was passed a child from " + $(v._owner.type) + "."), tt(v), _('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', j, N), tt(null);
      }
    }
    function Io(v, O) {
      {
        if (typeof v != "object")
          return;
        if (Sr(v))
          for (var j = 0; j < v.length; j++) {
            var N = v[j];
            Ar(N) && jo(N, O);
          }
        else if (Ar(v))
          v._store && (v._store.validated = !0);
        else if (v) {
          var z = m(v);
          if (typeof z == "function" && z !== v.entries)
            for (var U = z.call(v), V; !(V = U.next()).done; )
              Ar(V.value) && jo(V.value, O);
        }
      }
    }
    function Zf(v) {
      {
        var O = v.type;
        if (O == null || typeof O == "string")
          return;
        var j;
        if (typeof O == "function")
          j = O.propTypes;
        else if (typeof O == "object" && (O.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        O.$$typeof === l))
          j = O.propTypes;
        else
          return;
        if (j) {
          var N = $(O);
          Rr(j, v.props, "prop", N, v);
        } else if (O.PropTypes !== void 0 && !Er) {
          Er = !0;
          var z = $(O);
          _("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", z || "Unknown");
        }
        typeof O.getDefaultProps == "function" && !O.getDefaultProps.isReactClassApproved && _("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Qf(v) {
      {
        for (var O = Object.keys(v.props), j = 0; j < O.length; j++) {
          var N = O[j];
          if (N !== "children" && N !== "key") {
            tt(v), _("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", N), tt(null);
            break;
          }
        }
        v.ref !== null && (tt(v), _("Invalid attribute `ref` supplied to `React.Fragment`."), tt(null));
      }
    }
    var Mo = {};
    function Do(v, O, j, N, z, U) {
      {
        var V = E(v);
        if (!V) {
          var B = "";
          (v === void 0 || typeof v == "object" && v !== null && Object.keys(v).length === 0) && (B += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ce = Xf();
          ce ? B += ce : B += $o();
          var J;
          v === null ? J = "null" : Sr(v) ? J = "array" : v !== void 0 && v.$$typeof === t ? (J = "<" + ($(v.type) || "Unknown") + " />", B = " Did you accidentally export a JSX literal instead of a component?") : J = typeof v, _("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", J, B);
        }
        var ee = Yf(v, O, j, z, U);
        if (ee == null)
          return ee;
        if (V) {
          var xe = O.children;
          if (xe !== void 0)
            if (N)
              if (Sr(xe)) {
                for (var rt = 0; rt < xe.length; rt++)
                  Io(xe[rt], v);
                Object.freeze && Object.freeze(xe);
              } else
                _("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Io(xe, v);
        }
        if (Ne.call(O, "key")) {
          var He = $(v), de = Object.keys(O).filter(function(id) {
            return id !== "key";
          }), Or = de.length > 0 ? "{key: someKey, " + de.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Mo[He + Or]) {
            var ad = de.length > 0 ? "{" + de.join(": ..., ") + ": ...}" : "{}";
            _(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Or, He, ad, He), Mo[He + Or] = !0;
          }
        }
        return v === n ? Qf(ee) : Zf(ee), ee;
      }
    }
    function ed(v, O, j) {
      return Do(v, O, j, !0);
    }
    function td(v, O, j) {
      return Do(v, O, j, !1);
    }
    var rd = td, nd = ed;
    gt.Fragment = n, gt.jsx = rd, gt.jsxs = nd;
  })()), gt;
}
var Bo;
function Nd() {
  return Bo || (Bo = 1, process.env.NODE_ENV === "production" ? Lt.exports = Dd() : Lt.exports = Fd()), Lt.exports;
}
var y = Nd();
function ye() {
  return ye = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ye.apply(this, arguments);
}
function ze(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(a) {
    if (e?.(a), r === !1 || !a.defaultPrevented) return t?.(a);
  };
}
function kd(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Ld(...e) {
  return (t) => e.forEach(
    (r) => kd(r, t)
  );
}
function $t(...e) {
  return G(Ld(...e), e);
}
function Bd(e, t = []) {
  let r = [];
  function n(i, o) {
    const s = /* @__PURE__ */ Ct(o), c = r.length;
    r = [
      ...r,
      o
    ];
    function u(l) {
      const { scope: h, children: f, ...g } = l, p = h?.[e][c] || s, m = K(
        () => g,
        Object.values(g)
      );
      return /* @__PURE__ */ H(p.Provider, {
        value: m
      }, f);
    }
    function d(l, h) {
      const f = h?.[e][c] || s, g = ro(f);
      if (g) return g;
      if (o !== void 0) return o;
      throw new Error(`\`${l}\` must be used within \`${i}\``);
    }
    return u.displayName = i + "Provider", [
      u,
      d
    ];
  }
  const a = () => {
    const i = r.map((o) => /* @__PURE__ */ Ct(o));
    return function(s) {
      const c = s?.[e] || i;
      return K(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: c
          }
        }),
        [
          s,
          c
        ]
      );
    };
  };
  return a.scopeName = e, [
    n,
    Vd(a, ...t)
  ];
}
function Vd(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map(
      (a) => ({
        useScope: a(),
        scopeName: a.scopeName
      })
    );
    return function(i) {
      const o = n.reduce((s, { useScope: c, scopeName: u }) => {
        const l = c(i)[`__scope${u}`];
        return {
          ...s,
          ...l
        };
      }, {});
      return K(
        () => ({
          [`__scope${t.scopeName}`]: o
        }),
        [
          o
        ]
      );
    };
  };
  return r.scopeName = t.scopeName, r;
}
function er() {
  return er = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, er.apply(this, arguments);
}
function Hd(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function zd(...e) {
  return (t) => e.forEach(
    (r) => Hd(r, t)
  );
}
const ur = /* @__PURE__ */ he((e, t) => {
  const { children: r, ...n } = e, a = ct.toArray(r), i = a.find(Wd);
  if (i) {
    const o = i.props.children, s = a.map((c) => c === i ? ct.count(o) > 1 ? ct.only(null) : /* @__PURE__ */ Qt(o) ? o.props.children : null : c);
    return /* @__PURE__ */ H(Wi, er({}, n, {
      ref: t
    }), /* @__PURE__ */ Qt(o) ? /* @__PURE__ */ cr(o, void 0, s) : null);
  }
  return /* @__PURE__ */ H(Wi, er({}, n, {
    ref: t
  }), r);
});
ur.displayName = "Slot";
const Wi = /* @__PURE__ */ he((e, t) => {
  const { children: r, ...n } = e;
  return /* @__PURE__ */ Qt(r) ? /* @__PURE__ */ cr(r, {
    ...Gd(n, r.props),
    ref: t ? zd(t, r.ref) : r.ref
  }) : ct.count(r) > 1 ? ct.only(null) : null;
});
Wi.displayName = "SlotClone";
const Ud = ({ children: e }) => /* @__PURE__ */ H(Rl, null, e);
function Wd(e) {
  return /* @__PURE__ */ Qt(e) && e.type === Ud;
}
function Gd(e, t) {
  const r = {
    ...t
  };
  for (const n in t) {
    const a = e[n], i = t[n];
    /^on[A-Z]/.test(n) ? a && i ? r[n] = (...s) => {
      i(...s), a(...s);
    } : a && (r[n] = a) : n === "style" ? r[n] = {
      ...a,
      ...i
    } : n === "className" && (r[n] = [
      a,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...r
  };
}
const Kd = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], lr = Kd.reduce((e, t) => {
  const r = /* @__PURE__ */ he((n, a) => {
    const { asChild: i, ...o } = n, s = i ? ur : t;
    return te(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ H(s, ye({}, o, {
      ref: a
    }));
  });
  return r.displayName = `Primitive.${t}`, {
    ...e,
    [t]: r
  };
}, {});
function Yd(e, t) {
  e && Al(
    () => e.dispatchEvent(t)
  );
}
function Ge(e) {
  const t = ne(e);
  return te(() => {
    t.current = e;
  }), K(
    () => (...r) => {
      var n;
      return (n = t.current) === null || n === void 0 ? void 0 : n.call(t, ...r);
    },
    []
  );
}
function Xd(e, t = globalThis?.document) {
  const r = Ge(e);
  te(() => {
    const n = (a) => {
      a.key === "Escape" && r(a);
    };
    return t.addEventListener("keydown", n), () => t.removeEventListener("keydown", n);
  }, [
    r,
    t
  ]);
}
const Gi = "dismissableLayer.update", Jd = "dismissableLayer.pointerDownOutside", Zd = "dismissableLayer.focusOutside";
let Vo;
const Qd = /* @__PURE__ */ Ct({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), eh = /* @__PURE__ */ he((e, t) => {
  var r;
  const { disableOutsidePointerEvents: n = !1, onEscapeKeyDown: a, onPointerDownOutside: i, onFocusOutside: o, onInteractOutside: s, onDismiss: c, ...u } = e, d = ro(Qd), [l, h] = Z(null), f = (r = l?.ownerDocument) !== null && r !== void 0 ? r : globalThis?.document, [, g] = Z({}), p = $t(
    t,
    (x) => h(x)
  ), m = Array.from(d.layers), [b] = [
    ...d.layersWithOutsidePointerEventsDisabled
  ].slice(-1), _ = m.indexOf(b), C = l ? m.indexOf(l) : -1, R = d.layersWithOutsidePointerEventsDisabled.size > 0, P = C >= _, A = th((x) => {
    const w = x.target, E = [
      ...d.branches
    ].some(
      (S) => S.contains(w)
    );
    !P || E || (i?.(x), s?.(x), x.defaultPrevented || c?.());
  }, f), T = rh((x) => {
    const w = x.target;
    [
      ...d.branches
    ].some(
      (S) => S.contains(w)
    ) || (o?.(x), s?.(x), x.defaultPrevented || c?.());
  }, f);
  return Xd((x) => {
    C === d.layers.size - 1 && (a?.(x), !x.defaultPrevented && c && (x.preventDefault(), c()));
  }, f), te(() => {
    if (l)
      return n && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (Vo = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(l)), d.layers.add(l), Ho(), () => {
        n && d.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = Vo);
      };
  }, [
    l,
    f,
    n,
    d
  ]), te(() => () => {
    l && (d.layers.delete(l), d.layersWithOutsidePointerEventsDisabled.delete(l), Ho());
  }, [
    l,
    d
  ]), te(() => {
    const x = () => g({});
    return document.addEventListener(Gi, x), () => document.removeEventListener(Gi, x);
  }, []), /* @__PURE__ */ H(lr.div, ye({}, u, {
    ref: p,
    style: {
      pointerEvents: R ? P ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: ze(e.onFocusCapture, T.onFocusCapture),
    onBlurCapture: ze(e.onBlurCapture, T.onBlurCapture),
    onPointerDownCapture: ze(e.onPointerDownCapture, A.onPointerDownCapture)
  }));
});
function th(e, t = globalThis?.document) {
  const r = Ge(e), n = ne(!1), a = ne(() => {
  });
  return te(() => {
    const i = (s) => {
      if (s.target && !n.current) {
        let u = function() {
          $l(Jd, r, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = u, t.addEventListener("click", a.current, {
          once: !0
        })) : u();
      } else
        t.removeEventListener("click", a.current);
      n.current = !1;
    }, o = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(o), t.removeEventListener("pointerdown", i), t.removeEventListener("click", a.current);
    };
  }, [
    t,
    r
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function rh(e, t = globalThis?.document) {
  const r = Ge(e), n = ne(!1);
  return te(() => {
    const a = (i) => {
      i.target && !n.current && $l(Zd, r, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [
    t,
    r
  ]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function Ho() {
  const e = new CustomEvent(Gi);
  document.dispatchEvent(e);
}
function $l(e, t, r, { discrete: n }) {
  const a = r.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: r
  });
  t && a.addEventListener(e, t, {
    once: !0
  }), n ? Yd(a, i) : a.dispatchEvent(i);
}
let $r = 0;
function nh() {
  te(() => {
    var e, t;
    const r = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = r[0]) !== null && e !== void 0 ? e : zo()), document.body.insertAdjacentElement("beforeend", (t = r[1]) !== null && t !== void 0 ? t : zo()), $r++, () => {
      $r === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (n) => n.remove()
      ), $r--;
    };
  }, []);
}
function zo() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const qr = "focusScope.autoFocusOnMount", jr = "focusScope.autoFocusOnUnmount", Uo = {
  bubbles: !1,
  cancelable: !0
}, ah = /* @__PURE__ */ he((e, t) => {
  const { loop: r = !1, trapped: n = !1, onMountAutoFocus: a, onUnmountAutoFocus: i, ...o } = e, [s, c] = Z(null), u = Ge(a), d = Ge(i), l = ne(null), h = $t(
    t,
    (p) => c(p)
  ), f = ne({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  te(() => {
    if (n) {
      let p = function(C) {
        if (f.paused || !s) return;
        const R = C.target;
        s.contains(R) ? l.current = R : ke(l.current, {
          select: !0
        });
      }, m = function(C) {
        if (f.paused || !s) return;
        const R = C.relatedTarget;
        R !== null && (s.contains(R) || ke(l.current, {
          select: !0
        }));
      }, b = function(C) {
        if (document.activeElement === document.body)
          for (const P of C) P.removedNodes.length > 0 && ke(s);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", m);
      const _ = new MutationObserver(b);
      return s && _.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", m), _.disconnect();
      };
    }
  }, [
    n,
    s,
    f.paused
  ]), te(() => {
    if (s) {
      Go.add(f);
      const p = document.activeElement;
      if (!s.contains(p)) {
        const b = new CustomEvent(qr, Uo);
        s.addEventListener(qr, u), s.dispatchEvent(b), b.defaultPrevented || (ih(lh(ql(s)), {
          select: !0
        }), document.activeElement === p && ke(s));
      }
      return () => {
        s.removeEventListener(qr, u), setTimeout(() => {
          const b = new CustomEvent(jr, Uo);
          s.addEventListener(jr, d), s.dispatchEvent(b), b.defaultPrevented || ke(p ?? document.body, {
            select: !0
          }), s.removeEventListener(jr, d), Go.remove(f);
        }, 0);
      };
    }
  }, [
    s,
    u,
    d,
    f
  ]);
  const g = G((p) => {
    if (!r && !n || f.paused) return;
    const m = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, b = document.activeElement;
    if (m && b) {
      const _ = p.currentTarget, [C, R] = oh(_);
      C && R ? !p.shiftKey && b === R ? (p.preventDefault(), r && ke(C, {
        select: !0
      })) : p.shiftKey && b === C && (p.preventDefault(), r && ke(R, {
        select: !0
      })) : b === _ && p.preventDefault();
    }
  }, [
    r,
    n,
    f.paused
  ]);
  return /* @__PURE__ */ H(lr.div, ye({
    tabIndex: -1
  }, o, {
    ref: h,
    onKeyDown: g
  }));
});
function ih(e, { select: t = !1 } = {}) {
  const r = document.activeElement;
  for (const n of e)
    if (ke(n, {
      select: t
    }), document.activeElement !== r) return;
}
function oh(e) {
  const t = ql(e), r = Wo(t, e), n = Wo(t.reverse(), e);
  return [
    r,
    n
  ];
}
function ql(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const a = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || a ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function Wo(e, t) {
  for (const r of e)
    if (!sh(r, {
      upTo: t
    })) return r;
}
function sh(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function ch(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function ke(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const r = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== r && ch(e) && t && e.select();
  }
}
const Go = uh();
function uh() {
  let e = [];
  return {
    add(t) {
      const r = e[0];
      t !== r && r?.pause(), e = Ko(e, t), e.unshift(t);
    },
    remove(t) {
      var r;
      e = Ko(e, t), (r = e[0]) === null || r === void 0 || r.resume();
    }
  };
}
function Ko(e, t) {
  const r = [
    ...e
  ], n = r.indexOf(t);
  return n !== -1 && r.splice(n, 1), r;
}
function lh(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const fh = globalThis?.document ? At : () => {
}, dh = D.useId || (() => {
});
let hh = 0;
function ph(e) {
  const [t, r] = D.useState(dh());
  return fh(() => {
    r(
      (n) => n ?? String(hh++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
function Rt() {
  return Rt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Rt.apply(this, arguments);
}
const vh = ["top", "right", "bottom", "left"], Le = Math.min, me = Math.max, tr = Math.round, Bt = Math.floor, Be = (e) => ({
  x: e,
  y: e
}), gh = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, mh = {
  start: "end",
  end: "start"
};
function Ki(e, t, r) {
  return me(e, Le(t, r));
}
function je(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ie(e) {
  return e.split("-")[0];
}
function dt(e) {
  return e.split("-")[1];
}
function io(e) {
  return e === "x" ? "y" : "x";
}
function oo(e) {
  return e === "y" ? "height" : "width";
}
function ht(e) {
  return ["top", "bottom"].includes(Ie(e)) ? "y" : "x";
}
function so(e) {
  return io(ht(e));
}
function bh(e, t, r) {
  r === void 0 && (r = !1);
  const n = dt(e), a = so(e), i = oo(a);
  let o = a === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (o = rr(o)), [o, rr(o)];
}
function yh(e) {
  const t = rr(e);
  return [Yi(e), t, Yi(t)];
}
function Yi(e) {
  return e.replace(/start|end/g, (t) => mh[t]);
}
function _h(e, t, r) {
  const n = ["left", "right"], a = ["right", "left"], i = ["top", "bottom"], o = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? a : n : t ? n : a;
    case "left":
    case "right":
      return t ? i : o;
    default:
      return [];
  }
}
function xh(e, t, r, n) {
  const a = dt(e);
  let i = _h(Ie(e), r === "start", n);
  return a && (i = i.map((o) => o + "-" + a), t && (i = i.concat(i.map(Yi)))), i;
}
function rr(e) {
  return e.replace(/left|right|bottom|top/g, (t) => gh[t]);
}
function wh(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function jl(e) {
  return typeof e != "number" ? wh(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function nr(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function Yo(e, t, r) {
  let {
    reference: n,
    floating: a
  } = e;
  const i = ht(t), o = so(t), s = oo(o), c = Ie(t), u = i === "y", d = n.x + n.width / 2 - a.width / 2, l = n.y + n.height / 2 - a.height / 2, h = n[s] / 2 - a[s] / 2;
  let f;
  switch (c) {
    case "top":
      f = {
        x: d,
        y: n.y - a.height
      };
      break;
    case "bottom":
      f = {
        x: d,
        y: n.y + n.height
      };
      break;
    case "right":
      f = {
        x: n.x + n.width,
        y: l
      };
      break;
    case "left":
      f = {
        x: n.x - a.width,
        y: l
      };
      break;
    default:
      f = {
        x: n.x,
        y: n.y
      };
  }
  switch (dt(t)) {
    case "start":
      f[o] -= h * (r && u ? -1 : 1);
      break;
    case "end":
      f[o] += h * (r && u ? -1 : 1);
      break;
  }
  return f;
}
const Ch = async (e, t, r) => {
  const {
    placement: n = "bottom",
    strategy: a = "absolute",
    middleware: i = [],
    platform: o
  } = r, s = i.filter(Boolean), c = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let u = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: a
  }), {
    x: d,
    y: l
  } = Yo(u, n, c), h = n, f = {}, g = 0;
  for (let p = 0; p < s.length; p++) {
    const {
      name: m,
      fn: b
    } = s[p], {
      x: _,
      y: C,
      data: R,
      reset: P
    } = await b({
      x: d,
      y: l,
      initialPlacement: n,
      placement: h,
      strategy: a,
      middlewareData: f,
      rects: u,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (d = _ ?? d, l = C ?? l, f = {
      ...f,
      [m]: {
        ...f[m],
        ...R
      }
    }, P && g <= 50) {
      g++, typeof P == "object" && (P.placement && (h = P.placement), P.rects && (u = P.rects === !0 ? await o.getElementRects({
        reference: e,
        floating: t,
        strategy: a
      }) : P.rects), {
        x: d,
        y: l
      } = Yo(u, h, c)), p = -1;
      continue;
    }
  }
  return {
    x: d,
    y: l,
    placement: h,
    strategy: a,
    middlewareData: f
  };
};
async function St(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: n,
    y: a,
    platform: i,
    rects: o,
    elements: s,
    strategy: c
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: l = "floating",
    altBoundary: h = !1,
    padding: f = 0
  } = je(t, e), g = jl(f), m = s[h ? l === "floating" ? "reference" : "floating" : l], b = nr(await i.getClippingRect({
    element: (r = await (i.isElement == null ? void 0 : i.isElement(m))) == null || r ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: d,
    strategy: c
  })), _ = l === "floating" ? {
    ...o.floating,
    x: n,
    y: a
  } : o.reference, C = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), R = await (i.isElement == null ? void 0 : i.isElement(C)) ? await (i.getScale == null ? void 0 : i.getScale(C)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, P = nr(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: _,
    offsetParent: C,
    strategy: c
  }) : _);
  return {
    top: (b.top - P.top + g.top) / R.y,
    bottom: (P.bottom - b.bottom + g.bottom) / R.y,
    left: (b.left - P.left + g.left) / R.x,
    right: (P.right - b.right + g.right) / R.x
  };
}
const Xo = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: n,
      placement: a,
      rects: i,
      platform: o,
      elements: s
    } = t, {
      element: c,
      padding: u = 0
    } = je(e, t) || {};
    if (c == null)
      return {};
    const d = jl(u), l = {
      x: r,
      y: n
    }, h = so(a), f = oo(h), g = await o.getDimensions(c), p = h === "y", m = p ? "top" : "left", b = p ? "bottom" : "right", _ = p ? "clientHeight" : "clientWidth", C = i.reference[f] + i.reference[h] - l[h] - i.floating[f], R = l[h] - i.reference[h], P = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(c));
    let A = P ? P[_] : 0;
    (!A || !await (o.isElement == null ? void 0 : o.isElement(P))) && (A = s.floating[_] || i.floating[f]);
    const T = C / 2 - R / 2, x = A / 2 - g[f] / 2 - 1, w = Le(d[m], x), E = Le(d[b], x), S = w, I = A - g[f] - E, $ = A / 2 - g[f] / 2 + T, M = Ki(S, $, I), q = dt(a) != null && $ != M && i.reference[f] / 2 - ($ < S ? w : E) - g[f] / 2 < 0 ? $ < S ? S - $ : I - $ : 0;
    return {
      [h]: l[h] - q,
      data: {
        [h]: M,
        centerOffset: $ - M + q
      }
    };
  }
}), Rh = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r;
      const {
        placement: n,
        middlewareData: a,
        rects: i,
        initialPlacement: o,
        platform: s,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: l,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: f = "none",
        flipAlignment: g = !0,
        ...p
      } = je(e, t), m = Ie(n), b = Ie(o) === o, _ = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), C = l || (b || !g ? [rr(o)] : yh(o));
      !l && f !== "none" && C.push(...xh(o, g, f, _));
      const R = [o, ...C], P = await St(t, p), A = [];
      let T = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (u && A.push(P[m]), d) {
        const S = bh(n, i, _);
        A.push(P[S[0]], P[S[1]]);
      }
      if (T = [...T, {
        placement: n,
        overflows: A
      }], !A.every((S) => S <= 0)) {
        var x, w;
        const S = (((x = a.flip) == null ? void 0 : x.index) || 0) + 1, I = R[S];
        if (I)
          return {
            data: {
              index: S,
              overflows: T
            },
            reset: {
              placement: I
            }
          };
        let $ = (w = T.filter((M) => M.overflows[0] <= 0).sort((M, F) => M.overflows[1] - F.overflows[1])[0]) == null ? void 0 : w.placement;
        if (!$)
          switch (h) {
            case "bestFit": {
              var E;
              const M = (E = T.map((F) => [F.placement, F.overflows.filter((q) => q > 0).reduce((q, k) => q + k, 0)]).sort((F, q) => F[1] - q[1])[0]) == null ? void 0 : E[0];
              M && ($ = M);
              break;
            }
            case "initialPlacement":
              $ = o;
              break;
          }
        if (n !== $)
          return {
            reset: {
              placement: $
            }
          };
      }
      return {};
    }
  };
};
function Jo(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Zo(e) {
  return vh.some((t) => e[t] >= 0);
}
const Sh = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: r
      } = t, {
        strategy: n = "referenceHidden",
        ...a
      } = je(e, t);
      switch (n) {
        case "referenceHidden": {
          const i = await St(t, {
            ...a,
            elementContext: "reference"
          }), o = Jo(i, r.reference);
          return {
            data: {
              referenceHiddenOffsets: o,
              referenceHidden: Zo(o)
            }
          };
        }
        case "escaped": {
          const i = await St(t, {
            ...a,
            altBoundary: !0
          }), o = Jo(i, r.floating);
          return {
            data: {
              escapedOffsets: o,
              escaped: Zo(o)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Ph(e, t) {
  const {
    placement: r,
    platform: n,
    elements: a
  } = e, i = await (n.isRTL == null ? void 0 : n.isRTL(a.floating)), o = Ie(r), s = dt(r), c = ht(r) === "y", u = ["left", "top"].includes(o) ? -1 : 1, d = i && c ? -1 : 1, l = je(t, e);
  let {
    mainAxis: h,
    crossAxis: f,
    alignmentAxis: g
  } = typeof l == "number" ? {
    mainAxis: l,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...l
  };
  return s && typeof g == "number" && (f = s === "end" ? g * -1 : g), c ? {
    x: f * d,
    y: h * u
  } : {
    x: h * u,
    y: f * d
  };
}
const Eh = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n
      } = t, a = await Ph(t, e);
      return {
        x: r + a.x,
        y: n + a.y,
        data: a
      };
    }
  };
}, Ah = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: a
      } = t, {
        mainAxis: i = !0,
        crossAxis: o = !1,
        limiter: s = {
          fn: (m) => {
            let {
              x: b,
              y: _
            } = m;
            return {
              x: b,
              y: _
            };
          }
        },
        ...c
      } = je(e, t), u = {
        x: r,
        y: n
      }, d = await St(t, c), l = ht(Ie(a)), h = io(l);
      let f = u[h], g = u[l];
      if (i) {
        const m = h === "y" ? "top" : "left", b = h === "y" ? "bottom" : "right", _ = f + d[m], C = f - d[b];
        f = Ki(_, f, C);
      }
      if (o) {
        const m = l === "y" ? "top" : "left", b = l === "y" ? "bottom" : "right", _ = g + d[m], C = g - d[b];
        g = Ki(_, g, C);
      }
      const p = s.fn({
        ...t,
        [h]: f,
        [l]: g
      });
      return {
        ...p,
        data: {
          x: p.x - r,
          y: p.y - n
        }
      };
    }
  };
}, Oh = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: r,
        y: n,
        placement: a,
        rects: i,
        middlewareData: o
      } = t, {
        offset: s = 0,
        mainAxis: c = !0,
        crossAxis: u = !0
      } = je(e, t), d = {
        x: r,
        y: n
      }, l = ht(a), h = io(l);
      let f = d[h], g = d[l];
      const p = je(s, t), m = typeof p == "number" ? {
        mainAxis: p,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...p
      };
      if (c) {
        const C = h === "y" ? "height" : "width", R = i.reference[h] - i.floating[C] + m.mainAxis, P = i.reference[h] + i.reference[C] - m.mainAxis;
        f < R ? f = R : f > P && (f = P);
      }
      if (u) {
        var b, _;
        const C = h === "y" ? "width" : "height", R = ["top", "left"].includes(Ie(a)), P = i.reference[l] - i.floating[C] + (R && ((b = o.offset) == null ? void 0 : b[l]) || 0) + (R ? 0 : m.crossAxis), A = i.reference[l] + i.reference[C] + (R ? 0 : ((_ = o.offset) == null ? void 0 : _[l]) || 0) - (R ? m.crossAxis : 0);
        g < P ? g = P : g > A && (g = A);
      }
      return {
        [h]: f,
        [l]: g
      };
    }
  };
}, Th = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: r,
        rects: n,
        platform: a,
        elements: i
      } = t, {
        apply: o = () => {
        },
        ...s
      } = je(e, t), c = await St(t, s), u = Ie(r), d = dt(r), l = ht(r) === "y", {
        width: h,
        height: f
      } = n.floating;
      let g, p;
      u === "top" || u === "bottom" ? (g = u, p = d === (await (a.isRTL == null ? void 0 : a.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (p = u, g = d === "end" ? "top" : "bottom");
      const m = f - c[g], b = h - c[p], _ = !t.middlewareData.shift;
      let C = m, R = b;
      if (l) {
        const A = h - c.left - c.right;
        R = d || _ ? Le(b, A) : A;
      } else {
        const A = f - c.top - c.bottom;
        C = d || _ ? Le(m, A) : A;
      }
      if (_ && !d) {
        const A = me(c.left, 0), T = me(c.right, 0), x = me(c.top, 0), w = me(c.bottom, 0);
        l ? R = h - 2 * (A !== 0 || T !== 0 ? A + T : me(c.left, c.right)) : C = f - 2 * (x !== 0 || w !== 0 ? x + w : me(c.top, c.bottom));
      }
      await o({
        ...t,
        availableWidth: R,
        availableHeight: C
      });
      const P = await a.getDimensions(i.floating);
      return h !== P.width || f !== P.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Ve(e) {
  return Il(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function be(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function De(e) {
  var t;
  return (t = (Il(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Il(e) {
  return e instanceof Node || e instanceof be(e).Node;
}
function Me(e) {
  return e instanceof Element || e instanceof be(e).Element;
}
function Ae(e) {
  return e instanceof HTMLElement || e instanceof be(e).HTMLElement;
}
function Qo(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof be(e).ShadowRoot;
}
function qt(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: n,
    display: a
  } = we(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !["inline", "contents"].includes(a);
}
function $h(e) {
  return ["table", "td", "th"].includes(Ve(e));
}
function co(e) {
  const t = uo(), r = we(e);
  return r.transform !== "none" || r.perspective !== "none" || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((n) => (r.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (r.contain || "").includes(n));
}
function qh(e) {
  let t = ft(e);
  for (; Ae(t) && !fr(t); ) {
    if (co(t))
      return t;
    t = ft(t);
  }
  return null;
}
function uo() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function fr(e) {
  return ["html", "body", "#document"].includes(Ve(e));
}
function we(e) {
  return be(e).getComputedStyle(e);
}
function dr(e) {
  return Me(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function ft(e) {
  if (Ve(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Qo(e) && e.host || // Fallback.
    De(e)
  );
  return Qo(t) ? t.host : t;
}
function Ml(e) {
  const t = ft(e);
  return fr(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ae(t) && qt(t) ? t : Ml(t);
}
function ar(e, t) {
  var r;
  t === void 0 && (t = []);
  const n = Ml(e), a = n === ((r = e.ownerDocument) == null ? void 0 : r.body), i = be(n);
  return a ? t.concat(i, i.visualViewport || [], qt(n) ? n : []) : t.concat(n, ar(n));
}
function Dl(e) {
  const t = we(e);
  let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const a = Ae(e), i = a ? e.offsetWidth : r, o = a ? e.offsetHeight : n, s = tr(r) !== i || tr(n) !== o;
  return s && (r = i, n = o), {
    width: r,
    height: n,
    $: s
  };
}
function lo(e) {
  return Me(e) ? e : e.contextElement;
}
function lt(e) {
  const t = lo(e);
  if (!Ae(t))
    return Be(1);
  const r = t.getBoundingClientRect(), {
    width: n,
    height: a,
    $: i
  } = Dl(t);
  let o = (i ? tr(r.width) : r.width) / n, s = (i ? tr(r.height) : r.height) / a;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
const jh = /* @__PURE__ */ Be(0);
function Fl(e) {
  const t = be(e);
  return !uo() || !t.visualViewport ? jh : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Ih(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== be(e) ? !1 : t;
}
function Ke(e, t, r, n) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const a = e.getBoundingClientRect(), i = lo(e);
  let o = Be(1);
  t && (n ? Me(n) && (o = lt(n)) : o = lt(e));
  const s = Ih(i, r, n) ? Fl(i) : Be(0);
  let c = (a.left + s.x) / o.x, u = (a.top + s.y) / o.y, d = a.width / o.x, l = a.height / o.y;
  if (i) {
    const h = be(i), f = n && Me(n) ? be(n) : n;
    let g = h.frameElement;
    for (; g && n && f !== h; ) {
      const p = lt(g), m = g.getBoundingClientRect(), b = we(g), _ = m.left + (g.clientLeft + parseFloat(b.paddingLeft)) * p.x, C = m.top + (g.clientTop + parseFloat(b.paddingTop)) * p.y;
      c *= p.x, u *= p.y, d *= p.x, l *= p.y, c += _, u += C, g = be(g).frameElement;
    }
  }
  return nr({
    width: d,
    height: l,
    x: c,
    y: u
  });
}
function Mh(e) {
  let {
    rect: t,
    offsetParent: r,
    strategy: n
  } = e;
  const a = Ae(r), i = De(r);
  if (r === i)
    return t;
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = Be(1);
  const c = Be(0);
  if ((a || !a && n !== "fixed") && ((Ve(r) !== "body" || qt(i)) && (o = dr(r)), Ae(r))) {
    const u = Ke(r);
    s = lt(r), c.x = u.x + r.clientLeft, c.y = u.y + r.clientTop;
  }
  return {
    width: t.width * s.x,
    height: t.height * s.y,
    x: t.x * s.x - o.scrollLeft * s.x + c.x,
    y: t.y * s.y - o.scrollTop * s.y + c.y
  };
}
function Dh(e) {
  return Array.from(e.getClientRects());
}
function Nl(e) {
  return Ke(De(e)).left + dr(e).scrollLeft;
}
function Fh(e) {
  const t = De(e), r = dr(e), n = e.ownerDocument.body, a = me(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), i = me(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let o = -r.scrollLeft + Nl(e);
  const s = -r.scrollTop;
  return we(n).direction === "rtl" && (o += me(t.clientWidth, n.clientWidth) - a), {
    width: a,
    height: i,
    x: o,
    y: s
  };
}
function Nh(e, t) {
  const r = be(e), n = De(e), a = r.visualViewport;
  let i = n.clientWidth, o = n.clientHeight, s = 0, c = 0;
  if (a) {
    i = a.width, o = a.height;
    const u = uo();
    (!u || u && t === "fixed") && (s = a.offsetLeft, c = a.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: s,
    y: c
  };
}
function kh(e, t) {
  const r = Ke(e, !0, t === "fixed"), n = r.top + e.clientTop, a = r.left + e.clientLeft, i = Ae(e) ? lt(e) : Be(1), o = e.clientWidth * i.x, s = e.clientHeight * i.y, c = a * i.x, u = n * i.y;
  return {
    width: o,
    height: s,
    x: c,
    y: u
  };
}
function es(e, t, r) {
  let n;
  if (t === "viewport")
    n = Nh(e, r);
  else if (t === "document")
    n = Fh(De(e));
  else if (Me(t))
    n = kh(t, r);
  else {
    const a = Fl(e);
    n = {
      ...t,
      x: t.x - a.x,
      y: t.y - a.y
    };
  }
  return nr(n);
}
function kl(e, t) {
  const r = ft(e);
  return r === t || !Me(r) || fr(r) ? !1 : we(r).position === "fixed" || kl(r, t);
}
function Lh(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let n = ar(e).filter((s) => Me(s) && Ve(s) !== "body"), a = null;
  const i = we(e).position === "fixed";
  let o = i ? ft(e) : e;
  for (; Me(o) && !fr(o); ) {
    const s = we(o), c = co(o);
    !c && s.position === "fixed" && (a = null), (i ? !c && !a : !c && s.position === "static" && !!a && ["absolute", "fixed"].includes(a.position) || qt(o) && !c && kl(e, o)) ? n = n.filter((d) => d !== o) : a = s, o = ft(o);
  }
  return t.set(e, n), n;
}
function Bh(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: n,
    strategy: a
  } = e;
  const o = [...r === "clippingAncestors" ? Lh(t, this._c) : [].concat(r), n], s = o[0], c = o.reduce((u, d) => {
    const l = es(t, d, a);
    return u.top = me(l.top, u.top), u.right = Le(l.right, u.right), u.bottom = Le(l.bottom, u.bottom), u.left = me(l.left, u.left), u;
  }, es(t, s, a));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function Vh(e) {
  return Dl(e);
}
function Hh(e, t, r) {
  const n = Ae(t), a = De(t), i = r === "fixed", o = Ke(e, !0, i, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = Be(0);
  if (n || !n && !i)
    if ((Ve(t) !== "body" || qt(a)) && (s = dr(t)), n) {
      const u = Ke(t, !0, i, t);
      c.x = u.x + t.clientLeft, c.y = u.y + t.clientTop;
    } else a && (c.x = Nl(a));
  return {
    x: o.left + s.scrollLeft - c.x,
    y: o.top + s.scrollTop - c.y,
    width: o.width,
    height: o.height
  };
}
function ts(e, t) {
  return !Ae(e) || we(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function Ll(e, t) {
  const r = be(e);
  if (!Ae(e))
    return r;
  let n = ts(e, t);
  for (; n && $h(n) && we(n).position === "static"; )
    n = ts(n, t);
  return n && (Ve(n) === "html" || Ve(n) === "body" && we(n).position === "static" && !co(n)) ? r : n || qh(e) || r;
}
const zh = async function(e) {
  let {
    reference: t,
    floating: r,
    strategy: n
  } = e;
  const a = this.getOffsetParent || Ll, i = this.getDimensions;
  return {
    reference: Hh(t, await a(r), n),
    floating: {
      x: 0,
      y: 0,
      ...await i(r)
    }
  };
};
function Uh(e) {
  return we(e).direction === "rtl";
}
const Wh = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Mh,
  getDocumentElement: De,
  getClippingRect: Bh,
  getOffsetParent: Ll,
  getElementRects: zh,
  getClientRects: Dh,
  getDimensions: Vh,
  getScale: lt,
  isElement: Me,
  isRTL: Uh
};
function Gh(e, t) {
  let r = null, n;
  const a = De(e);
  function i() {
    clearTimeout(n), r && r.disconnect(), r = null;
  }
  function o(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), i();
    const {
      left: u,
      top: d,
      width: l,
      height: h
    } = e.getBoundingClientRect();
    if (s || t(), !l || !h)
      return;
    const f = Bt(d), g = Bt(a.clientWidth - (u + l)), p = Bt(a.clientHeight - (d + h)), m = Bt(u), _ = {
      rootMargin: -f + "px " + -g + "px " + -p + "px " + -m + "px",
      threshold: me(0, Le(1, c)) || 1
    };
    let C = !0;
    function R(P) {
      const A = P[0].intersectionRatio;
      if (A !== c) {
        if (!C)
          return o();
        A ? o(!1, A) : n = setTimeout(() => {
          o(!1, 1e-7);
        }, 100);
      }
      C = !1;
    }
    try {
      r = new IntersectionObserver(R, {
        ..._,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(R, _);
    }
    r.observe(e);
  }
  return o(!0), i;
}
function Kh(e, t, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: i = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = n, u = lo(e), d = a || i ? [...u ? ar(u) : [], ...ar(t)] : [];
  d.forEach((b) => {
    a && b.addEventListener("scroll", r, {
      passive: !0
    }), i && b.addEventListener("resize", r);
  });
  const l = u && s ? Gh(u, r) : null;
  let h = -1, f = null;
  o && (f = new ResizeObserver((b) => {
    let [_] = b;
    _ && _.target === u && f && (f.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      f && f.observe(t);
    })), r();
  }), u && !c && f.observe(u), f.observe(t));
  let g, p = c ? Ke(e) : null;
  c && m();
  function m() {
    const b = Ke(e);
    p && (b.x !== p.x || b.y !== p.y || b.width !== p.width || b.height !== p.height) && r(), p = b, g = requestAnimationFrame(m);
  }
  return r(), () => {
    d.forEach((b) => {
      a && b.removeEventListener("scroll", r), i && b.removeEventListener("resize", r);
    }), l && l(), f && f.disconnect(), f = null, c && cancelAnimationFrame(g);
  };
}
const Yh = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), a = {
    platform: Wh,
    ...r
  }, i = {
    ...a.platform,
    _c: n
  };
  return Ch(e, t, {
    ...a,
    platform: i
  });
}, Xh = (e) => {
  function t(r) {
    return {}.hasOwnProperty.call(r, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(r) {
      const {
        element: n,
        padding: a
      } = typeof e == "function" ? e(r) : e;
      return n && t(n) ? n.current != null ? Xo({
        element: n.current,
        padding: a
      }).fn(r) : {} : n ? Xo({
        element: n,
        padding: a
      }).fn(r) : {};
    }
  };
};
var Yt = typeof document < "u" ? At : te;
function ir(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let r, n, a;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (r = e.length, r != t.length) return !1;
      for (n = r; n-- !== 0; )
        if (!ir(e[n], t[n]))
          return !1;
      return !0;
    }
    if (a = Object.keys(e), r = a.length, r !== Object.keys(t).length)
      return !1;
    for (n = r; n-- !== 0; )
      if (!{}.hasOwnProperty.call(t, a[n]))
        return !1;
    for (n = r; n-- !== 0; ) {
      const i = a[n];
      if (!(i === "_owner" && e.$$typeof) && !ir(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Bl(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function rs(e, t) {
  const r = Bl(e);
  return Math.round(t * r) / r;
}
function ns(e) {
  const t = D.useRef(e);
  return Yt(() => {
    t.current = e;
  }), t;
}
function Jh(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: r = "absolute",
    middleware: n = [],
    platform: a,
    elements: {
      reference: i,
      floating: o
    } = {},
    transform: s = !0,
    whileElementsMounted: c,
    open: u
  } = e, [d, l] = D.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [h, f] = D.useState(n);
  ir(h, n) || f(n);
  const [g, p] = D.useState(null), [m, b] = D.useState(null), _ = D.useCallback((q) => {
    q != A.current && (A.current = q, p(q));
  }, [p]), C = D.useCallback((q) => {
    q !== T.current && (T.current = q, b(q));
  }, [b]), R = i || g, P = o || m, A = D.useRef(null), T = D.useRef(null), x = D.useRef(d), w = ns(c), E = ns(a), S = D.useCallback(() => {
    if (!A.current || !T.current)
      return;
    const q = {
      placement: t,
      strategy: r,
      middleware: h
    };
    E.current && (q.platform = E.current), Yh(A.current, T.current, q).then((k) => {
      const L = {
        ...k,
        isPositioned: !0
      };
      I.current && !ir(x.current, L) && (x.current = L, fd.flushSync(() => {
        l(L);
      }));
    });
  }, [h, t, r, E]);
  Yt(() => {
    u === !1 && x.current.isPositioned && (x.current.isPositioned = !1, l((q) => ({
      ...q,
      isPositioned: !1
    })));
  }, [u]);
  const I = D.useRef(!1);
  Yt(() => (I.current = !0, () => {
    I.current = !1;
  }), []), Yt(() => {
    if (R && (A.current = R), P && (T.current = P), R && P) {
      if (w.current)
        return w.current(R, P, S);
      S();
    }
  }, [R, P, S, w]);
  const $ = D.useMemo(() => ({
    reference: A,
    floating: T,
    setReference: _,
    setFloating: C
  }), [_, C]), M = D.useMemo(() => ({
    reference: R,
    floating: P
  }), [R, P]), F = D.useMemo(() => {
    const q = {
      position: r,
      left: 0,
      top: 0
    };
    if (!M.floating)
      return q;
    const k = rs(M.floating, d.x), L = rs(M.floating, d.y);
    return s ? {
      ...q,
      transform: "translate(" + k + "px, " + L + "px)",
      ...Bl(M.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: k,
      top: L
    };
  }, [r, s, M.floating, d.x, d.y]);
  return D.useMemo(() => ({
    ...d,
    update: S,
    refs: $,
    elements: M,
    floatingStyles: F
  }), [d, S, $, M, F]);
}
const Zh = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Vl = Zh.reduce((e, t) => {
  const r = /* @__PURE__ */ he((n, a) => {
    const { asChild: i, ...o } = n, s = i ? ur : t;
    return te(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ H(s, Rt({}, o, {
      ref: a
    }));
  });
  return r.displayName = `Primitive.${t}`, {
    ...e,
    [t]: r
  };
}, {});
function Qh(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function ep(...e) {
  return (t) => e.forEach(
    (r) => Qh(r, t)
  );
}
function Hl(...e) {
  return G(ep(...e), e);
}
function tp(e, t = []) {
  let r = [];
  function n(i, o) {
    const s = /* @__PURE__ */ Ct(o), c = r.length;
    r = [
      ...r,
      o
    ];
    function u(l) {
      const { scope: h, children: f, ...g } = l, p = h?.[e][c] || s, m = K(
        () => g,
        Object.values(g)
      );
      return /* @__PURE__ */ H(p.Provider, {
        value: m
      }, f);
    }
    function d(l, h) {
      const f = h?.[e][c] || s, g = ro(f);
      if (g) return g;
      if (o !== void 0) return o;
      throw new Error(`\`${l}\` must be used within \`${i}\``);
    }
    return u.displayName = i + "Provider", [
      u,
      d
    ];
  }
  const a = () => {
    const i = r.map((o) => /* @__PURE__ */ Ct(o));
    return function(s) {
      const c = s?.[e] || i;
      return K(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: c
          }
        }),
        [
          s,
          c
        ]
      );
    };
  };
  return a.scopeName = e, [
    n,
    rp(a, ...t)
  ];
}
function rp(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map(
      (a) => ({
        useScope: a(),
        scopeName: a.scopeName
      })
    );
    return function(i) {
      const o = n.reduce((s, { useScope: c, scopeName: u }) => {
        const l = c(i)[`__scope${u}`];
        return {
          ...s,
          ...l
        };
      }, {});
      return K(
        () => ({
          [`__scope${t.scopeName}`]: o
        }),
        [
          o
        ]
      );
    };
  };
  return r.scopeName = t.scopeName, r;
}
function np(e) {
  const t = ne(e);
  return te(() => {
    t.current = e;
  }), K(
    () => (...r) => {
      var n;
      return (n = t.current) === null || n === void 0 ? void 0 : n.call(t, ...r);
    },
    []
  );
}
const Xi = globalThis?.document ? At : () => {
};
function ap(e) {
  const [t, r] = Z(void 0);
  return Xi(() => {
    if (e) {
      r({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const n = new ResizeObserver((a) => {
        if (!Array.isArray(a) || !a.length) return;
        const i = a[0];
        let o, s;
        if ("borderBoxSize" in i) {
          const c = i.borderBoxSize, u = Array.isArray(c) ? c[0] : c;
          o = u.inlineSize, s = u.blockSize;
        } else
          o = e.offsetWidth, s = e.offsetHeight;
        r({
          width: o,
          height: s
        });
      });
      return n.observe(e, {
        box: "border-box"
      }), () => n.unobserve(e);
    } else
      r(void 0);
  }, [
    e
  ]), t;
}
const zl = "Popper", [Ul, Wl] = tp(zl), [ip, Gl] = Ul(zl), op = (e) => {
  const { __scopePopper: t, children: r } = e, [n, a] = Z(null);
  return /* @__PURE__ */ H(ip, {
    scope: t,
    anchor: n,
    onAnchorChange: a
  }, r);
}, sp = "PopperAnchor", cp = /* @__PURE__ */ he((e, t) => {
  const { __scopePopper: r, virtualRef: n, ...a } = e, i = Gl(sp, r), o = ne(null), s = Hl(t, o);
  return te(() => {
    i.onAnchorChange(n?.current || o.current);
  }), n ? null : /* @__PURE__ */ H(Vl.div, Rt({}, a, {
    ref: s
  }));
}), Kl = "PopperContent", [up, Iy] = Ul(Kl), lp = /* @__PURE__ */ he((e, t) => {
  var r, n, a, i, o, s, c, u;
  const { __scopePopper: d, side: l = "bottom", sideOffset: h = 0, align: f = "center", alignOffset: g = 0, arrowPadding: p = 0, avoidCollisions: m = !0, collisionBoundary: b = [], collisionPadding: _ = 0, sticky: C = "partial", hideWhenDetached: R = !1, updatePositionStrategy: P = "optimized", onPlaced: A, ...T } = e, x = Gl(Kl, d), [w, E] = Z(null), S = Hl(
    t,
    (se) => E(se)
  ), [I, $] = Z(null), M = ap(I), F = (r = M?.width) !== null && r !== void 0 ? r : 0, q = (n = M?.height) !== null && n !== void 0 ? n : 0, k = l + (f !== "center" ? "-" + f : ""), L = typeof _ == "number" ? _ : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ..._
  }, Q = Array.isArray(b) ? b : [
    b
  ], ae = Q.length > 0, re = {
    padding: L,
    boundary: Q.filter(fp),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: ae
  }, { refs: pe, floatingStyles: oe, placement: ue, isPositioned: ve, middlewareData: X } = Jh({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: k,
    whileElementsMounted: (...se) => Kh(...se, {
      animationFrame: P === "always"
    }),
    elements: {
      reference: x.anchor
    },
    middleware: [
      Eh({
        mainAxis: h + q,
        alignmentAxis: g
      }),
      m && Ah({
        mainAxis: !0,
        crossAxis: !1,
        limiter: C === "partial" ? Oh() : void 0,
        ...re
      }),
      m && Rh({
        ...re
      }),
      Th({
        ...re,
        apply: ({ elements: se, rects: Ne, availableWidth: Ft, availableHeight: Nt }) => {
          const { width: Qe, height: Rr } = Ne.reference, et = se.floating.style;
          et.setProperty("--radix-popper-available-width", `${Ft}px`), et.setProperty("--radix-popper-available-height", `${Nt}px`), et.setProperty("--radix-popper-anchor-width", `${Qe}px`), et.setProperty("--radix-popper-anchor-height", `${Rr}px`);
        }
      }),
      I && Xh({
        element: I,
        padding: p
      }),
      dp({
        arrowWidth: F,
        arrowHeight: q
      }),
      R && Sh({
        strategy: "referenceHidden",
        ...re
      })
    ]
  }), [ge, le] = Yl(ue), ie = np(A);
  Xi(() => {
    ve && ie?.();
  }, [
    ve,
    ie
  ]);
  const _e = (a = X.arrow) === null || a === void 0 ? void 0 : a.x, Te = (i = X.arrow) === null || i === void 0 ? void 0 : i.y, Fe = ((o = X.arrow) === null || o === void 0 ? void 0 : o.centerOffset) !== 0, [fe, $e] = Z();
  return Xi(() => {
    w && $e(window.getComputedStyle(w).zIndex);
  }, [
    w
  ]), /* @__PURE__ */ H("div", {
    ref: pe.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...oe,
      transform: ve ? oe.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: fe,
      "--radix-popper-transform-origin": [
        (s = X.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (c = X.transformOrigin) === null || c === void 0 ? void 0 : c.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ H(up, {
    scope: d,
    placedSide: ge,
    onArrowChange: $,
    arrowX: _e,
    arrowY: Te,
    shouldHideArrow: Fe
  }, /* @__PURE__ */ H(Vl.div, Rt({
    "data-side": ge,
    "data-align": le
  }, T, {
    ref: S,
    style: {
      ...T.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: ve ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (u = X.hide) !== null && u !== void 0 && u.referenceHidden ? 0 : void 0
    }
  }))));
});
function fp(e) {
  return e !== null;
}
const dp = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var r, n, a, i, o;
    const { placement: s, rects: c, middlewareData: u } = t, l = ((r = u.arrow) === null || r === void 0 ? void 0 : r.centerOffset) !== 0, h = l ? 0 : e.arrowWidth, f = l ? 0 : e.arrowHeight, [g, p] = Yl(s), m = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[p], b = ((n = (a = u.arrow) === null || a === void 0 ? void 0 : a.x) !== null && n !== void 0 ? n : 0) + h / 2, _ = ((i = (o = u.arrow) === null || o === void 0 ? void 0 : o.y) !== null && i !== void 0 ? i : 0) + f / 2;
    let C = "", R = "";
    return g === "bottom" ? (C = l ? m : `${b}px`, R = `${-f}px`) : g === "top" ? (C = l ? m : `${b}px`, R = `${c.floating.height + f}px`) : g === "right" ? (C = `${-f}px`, R = l ? m : `${_}px`) : g === "left" && (C = `${c.floating.width + f}px`, R = l ? m : `${_}px`), {
      data: {
        x: C,
        y: R
      }
    };
  }
});
function Yl(e) {
  const [t, r = "center"] = e.split("-");
  return [
    t,
    r
  ];
}
const hp = op, pp = cp, vp = lp, gp = /* @__PURE__ */ he((e, t) => {
  var r;
  const { container: n = globalThis == null || (r = globalThis.document) === null || r === void 0 ? void 0 : r.body, ...a } = e;
  return n ? /* @__PURE__ */ dd.createPortal(/* @__PURE__ */ H(lr.div, ye({}, a, {
    ref: t
  })), n) : null;
}), as = globalThis?.document ? At : () => {
};
function mp(e, t) {
  return od((r, n) => {
    const a = t[r][n];
    return a ?? r;
  }, e);
}
const fo = (e) => {
  const { present: t, children: r } = e, n = bp(t), a = typeof r == "function" ? r({
    present: n.isPresent
  }) : ct.only(r), i = $t(n.ref, a.ref);
  return typeof r == "function" || n.isPresent ? /* @__PURE__ */ cr(a, {
    ref: i
  }) : null;
};
fo.displayName = "Presence";
function bp(e) {
  const [t, r] = Z(), n = ne({}), a = ne(e), i = ne("none"), o = e ? "mounted" : "unmounted", [s, c] = mp(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return te(() => {
    const u = Vt(n.current);
    i.current = s === "mounted" ? u : "none";
  }, [
    s
  ]), as(() => {
    const u = n.current, d = a.current;
    if (d !== e) {
      const h = i.current, f = Vt(u);
      e ? c("MOUNT") : f === "none" || u?.display === "none" ? c("UNMOUNT") : c(d && h !== f ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [
    e,
    c
  ]), as(() => {
    if (t) {
      const u = (l) => {
        const f = Vt(n.current).includes(l.animationName);
        l.target === t && f && Al(
          () => c("ANIMATION_END")
        );
      }, d = (l) => {
        l.target === t && (i.current = Vt(n.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: G((u) => {
      u && (n.current = getComputedStyle(u)), r(u);
    }, [])
  };
}
function Vt(e) {
  return e?.animationName || "none";
}
function yp({ prop: e, defaultProp: t, onChange: r = () => {
} }) {
  const [n, a] = _p({
    defaultProp: t,
    onChange: r
  }), i = e !== void 0, o = i ? e : n, s = Ge(r), c = G((u) => {
    if (i) {
      const l = typeof u == "function" ? u(e) : u;
      l !== e && s(l);
    } else a(u);
  }, [
    i,
    e,
    a,
    s
  ]);
  return [
    o,
    c
  ];
}
function _p({ defaultProp: e, onChange: t }) {
  const r = Z(e), [n] = r, a = ne(n), i = Ge(t);
  return te(() => {
    a.current !== n && (i(n), a.current = n);
  }, [
    n,
    a,
    i
  ]), r;
}
var xp = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, nt = /* @__PURE__ */ new WeakMap(), Ht = /* @__PURE__ */ new WeakMap(), zt = {}, Ir = 0, Xl = function(e) {
  return e && (e.host || Xl(e.parentNode));
}, wp = function(e, t) {
  return t.map(function(r) {
    if (e.contains(r))
      return r;
    var n = Xl(r);
    return n && e.contains(n) ? n : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, Cp = function(e, t, r, n) {
  var a = wp(t, Array.isArray(e) ? e : [e]);
  zt[r] || (zt[r] = /* @__PURE__ */ new WeakMap());
  var i = zt[r], o = [], s = /* @__PURE__ */ new Set(), c = new Set(a), u = function(l) {
    !l || s.has(l) || (s.add(l), u(l.parentNode));
  };
  a.forEach(u);
  var d = function(l) {
    !l || c.has(l) || Array.prototype.forEach.call(l.children, function(h) {
      if (s.has(h))
        d(h);
      else {
        var f = h.getAttribute(n), g = f !== null && f !== "false", p = (nt.get(h) || 0) + 1, m = (i.get(h) || 0) + 1;
        nt.set(h, p), i.set(h, m), o.push(h), p === 1 && g && Ht.set(h, !0), m === 1 && h.setAttribute(r, "true"), g || h.setAttribute(n, "true");
      }
    });
  };
  return d(t), s.clear(), Ir++, function() {
    o.forEach(function(l) {
      var h = nt.get(l) - 1, f = i.get(l) - 1;
      nt.set(l, h), i.set(l, f), h || (Ht.has(l) || l.removeAttribute(n), Ht.delete(l)), f || l.removeAttribute(r);
    }), Ir--, Ir || (nt = /* @__PURE__ */ new WeakMap(), nt = /* @__PURE__ */ new WeakMap(), Ht = /* @__PURE__ */ new WeakMap(), zt = {});
  };
}, Rp = function(e, t, r) {
  r === void 0 && (r = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), a = xp(e);
  return a ? (n.push.apply(n, Array.from(a.querySelectorAll("[aria-live]"))), Cp(n, a, r, "aria-hidden")) : function() {
    return null;
  };
}, Ee = function() {
  return Ee = Object.assign || function(t) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, Ee.apply(this, arguments);
};
function Jl(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
}
function Sp(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, i; n < a; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var Xt = "right-scroll-bar-position", Jt = "width-before-scroll-bar", Pp = "with-scroll-bars-hidden", Ep = "--removed-body-scroll-bar-size";
function Ap(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Op(e, t) {
  var r = Z(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(n) {
          var a = r.value;
          a !== n && (r.value = n, r.callback(n, a));
        }
      }
    };
  })[0];
  return r.callback = t, r.facade;
}
function Tp(e, t) {
  return Op(null, function(r) {
    return e.forEach(function(n) {
      return Ap(n, r);
    });
  });
}
function $p(e) {
  return e;
}
function qp(e, t) {
  t === void 0 && (t = $p);
  var r = [], n = !1, a = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : e;
    },
    useMedium: function(i) {
      var o = t(i, n);
      return r.push(o), function() {
        r = r.filter(function(s) {
          return s !== o;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (n = !0; r.length; ) {
        var o = r;
        r = [], o.forEach(i);
      }
      r = {
        push: function(s) {
          return i(s);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(i) {
      n = !0;
      var o = [];
      if (r.length) {
        var s = r;
        r = [], s.forEach(i), o = r;
      }
      var c = function() {
        var d = o;
        o = [], d.forEach(i);
      }, u = function() {
        return Promise.resolve().then(c);
      };
      u(), r = {
        push: function(d) {
          o.push(d), u();
        },
        filter: function(d) {
          return o = o.filter(d), r;
        }
      };
    }
  };
  return a;
}
function jp(e) {
  e === void 0 && (e = {});
  var t = qp(null);
  return t.options = Ee({ async: !0, ssr: !1 }, e), t;
}
var Zl = function(e) {
  var t = e.sideCar, r = Jl(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = t.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return D.createElement(n, Ee({}, r));
};
Zl.isSideCarExport = !0;
function Ip(e, t) {
  return e.useMedium(t), Zl;
}
var Ql = jp(), Mr = function() {
}, hr = D.forwardRef(function(e, t) {
  var r = D.useRef(null), n = D.useState({
    onScrollCapture: Mr,
    onWheelCapture: Mr,
    onTouchMoveCapture: Mr
  }), a = n[0], i = n[1], o = e.forwardProps, s = e.children, c = e.className, u = e.removeScrollBar, d = e.enabled, l = e.shards, h = e.sideCar, f = e.noIsolation, g = e.inert, p = e.allowPinchZoom, m = e.as, b = m === void 0 ? "div" : m, _ = Jl(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), C = h, R = Tp([r, t]), P = Ee(Ee({}, _), a);
  return D.createElement(
    D.Fragment,
    null,
    d && D.createElement(C, { sideCar: Ql, removeScrollBar: u, shards: l, noIsolation: f, inert: g, setCallbacks: i, allowPinchZoom: !!p, lockRef: r }),
    o ? D.cloneElement(D.Children.only(s), Ee(Ee({}, P), { ref: R })) : D.createElement(b, Ee({}, P, { className: c, ref: R }), s)
  );
});
hr.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
hr.classNames = {
  fullWidth: Jt,
  zeroRight: Xt
};
var Mp = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Dp() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Mp();
  return t && e.setAttribute("nonce", t), e;
}
function Fp(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Np(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var kp = function() {
  var e = 0, t = null;
  return {
    add: function(r) {
      e == 0 && (t = Dp()) && (Fp(t, r), Np(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Lp = function() {
  var e = kp();
  return function(t, r) {
    D.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && r]);
  };
}, ef = function() {
  var e = Lp(), t = function(r) {
    var n = r.styles, a = r.dynamic;
    return e(n, a), null;
  };
  return t;
}, Bp = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Dr = function(e) {
  return parseInt(e || "", 10) || 0;
}, Vp = function(e) {
  var t = window.getComputedStyle(document.body), r = t[e === "padding" ? "paddingLeft" : "marginLeft"], n = t[e === "padding" ? "paddingTop" : "marginTop"], a = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Dr(r), Dr(n), Dr(a)];
}, Hp = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Bp;
  var t = Vp(e), r = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, n - r + t[2] - t[0])
  };
}, zp = ef(), Up = function(e, t, r, n) {
  var a = e.left, i = e.top, o = e.right, s = e.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(Pp, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(s, "px ").concat(n, `;
  }
  body {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(n, ";"),
    r === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(o, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(n, `;
    `),
    r === "padding" && "padding-right: ".concat(s, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Xt, ` {
    right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(Jt, ` {
    margin-right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(Xt, " .").concat(Xt, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(Jt, " .").concat(Jt, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body {
    `).concat(Ep, ": ").concat(s, `px;
  }
`);
}, Wp = function(e) {
  var t = e.noRelative, r = e.noImportant, n = e.gapMode, a = n === void 0 ? "margin" : n, i = D.useMemo(function() {
    return Hp(a);
  }, [a]);
  return D.createElement(zp, { styles: Up(i, !t, a, r ? "" : "!important") });
}, Ji = !1;
if (typeof window < "u")
  try {
    var Ut = Object.defineProperty({}, "passive", {
      get: function() {
        return Ji = !0, !0;
      }
    });
    window.addEventListener("test", Ut, Ut), window.removeEventListener("test", Ut, Ut);
  } catch {
    Ji = !1;
  }
var at = Ji ? { passive: !1 } : !1, Gp = function(e) {
  return e.tagName === "TEXTAREA";
}, tf = function(e, t) {
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[t] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !Gp(e) && r[t] === "visible")
  );
}, Kp = function(e) {
  return tf(e, "overflowY");
}, Yp = function(e) {
  return tf(e, "overflowX");
}, is = function(e, t) {
  var r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var n = rf(e, r);
    if (n) {
      var a = nf(e, r), i = a[1], o = a[2];
      if (i > o)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== document.body);
  return !1;
}, Xp = function(e) {
  var t = e.scrollTop, r = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    r,
    n
  ];
}, Jp = function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    r,
    n
  ];
}, rf = function(e, t) {
  return e === "v" ? Kp(t) : Yp(t);
}, nf = function(e, t) {
  return e === "v" ? Xp(t) : Jp(t);
}, Zp = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Qp = function(e, t, r, n, a) {
  var i = Zp(e, window.getComputedStyle(t).direction), o = i * n, s = r.target, c = t.contains(s), u = !1, d = o > 0, l = 0, h = 0;
  do {
    var f = nf(e, s), g = f[0], p = f[1], m = f[2], b = p - m - i * g;
    (g || b) && rf(e, s) && (l += b, h += g), s = s.parentNode;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (d && l === 0 || !d && h === 0) && (u = !0), u;
}, Wt = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, os = function(e) {
  return [e.deltaX, e.deltaY];
}, ss = function(e) {
  return e && "current" in e ? e.current : e;
}, ev = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, tv = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, rv = 0, it = [];
function nv(e) {
  var t = D.useRef([]), r = D.useRef([0, 0]), n = D.useRef(), a = D.useState(rv++)[0], i = D.useState(function() {
    return ef();
  })[0], o = D.useRef(e);
  D.useEffect(function() {
    o.current = e;
  }, [e]), D.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var p = Sp([e.lockRef.current], (e.shards || []).map(ss), !0).filter(Boolean);
      return p.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), p.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = D.useCallback(function(p, m) {
    if ("touches" in p && p.touches.length === 2)
      return !o.current.allowPinchZoom;
    var b = Wt(p), _ = r.current, C = "deltaX" in p ? p.deltaX : _[0] - b[0], R = "deltaY" in p ? p.deltaY : _[1] - b[1], P, A = p.target, T = Math.abs(C) > Math.abs(R) ? "h" : "v";
    if ("touches" in p && T === "h" && A.type === "range")
      return !1;
    var x = is(T, A);
    if (!x)
      return !0;
    if (x ? P = T : (P = T === "v" ? "h" : "v", x = is(T, A)), !x)
      return !1;
    if (!n.current && "changedTouches" in p && (C || R) && (n.current = P), !P)
      return !0;
    var w = n.current || P;
    return Qp(w, m, p, w === "h" ? C : R);
  }, []), c = D.useCallback(function(p) {
    var m = p;
    if (!(!it.length || it[it.length - 1] !== i)) {
      var b = "deltaY" in m ? os(m) : Wt(m), _ = t.current.filter(function(P) {
        return P.name === m.type && P.target === m.target && ev(P.delta, b);
      })[0];
      if (_ && _.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!_) {
        var C = (o.current.shards || []).map(ss).filter(Boolean).filter(function(P) {
          return P.contains(m.target);
        }), R = C.length > 0 ? s(m, C[0]) : !o.current.noIsolation;
        R && m.cancelable && m.preventDefault();
      }
    }
  }, []), u = D.useCallback(function(p, m, b, _) {
    var C = { name: p, delta: m, target: b, should: _ };
    t.current.push(C), setTimeout(function() {
      t.current = t.current.filter(function(R) {
        return R !== C;
      });
    }, 1);
  }, []), d = D.useCallback(function(p) {
    r.current = Wt(p), n.current = void 0;
  }, []), l = D.useCallback(function(p) {
    u(p.type, os(p), p.target, s(p, e.lockRef.current));
  }, []), h = D.useCallback(function(p) {
    u(p.type, Wt(p), p.target, s(p, e.lockRef.current));
  }, []);
  D.useEffect(function() {
    return it.push(i), e.setCallbacks({
      onScrollCapture: l,
      onWheelCapture: l,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", c, at), document.addEventListener("touchmove", c, at), document.addEventListener("touchstart", d, at), function() {
      it = it.filter(function(p) {
        return p !== i;
      }), document.removeEventListener("wheel", c, at), document.removeEventListener("touchmove", c, at), document.removeEventListener("touchstart", d, at);
    };
  }, []);
  var f = e.removeScrollBar, g = e.inert;
  return D.createElement(
    D.Fragment,
    null,
    g ? D.createElement(i, { styles: tv(a) }) : null,
    f ? D.createElement(Wp, { gapMode: "margin" }) : null
  );
}
const av = Ip(Ql, nv);
var af = D.forwardRef(function(e, t) {
  return D.createElement(hr, Ee({}, e, { ref: t, sideCar: av }));
});
af.classNames = hr.classNames;
const of = "Popover", [sf, My] = Bd(of, [
  Wl
]), ho = Wl(), [iv, pt] = sf(of), ov = (e) => {
  const { __scopePopover: t, children: r, open: n, defaultOpen: a, onOpenChange: i, modal: o = !1 } = e, s = ho(t), c = ne(null), [u, d] = Z(!1), [l = !1, h] = yp({
    prop: n,
    defaultProp: a,
    onChange: i
  });
  return /* @__PURE__ */ H(hp, s, /* @__PURE__ */ H(iv, {
    scope: t,
    contentId: ph(),
    triggerRef: c,
    open: l,
    onOpenChange: h,
    onOpenToggle: G(
      () => h(
        (f) => !f
      ),
      [
        h
      ]
    ),
    hasCustomAnchor: u,
    onCustomAnchorAdd: G(
      () => d(!0),
      []
    ),
    onCustomAnchorRemove: G(
      () => d(!1),
      []
    ),
    modal: o
  }, r));
}, sv = "PopoverTrigger", cv = /* @__PURE__ */ he((e, t) => {
  const { __scopePopover: r, ...n } = e, a = pt(sv, r), i = ho(r), o = $t(t, a.triggerRef), s = /* @__PURE__ */ H(lr.button, ye({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": a.open,
    "aria-controls": a.contentId,
    "data-state": lf(a.open)
  }, n, {
    ref: o,
    onClick: ze(e.onClick, a.onOpenToggle)
  }));
  return a.hasCustomAnchor ? s : /* @__PURE__ */ H(pp, ye({
    asChild: !0
  }, i), s);
}), cf = "PopoverPortal", [uv, lv] = sf(cf, {
  forceMount: void 0
}), fv = (e) => {
  const { __scopePopover: t, forceMount: r, children: n, container: a } = e, i = pt(cf, t);
  return /* @__PURE__ */ H(uv, {
    scope: t,
    forceMount: r
  }, /* @__PURE__ */ H(fo, {
    present: r || i.open
  }, /* @__PURE__ */ H(gp, {
    asChild: !0,
    container: a
  }, n)));
}, Pt = "PopoverContent", dv = /* @__PURE__ */ he((e, t) => {
  const r = lv(Pt, e.__scopePopover), { forceMount: n = r.forceMount, ...a } = e, i = pt(Pt, e.__scopePopover);
  return /* @__PURE__ */ H(fo, {
    present: n || i.open
  }, i.modal ? /* @__PURE__ */ H(hv, ye({}, a, {
    ref: t
  })) : /* @__PURE__ */ H(pv, ye({}, a, {
    ref: t
  })));
}), hv = /* @__PURE__ */ he((e, t) => {
  const r = pt(Pt, e.__scopePopover), n = ne(null), a = $t(t, n), i = ne(!1);
  return te(() => {
    const o = n.current;
    if (o) return Rp(o);
  }, []), /* @__PURE__ */ H(af, {
    as: ur,
    allowPinchZoom: !0
  }, /* @__PURE__ */ H(uf, ye({}, e, {
    ref: a,
    trapFocus: r.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: ze(e.onCloseAutoFocus, (o) => {
      var s;
      o.preventDefault(), i.current || (s = r.triggerRef.current) === null || s === void 0 || s.focus();
    }),
    onPointerDownOutside: ze(e.onPointerDownOutside, (o) => {
      const s = o.detail.originalEvent, c = s.button === 0 && s.ctrlKey === !0, u = s.button === 2 || c;
      i.current = u;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: ze(
      e.onFocusOutside,
      (o) => o.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), pv = /* @__PURE__ */ he((e, t) => {
  const r = pt(Pt, e.__scopePopover), n = ne(!1), a = ne(!1);
  return /* @__PURE__ */ H(uf, ye({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (i) => {
      var o;
      if ((o = e.onCloseAutoFocus) === null || o === void 0 || o.call(e, i), !i.defaultPrevented) {
        var s;
        n.current || (s = r.triggerRef.current) === null || s === void 0 || s.focus(), i.preventDefault();
      }
      n.current = !1, a.current = !1;
    },
    onInteractOutside: (i) => {
      var o, s;
      (o = e.onInteractOutside) === null || o === void 0 || o.call(e, i), i.defaultPrevented || (n.current = !0, i.detail.originalEvent.type === "pointerdown" && (a.current = !0));
      const c = i.target;
      ((s = r.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(c)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && a.current && i.preventDefault();
    }
  }));
}), uf = /* @__PURE__ */ he((e, t) => {
  const { __scopePopover: r, trapFocus: n, onOpenAutoFocus: a, onCloseAutoFocus: i, disableOutsidePointerEvents: o, onEscapeKeyDown: s, onPointerDownOutside: c, onFocusOutside: u, onInteractOutside: d, ...l } = e, h = pt(Pt, r), f = ho(r);
  return nh(), /* @__PURE__ */ H(ah, {
    asChild: !0,
    loop: !0,
    trapped: n,
    onMountAutoFocus: a,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ H(eh, {
    asChild: !0,
    disableOutsidePointerEvents: o,
    onInteractOutside: d,
    onEscapeKeyDown: s,
    onPointerDownOutside: c,
    onFocusOutside: u,
    onDismiss: () => h.onOpenChange(!1)
  }, /* @__PURE__ */ H(vp, ye({
    "data-state": lf(h.open),
    role: "dialog",
    id: h.contentId
  }, f, l, {
    ref: t,
    style: {
      ...l.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
});
function lf(e) {
  return e ? "open" : "closed";
}
const ff = ov, df = cv, hf = fv, pf = dv, vv = "_tooltip_5svgn_1", gv = "_popover_5svgn_5", cs = {
  tooltip: vv,
  popover: gv
}, Dy = ({
  actions: e,
  buttonProps: { onClick: t, ...r } = {},
  side: n = "bottom",
  align: a = "end"
}) => {
  const [i, o] = Z(!1), s = G(
    (u) => {
      u.stopPropagation(), t?.(u);
    },
    [t]
  );
  if (!e.length) return null;
  const c = (u, d) => {
    switch (u.type) {
      case "button":
      case "link": {
        const l = /* @__PURE__ */ y.jsx(
          Tr.Item,
          {
            icon: u.icon,
            onClick: (h) => {
              u.onClick?.(h), o(!1);
            },
            isDisabled: u.disabled ?? !1,
            children: /* @__PURE__ */ y.jsxs(
              Y,
              {
                as: "span",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "2px",
                children: [
                  /* @__PURE__ */ y.jsx("span", { children: u.label }),
                  u.description && /* @__PURE__ */ y.jsx(W.Paragraph, { as: "span", variant: "4", subdued: !0, children: u.description })
                ]
              }
            )
          }
        );
        return /* @__PURE__ */ y.jsx(
          Ot,
          {
            className: cs.tooltip,
            content: u.tooltip,
            children: u.type === "link" ? cr(u.link, {
              children: l
            }) : l
          },
          d
        );
      }
      case "divider":
        return /* @__PURE__ */ y.jsx(Tr.Divider, {}, d);
      default:
        return null;
    }
  };
  return /* @__PURE__ */ y.jsxs(ff, { open: i, onOpenChange: o, children: [
    /* @__PURE__ */ y.jsx(df, { asChild: !0, children: /* @__PURE__ */ y.jsx(
      no,
      {
        variant: "tertiary",
        icon: "dots-v",
        onClick: s,
        ...r
      }
    ) }),
    /* @__PURE__ */ y.jsx(hf, { children: /* @__PURE__ */ y.jsx(
      pf,
      {
        className: cs.popover,
        side: n,
        align: a,
        sideOffset: 8,
        onOpenAutoFocus: (u) => u.preventDefault(),
        children: /* @__PURE__ */ y.jsx(Tr, { children: e.map((u, d) => c(u, d)) })
      }
    ) })
  ] });
};
var mt = {}, Zi = function() {
  return (Zi = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) for (var a in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    return e;
  }).apply(this, arguments);
}, mv = (function() {
  function e(t, r, n) {
    var a = this;
    this.endVal = r, this.options = n, this.version = "2.6.0", this.defaults = { startVal: 0, decimalPlaces: 0, duration: 2, useEasing: !0, useGrouping: !0, useIndianSeparators: !1, smartEasingThreshold: 999, smartEasingAmount: 333, separator: ",", decimal: ".", prefix: "", suffix: "", enableScrollSpy: !1, scrollSpyDelay: 200, scrollSpyOnce: !1 }, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.once = !1, this.count = function(i) {
      a.startTime || (a.startTime = i);
      var o = i - a.startTime;
      a.remaining = a.duration - o, a.useEasing ? a.countDown ? a.frameVal = a.startVal - a.easingFn(o, 0, a.startVal - a.endVal, a.duration) : a.frameVal = a.easingFn(o, a.startVal, a.endVal - a.startVal, a.duration) : a.frameVal = a.startVal + (a.endVal - a.startVal) * (o / a.duration);
      var s = a.countDown ? a.frameVal < a.endVal : a.frameVal > a.endVal;
      a.frameVal = s ? a.endVal : a.frameVal, a.frameVal = Number(a.frameVal.toFixed(a.options.decimalPlaces)), a.printValue(a.frameVal), o < a.duration ? a.rAF = requestAnimationFrame(a.count) : a.finalEndVal !== null ? a.update(a.finalEndVal) : a.options.onCompleteCallback && a.options.onCompleteCallback();
    }, this.formatNumber = function(i) {
      var o, s, c, u, d = i < 0 ? "-" : "";
      o = Math.abs(i).toFixed(a.options.decimalPlaces);
      var l = (o += "").split(".");
      if (s = l[0], c = l.length > 1 ? a.options.decimal + l[1] : "", a.options.useGrouping) {
        u = "";
        for (var h = 3, f = 0, g = 0, p = s.length; g < p; ++g) a.options.useIndianSeparators && g === 4 && (h = 2, f = 1), g !== 0 && f % h == 0 && (u = a.options.separator + u), f++, u = s[p - g - 1] + u;
        s = u;
      }
      return a.options.numerals && a.options.numerals.length && (s = s.replace(/[0-9]/g, function(m) {
        return a.options.numerals[+m];
      }), c = c.replace(/[0-9]/g, function(m) {
        return a.options.numerals[+m];
      })), d + a.options.prefix + s + c + a.options.suffix;
    }, this.easeOutExpo = function(i, o, s, c) {
      return s * (1 - Math.pow(2, -10 * i / c)) * 1024 / 1023 + o;
    }, this.options = Zi(Zi({}, this.defaults), n), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(r), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, this.options.separator === "" && (this.options.useGrouping = !1), this.el = typeof t == "string" ? document.getElementById(t) : t, this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", typeof window < "u" && this.options.enableScrollSpy && (this.error ? console.error(this.error, t) : (window.onScrollFns = window.onScrollFns || [], window.onScrollFns.push(function() {
      return a.handleScroll(a);
    }), window.onscroll = function() {
      window.onScrollFns.forEach(function(i) {
        return i();
      });
    }, this.handleScroll(this)));
  }
  return e.prototype.handleScroll = function(t) {
    if (t && window && !t.once) {
      var r = window.innerHeight + window.scrollY, n = t.el.getBoundingClientRect(), a = n.top + window.pageYOffset, i = n.top + n.height + window.pageYOffset;
      i < r && i > window.scrollY && t.paused ? (t.paused = !1, setTimeout(function() {
        return t.start();
      }, t.options.scrollSpyDelay), t.options.scrollSpyOnce && (t.once = !0)) : (window.scrollY > i || a > r) && !t.paused && t.reset();
    }
  }, e.prototype.determineDirectionAndSmartEasing = function() {
    var t = this.finalEndVal ? this.finalEndVal : this.endVal;
    this.countDown = this.startVal > t;
    var r = t - this.startVal;
    if (Math.abs(r) > this.options.smartEasingThreshold && this.options.useEasing) {
      this.finalEndVal = t;
      var n = this.countDown ? 1 : -1;
      this.endVal = t + n * this.options.smartEasingAmount, this.duration = this.duration / 2;
    } else this.endVal = t, this.finalEndVal = null;
    this.finalEndVal !== null ? this.useEasing = !1 : this.useEasing = this.options.useEasing;
  }, e.prototype.start = function(t) {
    this.error || (t && (this.options.onCompleteCallback = t), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
  }, e.prototype.pauseResume = function() {
    this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
  }, e.prototype.reset = function() {
    cancelAnimationFrame(this.rAF), this.paused = !0, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
  }, e.prototype.update = function(t) {
    cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(t), this.endVal !== this.frameVal && (this.startVal = this.frameVal, this.finalEndVal == null && this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
  }, e.prototype.printValue = function(t) {
    var r;
    if (this.el) {
      var n = this.formattingFn(t);
      (r = this.options.plugin) !== null && r !== void 0 && r.render ? this.options.plugin.render(this.el, n) : this.el.tagName === "INPUT" ? this.el.value = n : this.el.tagName === "text" || this.el.tagName === "tspan" ? this.el.textContent = n : this.el.innerHTML = n;
    }
  }, e.prototype.ensureNumber = function(t) {
    return typeof t == "number" && !isNaN(t);
  }, e.prototype.validateValue = function(t) {
    var r = Number(t);
    return this.ensureNumber(r) ? r : (this.error = "[CountUp] invalid start or end value: ".concat(t), null);
  }, e.prototype.resetDuration = function() {
    this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
  }, e;
})();
const bv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CountUp: mv
}, Symbol.toStringTag, { value: "Module" })), yv = /* @__PURE__ */ Md(bv);
var us;
function _v() {
  if (us) return mt;
  us = 1, Object.defineProperty(mt, "__esModule", { value: !0 });
  var e = to, t = yv;
  function r(x, w) {
    var E = x == null ? null : typeof Symbol < "u" && x[Symbol.iterator] || x["@@iterator"];
    if (E != null) {
      var S, I, $, M, F = [], q = !0, k = !1;
      try {
        if ($ = (E = E.call(x)).next, w !== 0) for (; !(q = (S = $.call(E)).done) && (F.push(S.value), F.length !== w); q = !0) ;
      } catch (L) {
        k = !0, I = L;
      } finally {
        try {
          if (!q && E.return != null && (M = E.return(), Object(M) !== M)) return;
        } finally {
          if (k) throw I;
        }
      }
      return F;
    }
  }
  function n(x, w) {
    var E = Object.keys(x);
    if (Object.getOwnPropertySymbols) {
      var S = Object.getOwnPropertySymbols(x);
      w && (S = S.filter(function(I) {
        return Object.getOwnPropertyDescriptor(x, I).enumerable;
      })), E.push.apply(E, S);
    }
    return E;
  }
  function a(x) {
    for (var w = 1; w < arguments.length; w++) {
      var E = arguments[w] != null ? arguments[w] : {};
      w % 2 ? n(Object(E), !0).forEach(function(S) {
        i(x, S, E[S]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(x, Object.getOwnPropertyDescriptors(E)) : n(Object(E)).forEach(function(S) {
        Object.defineProperty(x, S, Object.getOwnPropertyDescriptor(E, S));
      });
    }
    return x;
  }
  function i(x, w, E) {
    return w = p(w), w in x ? Object.defineProperty(x, w, {
      value: E,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : x[w] = E, x;
  }
  function o() {
    return o = Object.assign ? Object.assign.bind() : function(x) {
      for (var w = 1; w < arguments.length; w++) {
        var E = arguments[w];
        for (var S in E)
          Object.prototype.hasOwnProperty.call(E, S) && (x[S] = E[S]);
      }
      return x;
    }, o.apply(this, arguments);
  }
  function s(x, w) {
    if (x == null) return {};
    var E = {}, S = Object.keys(x), I, $;
    for ($ = 0; $ < S.length; $++)
      I = S[$], !(w.indexOf(I) >= 0) && (E[I] = x[I]);
    return E;
  }
  function c(x, w) {
    if (x == null) return {};
    var E = s(x, w), S, I;
    if (Object.getOwnPropertySymbols) {
      var $ = Object.getOwnPropertySymbols(x);
      for (I = 0; I < $.length; I++)
        S = $[I], !(w.indexOf(S) >= 0) && Object.prototype.propertyIsEnumerable.call(x, S) && (E[S] = x[S]);
    }
    return E;
  }
  function u(x, w) {
    return d(x) || r(x, w) || l(x, w) || f();
  }
  function d(x) {
    if (Array.isArray(x)) return x;
  }
  function l(x, w) {
    if (x) {
      if (typeof x == "string") return h(x, w);
      var E = Object.prototype.toString.call(x).slice(8, -1);
      if (E === "Object" && x.constructor && (E = x.constructor.name), E === "Map" || E === "Set") return Array.from(x);
      if (E === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(E)) return h(x, w);
    }
  }
  function h(x, w) {
    (w == null || w > x.length) && (w = x.length);
    for (var E = 0, S = new Array(w); E < w; E++) S[E] = x[E];
    return S;
  }
  function f() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function g(x, w) {
    if (typeof x != "object" || x === null) return x;
    var E = x[Symbol.toPrimitive];
    if (E !== void 0) {
      var S = E.call(x, w);
      if (typeof S != "object") return S;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (w === "string" ? String : Number)(x);
  }
  function p(x) {
    var w = g(x, "string");
    return typeof w == "symbol" ? w : String(w);
  }
  var m = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? e.useLayoutEffect : e.useEffect;
  function b(x) {
    var w = e.useRef(x);
    return m(function() {
      w.current = x;
    }), e.useCallback(function() {
      for (var E = arguments.length, S = new Array(E), I = 0; I < E; I++)
        S[I] = arguments[I];
      return w.current.apply(void 0, S);
    }, []);
  }
  var _ = function(w, E) {
    var S = E.decimal, I = E.decimals, $ = E.duration, M = E.easingFn, F = E.end, q = E.formattingFn, k = E.numerals, L = E.prefix, Q = E.separator, ae = E.start, re = E.suffix, pe = E.useEasing, oe = E.useGrouping, ue = E.useIndianSeparators, ve = E.enableScrollSpy, X = E.scrollSpyDelay, ge = E.scrollSpyOnce;
    return new t.CountUp(w, F, {
      startVal: ae,
      duration: $,
      decimal: S,
      decimalPlaces: I,
      easingFn: M,
      formattingFn: q,
      numerals: k,
      separator: Q,
      prefix: L,
      suffix: re,
      useEasing: pe,
      useIndianSeparators: ue,
      useGrouping: oe,
      enableScrollSpy: ve,
      scrollSpyDelay: X,
      scrollSpyOnce: ge
    });
  }, C = ["ref", "startOnMount", "enableReinitialize", "delay", "onEnd", "onStart", "onPauseResume", "onReset", "onUpdate"], R = {
    decimal: ".",
    separator: ",",
    delay: null,
    prefix: "",
    suffix: "",
    duration: 2,
    start: 0,
    decimals: 0,
    startOnMount: !0,
    enableReinitialize: !0,
    useEasing: !0,
    useGrouping: !0,
    useIndianSeparators: !1
  }, P = function(w) {
    var E = Object.fromEntries(Object.entries(w).filter(function(fe) {
      var $e = u(fe, 2), se = $e[1];
      return se !== void 0;
    })), S = e.useMemo(function() {
      return a(a({}, R), E);
    }, [w]), I = S.ref, $ = S.startOnMount, M = S.enableReinitialize, F = S.delay, q = S.onEnd, k = S.onStart, L = S.onPauseResume, Q = S.onReset, ae = S.onUpdate, re = c(S, C), pe = e.useRef(), oe = e.useRef(), ue = e.useRef(!1), ve = b(function() {
      return _(typeof I == "string" ? I : I.current, re);
    }), X = b(function(fe) {
      var $e = pe.current;
      if ($e && !fe)
        return $e;
      var se = ve();
      return pe.current = se, se;
    }), ge = b(function() {
      var fe = function() {
        return X(!0).start(function() {
          q?.({
            pauseResume: le,
            reset: ie,
            start: Te,
            update: _e
          });
        });
      };
      F && F > 0 ? oe.current = setTimeout(fe, F * 1e3) : fe(), k?.({
        pauseResume: le,
        reset: ie,
        update: _e
      });
    }), le = b(function() {
      X().pauseResume(), L?.({
        reset: ie,
        start: Te,
        update: _e
      });
    }), ie = b(function() {
      X().el && (oe.current && clearTimeout(oe.current), X().reset(), Q?.({
        pauseResume: le,
        start: Te,
        update: _e
      }));
    }), _e = b(function(fe) {
      X().update(fe), ae?.({
        pauseResume: le,
        reset: ie,
        start: Te
      });
    }), Te = b(function() {
      ie(), ge();
    }), Fe = b(function(fe) {
      $ && (fe && ie(), ge());
    });
    return e.useEffect(function() {
      ue.current ? M && Fe(!0) : (ue.current = !0, Fe());
    }, [M, ue, Fe, F, w.start, w.suffix, w.prefix, w.duration, w.separator, w.decimals, w.decimal, w.formattingFn]), e.useEffect(function() {
      return function() {
        ie();
      };
    }, [ie]), {
      start: Te,
      pauseResume: le,
      reset: ie,
      update: _e,
      getCountUp: X
    };
  }, A = ["className", "redraw", "containerProps", "children", "style"], T = function(w) {
    var E = w.className, S = w.redraw, I = w.containerProps, $ = w.children, M = w.style, F = c(w, A), q = e.useRef(null), k = e.useRef(!1), L = P(a(a({}, F), {}, {
      ref: q,
      startOnMount: typeof $ != "function" || w.delay === 0,
      // component manually restarts
      enableReinitialize: !1
    })), Q = L.start, ae = L.reset, re = L.update, pe = L.pauseResume, oe = L.getCountUp, ue = b(function() {
      Q();
    }), ve = b(function(le) {
      w.preserveValue || ae(), re(le);
    }), X = b(function() {
      if (typeof w.children == "function" && !(q.current instanceof Element)) {
        console.error(`Couldn't find attached element to hook the CountUp instance into! Try to attach "containerRef" from the render prop to a an Element, eg. <span ref={containerRef} />.`);
        return;
      }
      oe();
    });
    e.useEffect(function() {
      X();
    }, [X]), e.useEffect(function() {
      k.current && ve(w.end);
    }, [w.end, ve]);
    var ge = S && w;
    return e.useEffect(function() {
      S && k.current && ue();
    }, [ue, S, ge]), e.useEffect(function() {
      !S && k.current && ue();
    }, [ue, S, w.start, w.suffix, w.prefix, w.duration, w.separator, w.decimals, w.decimal, w.className, w.formattingFn]), e.useEffect(function() {
      k.current = !0;
    }, []), typeof $ == "function" ? $({
      countUpRef: q,
      start: Q,
      reset: ae,
      update: re,
      pauseResume: pe,
      getCountUp: oe
    }) : /* @__PURE__ */ e.createElement("span", o({
      className: E,
      ref: q,
      style: M
    }, I), typeof w.start < "u" ? oe().formattingFn(w.start) : "");
  };
  return mt.default = T, mt.useCountUp = P, mt;
}
var xv = _v();
const wv = /* @__PURE__ */ Se(xv), Cv = "_bar_1n5dj_1", Rv = "_section_1n5dj_5", Sv = "_sectionHidden_1n5dj_8", Pv = "_sectionInheritRadius_1n5dj_11", Ev = "_valueOutside_1n5dj_15", ot = {
  bar: Cv,
  section: Rv,
  sectionHidden: Sv,
  sectionInheritRadius: Pv,
  valueOutside: Ev
}, Zt = ({
  value: e,
  label: t,
  labelWidth: r,
  theme: n = ["var(--dixa-color-purple-700)", "var(--dixa-color-neutral-200)"],
  showFullBar: a = !1,
  showDifference: i = !1
}) => {
  const o = Math.min(e, 100), [s, c] = Z([
    null,
    null
  ]), u = Ol(s);
  te(() => {
    c([
      o,
      ...a ? [100 - o] : []
    ]);
  }, [o, a]);
  const d = 1.5, l = K(
    () => s.map((h, f) => {
      const g = o && f === 0 || i, p = h !== null && h < 20, m = qe(ot.section, {
        [ot.sectionHidden]: a && h === 0,
        [ot.sectionInheritRadius]: !a
      }), b = qe(ot.section, {
        [ot.valueOutside]: p
      });
      return /* @__PURE__ */ y.jsx(
        Y,
        {
          justifyContent: "flex-end",
          alignItems: "center",
          padding: "0 100",
          background: n[f],
          color: "neutral.000",
          className: m,
          style: {
            flexBasis: `${h ?? 0}%`,
            transition: `flex-basis ${d}s ease-out`
          },
          children: g && /* @__PURE__ */ y.jsx(
            W.Paragraph,
            {
              className: b,
              variant: "4",
              color: f === 0 && !p ? "var(--dixa-color-neutral-000)" : "var(--dixa-color-neutral-900)",
              children: /* @__PURE__ */ y.jsx(
                wv,
                {
                  start: u?.[f] ?? 0,
                  end: h ?? 0,
                  duration: d,
                  delay: 0,
                  suffix: "%",
                  children: ({ countUpRef: _ }) => /* @__PURE__ */ y.jsx("span", { ref: _ })
                }
              )
            }
          )
        },
        f
      );
    }),
    [
      o,
      n,
      i,
      a,
      s,
      u
    ]
  );
  return /* @__PURE__ */ y.jsxs(Y, { alignItems: "center", gap: "200", children: [
    t && /* @__PURE__ */ y.jsx(ao, { minWidth: r ? `${r}px` : "auto", children: /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "4", children: t }) }),
    /* @__PURE__ */ y.jsx(Y, { flex: "1", className: ot.bar, height: "20px", borderRadius: "50", children: l })
  ] });
};
function Ue(e, t = { compact: !1 }) {
  if (e < 1e3)
    return `${(e / 1e3).toFixed(0)}s`;
  const r = Math.floor(e / 1e3 % 60), n = Math.floor(e / (1e3 * 60) % 60), a = Math.floor(e / (1e3 * 60 * 60) % 24), i = Math.floor(e / (1e3 * 60 * 60 * 24)), o = (c, u) => c > 0 ? `${c}${u}` : "";
  return [
    o(i, "d"),
    o(a, "h"),
    o(n, "m") || (t.compact ? "" : "0m"),
    o(r, "s") || (t.compact ? "" : "0s")
  ].filter(Boolean).join(" ");
}
function or(e) {
  return /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d{3})?(Z|[+-]\d{2}:\d{2})?)?$/.test(e) ? ut(e, ut.ISO_8601, !0).isValid() : !1;
}
const ls = 1e6, fs = 1e3;
function vf(e) {
  if (e < fs) return `${e}`;
  const t = e >= ls;
  return `${parseFloat(
    (e / (t ? ls : fs)).toFixed(1)
  )}${t ? "M" : "K"}`;
}
function Et(e) {
  return e.toLocaleString(navigator.language);
}
const Fy = (e) => ({
  metrics: e.filter(Av),
  chart: e.find(Ov),
  heatmap: e.find(Tv),
  table: e.find($v),
  presence: e.find(qv),
  insight: e.find(jv)
}), Av = (e) => e.type === "metric", Ov = (e) => e.type === "chart" && e.visualization !== "heatmap", Tv = (e) => e.type === "chart" && e.visualization === "heatmap", $v = (e) => e.type === "table", qv = (e) => e.type === "presence", jv = (e) => e.type === "ai_insight", jt = (e, t) => {
  switch (t) {
    case "duration":
      return Ue(e).split(" ").slice(0, 2).join(" ");
    case "count":
      return vf(e);
    case "number":
      return Et(e);
    case "percentage":
      return `${Et(e)}%`;
    case "timer":
      return Ue(e);
    default:
      return "";
  }
}, sr = {
  default: 8,
  rating: 5
}, Qi = Tl.purple[700], Iv = (e) => /^#|^rgb(a)?\(|^hsl(a)?\(|^var\(/.test(e), Mv = (e) => {
  const [t, r] = e.split("-"), n = Number(r);
  return sr[t] ? n >= 1 && n <= sr[t] : !1;
}, gf = (e) => Iv(e) ? e : Mv(e) ? `var(--dixa-analytics-color-${e}, ${Qi})` : Qi, st = (e, t = "default", r) => {
  if (r)
    return gf(r);
  const n = sr[t] ?? sr.default, a = e % n + 1;
  return `var(--dixa-analytics-color-${t}-${a}, ${Qi})`;
}, Dv = "_container_1t2a7_1", Fv = {
  container: Dv
}, Nv = Ce(
  function({
    granularities: t,
    onChangeGranularity: r
  }) {
    return /* @__PURE__ */ y.jsx(Sl, { variant: "secondary", children: t.map(({ value: n, selected: a }) => /* @__PURE__ */ y.jsx(
      Pl,
      {
        onClick: a ? void 0 : () => r?.(n),
        active: a,
        children: n
      },
      n
    )) });
  }
), kv = "_root_6kwn9_1", Lv = "_rootBounded_6kwn9_7", Bv = "_rootFluid_6kwn9_7", Fr = {
  root: kv,
  rootBounded: Lv,
  rootFluid: Bv
}, eo = ({
  bounded: e = !1,
  fluid: t = !1,
  children: r
}) => {
  const n = qe(Fr.root, {
    [Fr.rootBounded]: e,
    [Fr.rootFluid]: t
  });
  return /* @__PURE__ */ y.jsx("div", { className: n, children: r });
}, Vv = Ce(
  function({
    data: t
  }) {
    const [r, n] = Z(0);
    return te(() => {
      n(Math.max(0, Date.now() - t));
    }, [t]), hd(() => {
      n(Math.max(0, Date.now() - t));
    }, 1e3), /* @__PURE__ */ y.jsx(y.Fragment, { children: jt(r, "timer") });
  }
), Hv = "_wrapper_1w7q6_1", zv = "_text_1w7q6_6", ds = {
  wrapper: Hv,
  text: zv
}, Uv = Ce(function({
  className: t,
  data: r,
  format: n,
  color: a,
  suffix: i
}) {
  const o = K(() => {
    if (r === null) return "n.a.";
    switch (n) {
      case "timer":
        return /* @__PURE__ */ y.jsx(Vv, { data: r });
      default:
        return jt(r, n);
    }
  }, [r, n]), s = K(() => {
    if (r !== null)
      switch (n) {
        case "duration":
          return Ue(r);
        case "count":
          return Et(r);
        default:
          return;
      }
  }, [r, n]), u = !(r !== null && s !== o) || ["number", "percentage", "timer"].includes(n);
  return /* @__PURE__ */ y.jsx(
    Ot,
    {
      content: s,
      disabled: u,
      wrap: "div",
      wrapProps: { className: ds.wrapper },
      children: /* @__PURE__ */ y.jsxs(
        W.Heading,
        {
          variant: "heading-1",
          color: a ?? (r === null ? "tertiary" : void 0),
          className: qe(ds.text, t),
          as: "span",
          children: [
            o,
            i
          ]
        }
      )
    }
  );
}), Wv = "_colorIndicator_luubh_1", Gv = {
  colorIndicator: Wv
}, mf = Ce(function({
  instrument: t,
  theme: r = "light"
}) {
  const { data: n, format: a, title: i, description: o, color: s } = t, c = s ? gf(s) : void 0, u = r === "dark" ? "inherit" : void 0;
  return /* @__PURE__ */ y.jsxs(Y, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ y.jsxs(Y, { alignItems: "center", gap: "100", title: i, children: [
      s && /* @__PURE__ */ y.jsx(
        ao,
        {
          as: "span",
          className: Gv.colorIndicator,
          background: c
        }
      ),
      /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "4", color: u, subdued: !0, children: i })
    ] }),
    /* @__PURE__ */ y.jsx(Uv, { data: n, format: a, color: u }),
    o && /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "4", color: u, subdued: !0, children: o })
  ] });
}), Kv = {
  fontFamily: "var(--dixa-typography-family-default)",
  fontSize: "var(--dixa-typography-size-200)",
  fill: "var(--dixa-typography-color-tertiary)"
}, Yv = {
  bar: "chart-bar",
  line: "chart-line",
  area: "chart-area",
  pie: "chart-pie",
  donut: "chart-donut"
}, We = {
  tickCount: 5,
  tickProps: Kv,
  visualizationIcons: Yv
}, Xv = ({ categories: e, series: t }, { omitZero: r }) => e.map((n, a) => {
  const i = t.reduce(
    (o, { label: s, data: c }) => {
      const { value: u } = pr(c[a]);
      return (r ? !u : u === null) ? o : { ...o, [s]: u };
    },
    {}
  );
  return {
    name: n.label,
    ...i
  };
}), pr = (e) => e === null || typeof e == "number" ? { value: e } : {
  value: e?.value ?? null,
  metrics: e?.metrics
};
var Nr, hs;
function bf() {
  if (hs) return Nr;
  hs = 1;
  var e = typeof kt == "object" && kt && kt.Object === Object && kt;
  return Nr = e, Nr;
}
var kr, ps;
function Oe() {
  if (ps) return kr;
  ps = 1;
  var e = bf(), t = typeof self == "object" && self && self.Object === Object && self, r = e || t || Function("return this")();
  return kr = r, kr;
}
var Lr, vs;
function It() {
  if (vs) return Lr;
  vs = 1;
  var e = Oe(), t = e.Symbol;
  return Lr = t, Lr;
}
var Br, gs;
function yf() {
  if (gs) return Br;
  gs = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length, i = Array(a); ++n < a; )
      i[n] = r(t[n], n, t);
    return i;
  }
  return Br = e, Br;
}
var Vr, ms;
function Pe() {
  if (ms) return Vr;
  ms = 1;
  var e = Array.isArray;
  return Vr = e, Vr;
}
var Hr, bs;
function Jv() {
  if (bs) return Hr;
  bs = 1;
  var e = It(), t = Object.prototype, r = t.hasOwnProperty, n = t.toString, a = e ? e.toStringTag : void 0;
  function i(o) {
    var s = r.call(o, a), c = o[a];
    try {
      o[a] = void 0;
      var u = !0;
    } catch {
    }
    var d = n.call(o);
    return u && (s ? o[a] = c : delete o[a]), d;
  }
  return Hr = i, Hr;
}
var zr, ys;
function Zv() {
  if (ys) return zr;
  ys = 1;
  var e = Object.prototype, t = e.toString;
  function r(n) {
    return t.call(n);
  }
  return zr = r, zr;
}
var Ur, _s;
function Ye() {
  if (_s) return Ur;
  _s = 1;
  var e = It(), t = Jv(), r = Zv(), n = "[object Null]", a = "[object Undefined]", i = e ? e.toStringTag : void 0;
  function o(s) {
    return s == null ? s === void 0 ? a : n : i && i in Object(s) ? t(s) : r(s);
  }
  return Ur = o, Ur;
}
var Wr, xs;
function Xe() {
  if (xs) return Wr;
  xs = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return Wr = e, Wr;
}
var Gr, ws;
function Mt() {
  if (ws) return Gr;
  ws = 1;
  var e = Ye(), t = Xe(), r = "[object Symbol]";
  function n(a) {
    return typeof a == "symbol" || t(a) && e(a) == r;
  }
  return Gr = n, Gr;
}
var Kr, Cs;
function _f() {
  if (Cs) return Kr;
  Cs = 1;
  var e = It(), t = yf(), r = Pe(), n = Mt(), a = e ? e.prototype : void 0, i = a ? a.toString : void 0;
  function o(s) {
    if (typeof s == "string")
      return s;
    if (r(s))
      return t(s, o) + "";
    if (n(s))
      return i ? i.call(s) : "";
    var c = s + "";
    return c == "0" && 1 / s == -1 / 0 ? "-0" : c;
  }
  return Kr = o, Kr;
}
var Yr, Rs;
function Qv() {
  if (Rs) return Yr;
  Rs = 1;
  function e(t, r, n) {
    var a = -1, i = t.length;
    r < 0 && (r = -r > i ? 0 : i + r), n = n > i ? i : n, n < 0 && (n += i), i = r > n ? 0 : n - r >>> 0, r >>>= 0;
    for (var o = Array(i); ++a < i; )
      o[a] = t[a + r];
    return o;
  }
  return Yr = e, Yr;
}
var Xr, Ss;
function xf() {
  if (Ss) return Xr;
  Ss = 1;
  var e = Qv();
  function t(r, n, a) {
    var i = r.length;
    return a = a === void 0 ? i : a, !n && a >= i ? r : e(r, n, a);
  }
  return Xr = t, Xr;
}
var Jr, Ps;
function vr() {
  if (Ps) return Jr;
  Ps = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", a = t + r + n, i = "\\ufe0e\\ufe0f", o = "\\u200d", s = RegExp("[" + o + e + a + i + "]");
  function c(u) {
    return s.test(u);
  }
  return Jr = c, Jr;
}
var Zr, Es;
function Je() {
  if (Es) return Zr;
  Es = 1;
  function e(t) {
    var r = typeof t;
    return t != null && (r == "object" || r == "function");
  }
  return Zr = e, Zr;
}
var Qr, As;
function eg() {
  if (As) return Qr;
  As = 1;
  var e = Ye(), t = Xe(), r = "[object RegExp]";
  function n(a) {
    return t(a) && e(a) == r;
  }
  return Qr = n, Qr;
}
var en, Os;
function po() {
  if (Os) return en;
  Os = 1;
  function e(t) {
    return function(r) {
      return t(r);
    };
  }
  return en = e, en;
}
var xt = { exports: {} };
xt.exports;
var Ts;
function wf() {
  return Ts || (Ts = 1, (function(e, t) {
    var r = bf(), n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, i = a && a.exports === n, o = i && r.process, s = (function() {
      try {
        var c = a && a.require && a.require("util").types;
        return c || o && o.binding && o.binding("util");
      } catch {
      }
    })();
    e.exports = s;
  })(xt, xt.exports)), xt.exports;
}
var tn, $s;
function tg() {
  if ($s) return tn;
  $s = 1;
  var e = eg(), t = po(), r = wf(), n = r && r.isRegExp, a = n ? t(n) : e;
  return tn = a, tn;
}
var rn, qs;
function Cf() {
  if (qs) return rn;
  qs = 1;
  function e(t) {
    return function(r) {
      return r?.[t];
    };
  }
  return rn = e, rn;
}
var nn, js;
function rg() {
  if (js) return nn;
  js = 1;
  var e = Cf(), t = e("length");
  return nn = t, nn;
}
var an, Is;
function ng() {
  if (Is) return an;
  Is = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", a = t + r + n, i = "\\ufe0e\\ufe0f", o = "[" + e + "]", s = "[" + a + "]", c = "\\ud83c[\\udffb-\\udfff]", u = "(?:" + s + "|" + c + ")", d = "[^" + e + "]", l = "(?:\\ud83c[\\udde6-\\uddff]){2}", h = "[\\ud800-\\udbff][\\udc00-\\udfff]", f = "\\u200d", g = u + "?", p = "[" + i + "]?", m = "(?:" + f + "(?:" + [d, l, h].join("|") + ")" + p + g + ")*", b = p + g + m, _ = "(?:" + [d + s + "?", s, l, h, o].join("|") + ")", C = RegExp(c + "(?=" + c + ")|" + _ + b, "g");
  function R(P) {
    for (var A = C.lastIndex = 0; C.test(P); )
      ++A;
    return A;
  }
  return an = R, an;
}
var on, Ms;
function ag() {
  if (Ms) return on;
  Ms = 1;
  var e = rg(), t = vr(), r = ng();
  function n(a) {
    return t(a) ? r(a) : e(a);
  }
  return on = n, on;
}
var sn, Ds;
function ig() {
  if (Ds) return sn;
  Ds = 1;
  function e(t) {
    return t.split("");
  }
  return sn = e, sn;
}
var cn, Fs;
function og() {
  if (Fs) return cn;
  Fs = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", a = t + r + n, i = "\\ufe0e\\ufe0f", o = "[" + e + "]", s = "[" + a + "]", c = "\\ud83c[\\udffb-\\udfff]", u = "(?:" + s + "|" + c + ")", d = "[^" + e + "]", l = "(?:\\ud83c[\\udde6-\\uddff]){2}", h = "[\\ud800-\\udbff][\\udc00-\\udfff]", f = "\\u200d", g = u + "?", p = "[" + i + "]?", m = "(?:" + f + "(?:" + [d, l, h].join("|") + ")" + p + g + ")*", b = p + g + m, _ = "(?:" + [d + s + "?", s, l, h, o].join("|") + ")", C = RegExp(c + "(?=" + c + ")|" + _ + b, "g");
  function R(P) {
    return P.match(C) || [];
  }
  return cn = R, cn;
}
var un, Ns;
function Rf() {
  if (Ns) return un;
  Ns = 1;
  var e = ig(), t = vr(), r = og();
  function n(a) {
    return t(a) ? r(a) : e(a);
  }
  return un = n, un;
}
var ln, ks;
function sg() {
  if (ks) return ln;
  ks = 1;
  var e = /\s/;
  function t(r) {
    for (var n = r.length; n-- && e.test(r.charAt(n)); )
      ;
    return n;
  }
  return ln = t, ln;
}
var fn, Ls;
function cg() {
  if (Ls) return fn;
  Ls = 1;
  var e = sg(), t = /^\s+/;
  function r(n) {
    return n && n.slice(0, e(n) + 1).replace(t, "");
  }
  return fn = r, fn;
}
var dn, Bs;
function Sf() {
  if (Bs) return dn;
  Bs = 1;
  var e = cg(), t = Je(), r = Mt(), n = NaN, a = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, o = /^0o[0-7]+$/i, s = parseInt;
  function c(u) {
    if (typeof u == "number")
      return u;
    if (r(u))
      return n;
    if (t(u)) {
      var d = typeof u.valueOf == "function" ? u.valueOf() : u;
      u = t(d) ? d + "" : d;
    }
    if (typeof u != "string")
      return u === 0 ? u : +u;
    u = e(u);
    var l = i.test(u);
    return l || o.test(u) ? s(u.slice(2), l ? 2 : 8) : a.test(u) ? n : +u;
  }
  return dn = c, dn;
}
var hn, Vs;
function ug() {
  if (Vs) return hn;
  Vs = 1;
  var e = Sf(), t = 1 / 0, r = 17976931348623157e292;
  function n(a) {
    if (!a)
      return a === 0 ? a : 0;
    if (a = e(a), a === t || a === -t) {
      var i = a < 0 ? -1 : 1;
      return i * r;
    }
    return a === a ? a : 0;
  }
  return hn = n, hn;
}
var pn, Hs;
function lg() {
  if (Hs) return pn;
  Hs = 1;
  var e = ug();
  function t(r) {
    var n = e(r), a = n % 1;
    return n === n ? a ? n - a : n : 0;
  }
  return pn = t, pn;
}
var vn, zs;
function gr() {
  if (zs) return vn;
  zs = 1;
  var e = _f();
  function t(r) {
    return r == null ? "" : e(r);
  }
  return vn = t, vn;
}
var gn, Us;
function fg() {
  if (Us) return gn;
  Us = 1;
  var e = _f(), t = xf(), r = vr(), n = Je(), a = tg(), i = ag(), o = Rf(), s = lg(), c = gr(), u = 30, d = "...", l = /\w*$/;
  function h(f, g) {
    var p = u, m = d;
    if (n(g)) {
      var b = "separator" in g ? g.separator : b;
      p = "length" in g ? s(g.length) : p, m = "omission" in g ? e(g.omission) : m;
    }
    f = c(f);
    var _ = f.length;
    if (r(f)) {
      var C = o(f);
      _ = C.length;
    }
    if (p >= _)
      return f;
    var R = p - i(m);
    if (R < 1)
      return m;
    var P = C ? t(C, 0, R).join("") : f.slice(0, R);
    if (b === void 0)
      return P + m;
    if (C && (R += P.length - R), a(b)) {
      if (f.slice(R).search(b)) {
        var A, T = P;
        for (b.global || (b = RegExp(b.source, c(l.exec(b)) + "g")), b.lastIndex = 0; A = b.exec(T); )
          var x = A.index;
        P = P.slice(0, x === void 0 ? R : x);
      }
    } else if (f.indexOf(e(b), R) != R) {
      var w = P.lastIndexOf(b);
      w > -1 && (P = P.slice(0, w));
    }
    return P + m;
  }
  return gn = h, gn;
}
var dg = fg();
const hg = /* @__PURE__ */ Se(dg), Pf = (e, t = "D", {
  long: r = !1,
  timezone: n = ut.tz.guess()
} = {}) => {
  const a = ut.tz(e, n), i = ut.locale() === "en", o = (s) => r ? s.format("ddd, ll") : s.format(i ? "MMM DD" : "DD MMM");
  switch (t) {
    case "H":
      return a.format("LT");
    case "W":
      return r ? `${o(a)} - ${o(
        a.endOf("week")
      )} (W${a.format("W")})` : o(a);
    case "M":
      return a.format(r ? "MMM YYYY" : "MMM");
    case "D":
    default:
      return o(a);
  }
}, Ef = (e, t = {}) => t?.length ? hg(e, t) : e, pg = "_root_7a8ds_48", vg = {
  root: pg
}, gg = Ce(function({
  instrument: t,
  granularity: r,
  timezone: n,
  tooltipProps: a
}) {
  const { active: i, payload: o, label: s } = a, { categories: c, series: u } = t.data, d = c.find((_) => _.label === s), l = d?.metrics ?? [], h = 24, f = Math.max(0, (o?.length ?? 0) - h), g = K(() => u.length === 1 && ["count", "number"].includes(u[0].options?.format ?? "number") && !c.every(({ label: C }) => or(C)) ? u[0].data.reduce((C, R) => {
    const { value: P } = pr(R);
    return typeof P == "number" ? C + P : C;
  }, 0) : null, [c, u]), p = K(
    () => o?.slice(
      0,
      // When there are more series than the limit, subtract one to make room for the overflow indicator.
      f > 0 ? h - 1 : h
    ).map((_, C) => {
      const R = _.value ?? 0, P = R && g ? R / g * 100 : null, A = P ? `${P.toFixed(2)}%` : void 0;
      return {
        type: "metric",
        title: _.name ?? "",
        color: _.color,
        data: R,
        format: u[C].options?.format ?? "number",
        description: A
      };
    }),
    [o, u, h, f, g]
  ), m = G(
    (_) => _?.map((C) => /* @__PURE__ */ y.jsx(
      mf,
      {
        instrument: C,
        theme: "dark"
      },
      C.title
    )),
    []
  ), b = K(
    () => d?.label ? or(d.label) ? Pf(d.label, r, {
      timezone: n,
      long: !0
    }) : Ef(d.label) : null,
    [d?.label, r, n]
  );
  return !i || !o ? null : /* @__PURE__ */ y.jsxs("div", { className: vg.root, children: [
    b && /* @__PURE__ */ y.jsxs(Y, { flexDirection: "column", gap: "100", children: [
      /* @__PURE__ */ y.jsx(W.Heading, { variant: "heading-2", color: "inherit", children: b }),
      d?.description && /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "4", color: "inherit", children: d.description })
    ] }),
    l.length > 0 && /* @__PURE__ */ y.jsx(eo, { bounded: !0, children: m(l) }),
    /* @__PURE__ */ y.jsxs(eo, { bounded: !0, children: [
      m(p),
      f > 0 && /* @__PURE__ */ y.jsx(Y, { flex: "1", alignItems: "center", children: /* @__PURE__ */ y.jsxs(W.Heading, { variant: "heading-2", color: "inherit", children: [
        "+ ",
        f + 1,
        " more"
      ] }) })
    ] })
  ] });
});
var mn, Ws;
function mg() {
  if (Ws) return mn;
  Ws = 1;
  var e = xf(), t = vr(), r = Rf(), n = gr();
  function a(i) {
    return function(o) {
      o = n(o);
      var s = t(o) ? r(o) : void 0, c = s ? s[0] : o.charAt(0), u = s ? e(s, 1).join("") : o.slice(1);
      return c[i]() + u;
    };
  }
  return mn = a, mn;
}
var bn, Gs;
function bg() {
  if (Gs) return bn;
  Gs = 1;
  var e = mg(), t = e("toUpperCase");
  return bn = t, bn;
}
var yn, Ks;
function yg() {
  if (Ks) return yn;
  Ks = 1;
  var e = gr(), t = bg();
  function r(n) {
    return t(e(n).toLowerCase());
  }
  return yn = r, yn;
}
var _g = yg();
const xg = /* @__PURE__ */ Se(_g), wg = Ce(
  function({
    visualization: t,
    visualizations: r,
    onChangeVisualization: n
  }) {
    return r.length <= 1 ? null : /* @__PURE__ */ y.jsx(Sl, { variant: "secondary", children: r.map((a) => /* @__PURE__ */ y.jsx(
      no,
      {
        icon: We.visualizationIcons[a],
        onClick: () => {
          n(a);
        },
        active: t === a,
        title: `${xg(a)} chart`
      },
      a
    )) });
  }
), Cg = ({
  instrument: e,
  granularity: t,
  timezone: r,
  syncOptions: n
}) => {
  const { data: a, layout: i } = e, o = i === "horizontal", s = i === "vertical", c = 192, u = K(() => {
    if (s) return 0;
    const g = a.categories.length % 2 === 0;
    switch (t) {
      // There are always an even number of categories, so we preserve the first tick in order to
      // ensure that hours are shown in even intervals e.g. 08:00, 10:00, 12:00 ... 22:00.
      case "H":
        return "preserveStart";
      // When the number of days is even, we preserve the last tick in order to ensure that
      // days are shown in equal intervals e.g. Apr 2, Apr 4, Apr 6 ... Apr 30. When uneven, we
      // preserve the first tick, resulting in equal intervals e.g. Mar 1, Mar 4, Mar 7 ... Mar 31.
      case "D":
      case "W":
        return g ? "preserveEnd" : "preserveStart";
      default:
        return "preserveStartEnd";
    }
  }, [a.categories.length, t, s]), d = {
    dataKey: "name",
    width: s ? c : 0,
    tickLine: {
      stroke: "var(--dixa-color-neutral-200)"
    },
    axisLine: {
      stroke: "var(--dixa-color-neutral-200)"
    },
    tickSize: 6,
    tickMargin: 8,
    interval: u,
    tick: We.tickProps,
    tickFormatter: (g) => or(g) ? Pf(g, t, { timezone: r }) : Ef(g, { length: c / 10 })
  }, l = {
    domain: [0, "auto"],
    allowDecimals: !1,
    tickLine: !1,
    axisLine: !1,
    tick: We.tickProps,
    ticks: n?.ticks,
    tickCount: We.tickCount,
    tickFormatter: (g) => jt(g, a.series[0].options?.format ?? "number")
  }, h = o ? { type: "category", ...d } : { type: "number", ...l }, f = o ? { type: "number", ...l } : { type: "category", ...d };
  return { xAxisProps: h, yAxisProps: f };
};
var _n, Ys;
function Rg() {
  if (Ys) return _n;
  Ys = 1;
  var e = Oe(), t = function() {
    return e.Date.now();
  };
  return _n = t, _n;
}
var xn, Xs;
function Sg() {
  if (Xs) return xn;
  Xs = 1;
  var e = Je(), t = Rg(), r = Sf(), n = "Expected a function", a = Math.max, i = Math.min;
  function o(s, c, u) {
    var d, l, h, f, g, p, m = 0, b = !1, _ = !1, C = !0;
    if (typeof s != "function")
      throw new TypeError(n);
    c = r(c) || 0, e(u) && (b = !!u.leading, _ = "maxWait" in u, h = _ ? a(r(u.maxWait) || 0, c) : h, C = "trailing" in u ? !!u.trailing : C);
    function R($) {
      var M = d, F = l;
      return d = l = void 0, m = $, f = s.apply(F, M), f;
    }
    function P($) {
      return m = $, g = setTimeout(x, c), b ? R($) : f;
    }
    function A($) {
      var M = $ - p, F = $ - m, q = c - M;
      return _ ? i(q, h - F) : q;
    }
    function T($) {
      var M = $ - p, F = $ - m;
      return p === void 0 || M >= c || M < 0 || _ && F >= h;
    }
    function x() {
      var $ = t();
      if (T($))
        return w($);
      g = setTimeout(x, A($));
    }
    function w($) {
      return g = void 0, C && d ? R($) : (d = l = void 0, f);
    }
    function E() {
      g !== void 0 && clearTimeout(g), m = 0, d = p = l = g = void 0;
    }
    function S() {
      return g === void 0 ? f : w(t());
    }
    function I() {
      var $ = t(), M = T($);
      if (d = arguments, l = this, p = $, M) {
        if (g === void 0)
          return P(p);
        if (_)
          return clearTimeout(g), g = setTimeout(x, c), R(p);
      }
      return g === void 0 && (g = setTimeout(x, c)), f;
    }
    return I.cancel = E, I.flush = S, I;
  }
  return xn = o, xn;
}
var Pg = Sg();
const Eg = /* @__PURE__ */ Se(Pg), Ag = "_legendItem_1mjjb_48", Og = "_legendItemInactive_1mjjb_55", Tg = "_legendIcon_1mjjb_59", $g = "_legendIconBar_1mjjb_66", qg = "_legendIconLine_1mjjb_69", bt = {
  legendItem: Ag,
  legendItemInactive: Og,
  legendIcon: Tg,
  legendIconBar: $g,
  legendIconLine: qg
}, jg = Ce(function({
  instrument: t,
  legend: r,
  visualization: n,
  onToggleLegendItem: a,
  onMouseEnterLegendItem: i,
  onMouseLeaveLegendItem: o,
  hoveredLegend: s
}) {
  const { series: c, options: u } = t.data, { layout: d } = u?.legend ?? {
    layout: "horizontal"
  }, l = d === "horizontal";
  return /* @__PURE__ */ y.jsx(
    Y,
    {
      padding: l ? "0" : "0 0 0 400",
      flexDirection: l ? "row" : "column",
      gap: l ? "400" : "200",
      justifyContent: "center",
      children: c.map(({ label: h, options: f }, g) => {
        const p = st(
          g,
          void 0,
          f?.color
        ), m = qe(bt.legendItem, {
          [bt.legendItemInactive]: s && s !== h
        }), b = qe(bt.legendIcon, {
          [bt.legendIconBar]: n !== "line",
          [bt.legendIconLine]: n === "line"
        });
        return /* @__PURE__ */ y.jsxs(
          Y,
          {
            gap: "200",
            flexDirection: "row",
            alignItems: "center",
            className: m,
            onClick: () => a(h),
            onMouseEnter: () => i?.(h),
            onMouseLeave: () => o?.(h),
            children: [
              /* @__PURE__ */ y.jsx(
                "span",
                {
                  className: b,
                  style: {
                    borderColor: p,
                    backgroundColor: r.includes(h) ? p : "transparent"
                  }
                }
              ),
              /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "4", subdued: !0, children: h })
            ]
          },
          h
        );
      })
    }
  );
}), Ig = ({
  instrument: e,
  visualization: t
}) => {
  const {
    data: { series: r, options: n }
  } = e, a = n?.legend?.layout === "horizontal", [i, o] = pd(
    r.filter(({ options: m }) => m?.visible ?? !0).map(({ label: m }) => m)
  ), [s, c] = Z(null);
  Tt(() => {
    u();
  }, [r.length]);
  const u = G(() => {
    o.set(r.map(({ label: m }) => m));
  }, [r, o]), d = G(
    (m) => {
      i.includes(m) && c(m);
    },
    [i]
  ), l = K(
    () => Eg(d, 300),
    [d]
  ), h = G(() => {
    l.cancel(), c(null);
  }, [l]), f = G(
    (m) => {
      i.length === r.length ? o.filter((b) => b === m) : i.length === 1 && i.includes(m) ? u() : i.includes(m) ? o.removeAt(i.indexOf(m)) : o.push(m);
    },
    [r.length, u, i, o]
  ), g = K(
    () => r.length < 10 ? {
      onMouseEnterLegendItem: l,
      onMouseLeaveLegendItem: h,
      hoveredLegend: s
    } : {},
    [
      l,
      h,
      s,
      r.length
    ]
  ), p = K(
    () => ({
      layout: n?.legend?.layout,
      align: a ? "center" : "right",
      verticalAlign: a ? "bottom" : "middle",
      wrapperStyle: {
        overflow: "auto",
        ...a ? {
          bottom: 0
        } : {
          right: 0,
          width: 208,
          maxHeight: "100%"
        }
      },
      // Using the render function form instead of directly passing an element prevents the
      // `ChartInstrumentLegend` component from re-rendering unnecessarily due to Recharts props
      // changing, because Recharts automatically passes props to the `content` element.
      content: () => /* @__PURE__ */ y.jsx(
        jg,
        {
          visualization: t,
          instrument: e,
          legend: i,
          onToggleLegendItem: f,
          ...g
        }
      )
    }),
    [
      f,
      e,
      a,
      i,
      g,
      n?.legend?.layout,
      t
    ]
  );
  return {
    legend: i,
    legendProps: p,
    hoveredLegend: s
  };
};
var wn, Js;
function Mg() {
  if (Js) return wn;
  Js = 1;
  function e(t) {
    var r = t == null ? 0 : t.length;
    return r ? t[r - 1] : void 0;
  }
  return wn = e, wn;
}
var Dg = Mg();
const Fg = /* @__PURE__ */ Se(Dg);
var Cn, Zs;
function vo() {
  if (Zs) return Cn;
  Zs = 1;
  var e = Pe(), t = Mt(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, n = /^\w*$/;
  function a(i, o) {
    if (e(i))
      return !1;
    var s = typeof i;
    return s == "number" || s == "symbol" || s == "boolean" || i == null || t(i) ? !0 : n.test(i) || !r.test(i) || o != null && i in Object(o);
  }
  return Cn = a, Cn;
}
var Rn, Qs;
function Af() {
  if (Qs) return Rn;
  Qs = 1;
  var e = Ye(), t = Je(), r = "[object AsyncFunction]", n = "[object Function]", a = "[object GeneratorFunction]", i = "[object Proxy]";
  function o(s) {
    if (!t(s))
      return !1;
    var c = e(s);
    return c == n || c == a || c == r || c == i;
  }
  return Rn = o, Rn;
}
var Sn, ec;
function Ng() {
  if (ec) return Sn;
  ec = 1;
  var e = Oe(), t = e["__core-js_shared__"];
  return Sn = t, Sn;
}
var Pn, tc;
function kg() {
  if (tc) return Pn;
  tc = 1;
  var e = Ng(), t = (function() {
    var n = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return n ? "Symbol(src)_1." + n : "";
  })();
  function r(n) {
    return !!t && t in n;
  }
  return Pn = r, Pn;
}
var En, rc;
function Of() {
  if (rc) return En;
  rc = 1;
  var e = Function.prototype, t = e.toString;
  function r(n) {
    if (n != null) {
      try {
        return t.call(n);
      } catch {
      }
      try {
        return n + "";
      } catch {
      }
    }
    return "";
  }
  return En = r, En;
}
var An, nc;
function Lg() {
  if (nc) return An;
  nc = 1;
  var e = Af(), t = kg(), r = Je(), n = Of(), a = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, o = Function.prototype, s = Object.prototype, c = o.toString, u = s.hasOwnProperty, d = RegExp(
    "^" + c.call(u).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function l(h) {
    if (!r(h) || t(h))
      return !1;
    var f = e(h) ? d : i;
    return f.test(n(h));
  }
  return An = l, An;
}
var On, ac;
function Bg() {
  if (ac) return On;
  ac = 1;
  function e(t, r) {
    return t?.[r];
  }
  return On = e, On;
}
var Tn, ic;
function Ze() {
  if (ic) return Tn;
  ic = 1;
  var e = Lg(), t = Bg();
  function r(n, a) {
    var i = t(n, a);
    return e(i) ? i : void 0;
  }
  return Tn = r, Tn;
}
var $n, oc;
function mr() {
  if (oc) return $n;
  oc = 1;
  var e = Ze(), t = e(Object, "create");
  return $n = t, $n;
}
var qn, sc;
function Vg() {
  if (sc) return qn;
  sc = 1;
  var e = mr();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return qn = t, qn;
}
var jn, cc;
function Hg() {
  if (cc) return jn;
  cc = 1;
  function e(t) {
    var r = this.has(t) && delete this.__data__[t];
    return this.size -= r ? 1 : 0, r;
  }
  return jn = e, jn;
}
var In, uc;
function zg() {
  if (uc) return In;
  uc = 1;
  var e = mr(), t = "__lodash_hash_undefined__", r = Object.prototype, n = r.hasOwnProperty;
  function a(i) {
    var o = this.__data__;
    if (e) {
      var s = o[i];
      return s === t ? void 0 : s;
    }
    return n.call(o, i) ? o[i] : void 0;
  }
  return In = a, In;
}
var Mn, lc;
function Ug() {
  if (lc) return Mn;
  lc = 1;
  var e = mr(), t = Object.prototype, r = t.hasOwnProperty;
  function n(a) {
    var i = this.__data__;
    return e ? i[a] !== void 0 : r.call(i, a);
  }
  return Mn = n, Mn;
}
var Dn, fc;
function Wg() {
  if (fc) return Dn;
  fc = 1;
  var e = mr(), t = "__lodash_hash_undefined__";
  function r(n, a) {
    var i = this.__data__;
    return this.size += this.has(n) ? 0 : 1, i[n] = e && a === void 0 ? t : a, this;
  }
  return Dn = r, Dn;
}
var Fn, dc;
function Gg() {
  if (dc) return Fn;
  dc = 1;
  var e = Vg(), t = Hg(), r = zg(), n = Ug(), a = Wg();
  function i(o) {
    var s = -1, c = o == null ? 0 : o.length;
    for (this.clear(); ++s < c; ) {
      var u = o[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = r, i.prototype.has = n, i.prototype.set = a, Fn = i, Fn;
}
var Nn, hc;
function Kg() {
  if (hc) return Nn;
  hc = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Nn = e, Nn;
}
var kn, pc;
function go() {
  if (pc) return kn;
  pc = 1;
  function e(t, r) {
    return t === r || t !== t && r !== r;
  }
  return kn = e, kn;
}
var Ln, vc;
function br() {
  if (vc) return Ln;
  vc = 1;
  var e = go();
  function t(r, n) {
    for (var a = r.length; a--; )
      if (e(r[a][0], n))
        return a;
    return -1;
  }
  return Ln = t, Ln;
}
var Bn, gc;
function Yg() {
  if (gc) return Bn;
  gc = 1;
  var e = br(), t = Array.prototype, r = t.splice;
  function n(a) {
    var i = this.__data__, o = e(i, a);
    if (o < 0)
      return !1;
    var s = i.length - 1;
    return o == s ? i.pop() : r.call(i, o, 1), --this.size, !0;
  }
  return Bn = n, Bn;
}
var Vn, mc;
function Xg() {
  if (mc) return Vn;
  mc = 1;
  var e = br();
  function t(r) {
    var n = this.__data__, a = e(n, r);
    return a < 0 ? void 0 : n[a][1];
  }
  return Vn = t, Vn;
}
var Hn, bc;
function Jg() {
  if (bc) return Hn;
  bc = 1;
  var e = br();
  function t(r) {
    return e(this.__data__, r) > -1;
  }
  return Hn = t, Hn;
}
var zn, yc;
function Zg() {
  if (yc) return zn;
  yc = 1;
  var e = br();
  function t(r, n) {
    var a = this.__data__, i = e(a, r);
    return i < 0 ? (++this.size, a.push([r, n])) : a[i][1] = n, this;
  }
  return zn = t, zn;
}
var Un, _c;
function yr() {
  if (_c) return Un;
  _c = 1;
  var e = Kg(), t = Yg(), r = Xg(), n = Jg(), a = Zg();
  function i(o) {
    var s = -1, c = o == null ? 0 : o.length;
    for (this.clear(); ++s < c; ) {
      var u = o[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = r, i.prototype.has = n, i.prototype.set = a, Un = i, Un;
}
var Wn, xc;
function mo() {
  if (xc) return Wn;
  xc = 1;
  var e = Ze(), t = Oe(), r = e(t, "Map");
  return Wn = r, Wn;
}
var Gn, wc;
function Qg() {
  if (wc) return Gn;
  wc = 1;
  var e = Gg(), t = yr(), r = mo();
  function n() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || t)(),
      string: new e()
    };
  }
  return Gn = n, Gn;
}
var Kn, Cc;
function em() {
  if (Cc) return Kn;
  Cc = 1;
  function e(t) {
    var r = typeof t;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
  }
  return Kn = e, Kn;
}
var Yn, Rc;
function _r() {
  if (Rc) return Yn;
  Rc = 1;
  var e = em();
  function t(r, n) {
    var a = r.__data__;
    return e(n) ? a[typeof n == "string" ? "string" : "hash"] : a.map;
  }
  return Yn = t, Yn;
}
var Xn, Sc;
function tm() {
  if (Sc) return Xn;
  Sc = 1;
  var e = _r();
  function t(r) {
    var n = e(this, r).delete(r);
    return this.size -= n ? 1 : 0, n;
  }
  return Xn = t, Xn;
}
var Jn, Pc;
function rm() {
  if (Pc) return Jn;
  Pc = 1;
  var e = _r();
  function t(r) {
    return e(this, r).get(r);
  }
  return Jn = t, Jn;
}
var Zn, Ec;
function nm() {
  if (Ec) return Zn;
  Ec = 1;
  var e = _r();
  function t(r) {
    return e(this, r).has(r);
  }
  return Zn = t, Zn;
}
var Qn, Ac;
function am() {
  if (Ac) return Qn;
  Ac = 1;
  var e = _r();
  function t(r, n) {
    var a = e(this, r), i = a.size;
    return a.set(r, n), this.size += a.size == i ? 0 : 1, this;
  }
  return Qn = t, Qn;
}
var ea, Oc;
function bo() {
  if (Oc) return ea;
  Oc = 1;
  var e = Qg(), t = tm(), r = rm(), n = nm(), a = am();
  function i(o) {
    var s = -1, c = o == null ? 0 : o.length;
    for (this.clear(); ++s < c; ) {
      var u = o[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = r, i.prototype.has = n, i.prototype.set = a, ea = i, ea;
}
var ta, Tc;
function im() {
  if (Tc) return ta;
  Tc = 1;
  var e = bo(), t = "Expected a function";
  function r(n, a) {
    if (typeof n != "function" || a != null && typeof a != "function")
      throw new TypeError(t);
    var i = function() {
      var o = arguments, s = a ? a.apply(this, o) : o[0], c = i.cache;
      if (c.has(s))
        return c.get(s);
      var u = n.apply(this, o);
      return i.cache = c.set(s, u) || c, u;
    };
    return i.cache = new (r.Cache || e)(), i;
  }
  return r.Cache = e, ta = r, ta;
}
var ra, $c;
function om() {
  if ($c) return ra;
  $c = 1;
  var e = im(), t = 500;
  function r(n) {
    var a = e(n, function(o) {
      return i.size === t && i.clear(), o;
    }), i = a.cache;
    return a;
  }
  return ra = r, ra;
}
var na, qc;
function sm() {
  if (qc) return na;
  qc = 1;
  var e = om(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, n = e(function(a) {
    var i = [];
    return a.charCodeAt(0) === 46 && i.push(""), a.replace(t, function(o, s, c, u) {
      i.push(c ? u.replace(r, "$1") : s || o);
    }), i;
  });
  return na = n, na;
}
var aa, jc;
function xr() {
  if (jc) return aa;
  jc = 1;
  var e = Pe(), t = vo(), r = sm(), n = gr();
  function a(i, o) {
    return e(i) ? i : t(i, o) ? [i] : r(n(i));
  }
  return aa = a, aa;
}
var ia, Ic;
function Dt() {
  if (Ic) return ia;
  Ic = 1;
  var e = Mt();
  function t(r) {
    if (typeof r == "string" || e(r))
      return r;
    var n = r + "";
    return n == "0" && 1 / r == -1 / 0 ? "-0" : n;
  }
  return ia = t, ia;
}
var oa, Mc;
function wr() {
  if (Mc) return oa;
  Mc = 1;
  var e = xr(), t = Dt();
  function r(n, a) {
    a = e(a, n);
    for (var i = 0, o = a.length; n != null && i < o; )
      n = n[t(a[i++])];
    return i && i == o ? n : void 0;
  }
  return oa = r, oa;
}
var sa, Dc;
function Tf() {
  if (Dc) return sa;
  Dc = 1;
  var e = Ze(), t = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return sa = t, sa;
}
var ca, Fc;
function cm() {
  if (Fc) return ca;
  Fc = 1;
  var e = Tf();
  function t(r, n, a) {
    n == "__proto__" && e ? e(r, n, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[n] = a;
  }
  return ca = t, ca;
}
var ua, Nc;
function um() {
  if (Nc) return ua;
  Nc = 1;
  var e = cm(), t = go(), r = Object.prototype, n = r.hasOwnProperty;
  function a(i, o, s) {
    var c = i[o];
    (!(n.call(i, o) && t(c, s)) || s === void 0 && !(o in i)) && e(i, o, s);
  }
  return ua = a, ua;
}
var la, kc;
function yo() {
  if (kc) return la;
  kc = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function r(n, a) {
    var i = typeof n;
    return a = a ?? e, !!a && (i == "number" || i != "symbol" && t.test(n)) && n > -1 && n % 1 == 0 && n < a;
  }
  return la = r, la;
}
var fa, Lc;
function lm() {
  if (Lc) return fa;
  Lc = 1;
  var e = um(), t = xr(), r = yo(), n = Je(), a = Dt();
  function i(o, s, c, u) {
    if (!n(o))
      return o;
    s = t(s, o);
    for (var d = -1, l = s.length, h = l - 1, f = o; f != null && ++d < l; ) {
      var g = a(s[d]), p = c;
      if (g === "__proto__" || g === "constructor" || g === "prototype")
        return o;
      if (d != h) {
        var m = f[g];
        p = u ? u(m, g, f) : void 0, p === void 0 && (p = n(m) ? m : r(s[d + 1]) ? [] : {});
      }
      e(f, g, p), f = f[g];
    }
    return o;
  }
  return fa = i, fa;
}
var da, Bc;
function fm() {
  if (Bc) return da;
  Bc = 1;
  var e = wr(), t = lm(), r = xr();
  function n(a, i, o) {
    for (var s = -1, c = i.length, u = {}; ++s < c; ) {
      var d = i[s], l = e(a, d);
      o(l, d) && t(u, r(d, a), l);
    }
    return u;
  }
  return da = n, da;
}
var ha, Vc;
function dm() {
  if (Vc) return ha;
  Vc = 1;
  function e(t, r) {
    return t != null && r in Object(t);
  }
  return ha = e, ha;
}
var pa, Hc;
function hm() {
  if (Hc) return pa;
  Hc = 1;
  var e = Ye(), t = Xe(), r = "[object Arguments]";
  function n(a) {
    return t(a) && e(a) == r;
  }
  return pa = n, pa;
}
var va, zc;
function _o() {
  if (zc) return va;
  zc = 1;
  var e = hm(), t = Xe(), r = Object.prototype, n = r.hasOwnProperty, a = r.propertyIsEnumerable, i = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(o) {
    return t(o) && n.call(o, "callee") && !a.call(o, "callee");
  };
  return va = i, va;
}
var ga, Uc;
function xo() {
  if (Uc) return ga;
  Uc = 1;
  var e = 9007199254740991;
  function t(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return ga = t, ga;
}
var ma, Wc;
function pm() {
  if (Wc) return ma;
  Wc = 1;
  var e = xr(), t = _o(), r = Pe(), n = yo(), a = xo(), i = Dt();
  function o(s, c, u) {
    c = e(c, s);
    for (var d = -1, l = c.length, h = !1; ++d < l; ) {
      var f = i(c[d]);
      if (!(h = s != null && u(s, f)))
        break;
      s = s[f];
    }
    return h || ++d != l ? h : (l = s == null ? 0 : s.length, !!l && a(l) && n(f, l) && (r(s) || t(s)));
  }
  return ma = o, ma;
}
var ba, Gc;
function $f() {
  if (Gc) return ba;
  Gc = 1;
  var e = dm(), t = pm();
  function r(n, a) {
    return n != null && t(n, a, e);
  }
  return ba = r, ba;
}
var ya, Kc;
function vm() {
  if (Kc) return ya;
  Kc = 1;
  var e = fm(), t = $f();
  function r(n, a) {
    return e(n, a, function(i, o) {
      return t(n, o);
    });
  }
  return ya = r, ya;
}
var _a, Yc;
function qf() {
  if (Yc) return _a;
  Yc = 1;
  function e(t, r) {
    for (var n = -1, a = r.length, i = t.length; ++n < a; )
      t[i + n] = r[n];
    return t;
  }
  return _a = e, _a;
}
var xa, Xc;
function gm() {
  if (Xc) return xa;
  Xc = 1;
  var e = It(), t = _o(), r = Pe(), n = e ? e.isConcatSpreadable : void 0;
  function a(i) {
    return r(i) || t(i) || !!(n && i && i[n]);
  }
  return xa = a, xa;
}
var wa, Jc;
function mm() {
  if (Jc) return wa;
  Jc = 1;
  var e = qf(), t = gm();
  function r(n, a, i, o, s) {
    var c = -1, u = n.length;
    for (i || (i = t), s || (s = []); ++c < u; ) {
      var d = n[c];
      a > 0 && i(d) ? a > 1 ? r(d, a - 1, i, o, s) : e(s, d) : o || (s[s.length] = d);
    }
    return s;
  }
  return wa = r, wa;
}
var Ca, Zc;
function bm() {
  if (Zc) return Ca;
  Zc = 1;
  var e = mm();
  function t(r) {
    var n = r == null ? 0 : r.length;
    return n ? e(r, 1) : [];
  }
  return Ca = t, Ca;
}
var Ra, Qc;
function ym() {
  if (Qc) return Ra;
  Qc = 1;
  function e(t, r, n) {
    switch (n.length) {
      case 0:
        return t.call(r);
      case 1:
        return t.call(r, n[0]);
      case 2:
        return t.call(r, n[0], n[1]);
      case 3:
        return t.call(r, n[0], n[1], n[2]);
    }
    return t.apply(r, n);
  }
  return Ra = e, Ra;
}
var Sa, eu;
function _m() {
  if (eu) return Sa;
  eu = 1;
  var e = ym(), t = Math.max;
  function r(n, a, i) {
    return a = t(a === void 0 ? n.length - 1 : a, 0), function() {
      for (var o = arguments, s = -1, c = t(o.length - a, 0), u = Array(c); ++s < c; )
        u[s] = o[a + s];
      s = -1;
      for (var d = Array(a + 1); ++s < a; )
        d[s] = o[s];
      return d[a] = i(u), e(n, this, d);
    };
  }
  return Sa = r, Sa;
}
var Pa, tu;
function xm() {
  if (tu) return Pa;
  tu = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return Pa = e, Pa;
}
var Ea, ru;
function Cr() {
  if (ru) return Ea;
  ru = 1;
  function e(t) {
    return t;
  }
  return Ea = e, Ea;
}
var Aa, nu;
function wm() {
  if (nu) return Aa;
  nu = 1;
  var e = xm(), t = Tf(), r = Cr(), n = t ? function(a, i) {
    return t(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(i),
      writable: !0
    });
  } : r;
  return Aa = n, Aa;
}
var Oa, au;
function Cm() {
  if (au) return Oa;
  au = 1;
  var e = 800, t = 16, r = Date.now;
  function n(a) {
    var i = 0, o = 0;
    return function() {
      var s = r(), c = t - (s - o);
      if (o = s, c > 0) {
        if (++i >= e)
          return arguments[0];
      } else
        i = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Oa = n, Oa;
}
var Ta, iu;
function Rm() {
  if (iu) return Ta;
  iu = 1;
  var e = wm(), t = Cm(), r = t(e);
  return Ta = r, Ta;
}
var $a, ou;
function Sm() {
  if (ou) return $a;
  ou = 1;
  var e = bm(), t = _m(), r = Rm();
  function n(a) {
    return r(t(a, void 0, e), a + "");
  }
  return $a = n, $a;
}
var qa, su;
function Pm() {
  if (su) return qa;
  su = 1;
  var e = vm(), t = Sm(), r = t(function(n, a) {
    return n == null ? {} : e(n, a);
  });
  return qa = r, qa;
}
var Em = Pm();
const Am = /* @__PURE__ */ Se(Em);
var ja, cu;
function Om() {
  if (cu) return ja;
  cu = 1;
  function e(t, r) {
    for (var n, a = -1, i = t.length; ++a < i; ) {
      var o = r(t[a]);
      o !== void 0 && (n = n === void 0 ? o : n + o);
    }
    return n;
  }
  return ja = e, ja;
}
var Ia, uu;
function Tm() {
  if (uu) return Ia;
  uu = 1;
  var e = Om(), t = Cr();
  function r(n) {
    return n && n.length ? e(n, t) : 0;
  }
  return Ia = r, Ia;
}
var $m = Tm();
const qm = /* @__PURE__ */ Se($m), jm = (e) => {
  const { outerRadius: t } = e;
  return /* @__PURE__ */ y.jsxs("g", { children: [
    /* @__PURE__ */ y.jsx(Fo, { ...e }),
    /* @__PURE__ */ y.jsx(
      Fo,
      {
        ...e,
        innerRadius: t,
        outerRadius: t + 10,
        fillOpacity: 0.4
      }
    )
  ] });
}, Im = (e) => {
  const { name: t, value: r, cx: n, cy: a, midAngle: i, outerRadius: o, fill: s, percent: c } = e, u = !!r, d = typeof c == "number" && c >= 0.01;
  if (!u || !d || !(typeof n == "number" && typeof a == "number" && typeof i == "number" && typeof o == "number"))
    return null;
  const h = Math.PI / 180, f = o + 24, g = n + o * Math.cos(-i * h), p = a + o * Math.sin(-i * h), m = n + f * Math.cos(-i * h), b = a + f * Math.sin(-i * h), _ = m + (m > n ? 12 : -12), C = b;
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(
      "polyline",
      {
        points: `${g},${p} ${m},${b} ${_},${C}`,
        stroke: s,
        fill: "none",
        strokeWidth: 1
      }
    ),
    /* @__PURE__ */ y.jsx(
      "text",
      {
        ...We.tickProps,
        fill: jd.color.secondary,
        x: _ + (_ > n ? 8 : -8),
        y: C,
        textAnchor: _ > n ? "start" : "end",
        dominantBaseline: "middle",
        children: t
      }
    )
  ] });
}, Mm = ({
  instrument: e,
  legend: t,
  hoveredLegend: r,
  hoveredCategory: n
}) => {
  const { data: a, layout: i } = e, o = G(() => {
    const { categories: l, series: h } = a, f = h.filter(({ label: b }) => t.includes(b)), g = i === "vertical", p = g ? [0, 2, 2, 0] : [2, 2, 0, 0];
    return h.map(
      ({ label: b, options: _, data: C }, R) => {
        const P = st(
          R,
          a.options?.theme,
          _?.color
        ), A = _?.stack, T = A ? Fg(f)?.label === b : !0, x = f.length <= 10 && (A ? T : !0), w = /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
          x && /* @__PURE__ */ y.jsx(
            gd,
            {
              position: g ? "right" : "top",
              valueAccessor: ({ payload: S }) => (
                // In the case of stacked series, the total sum of all
                // visible series values for the current category is
                // displayed. For individual series, their own value is
                // displayed by using their `label` from the Recharts data.
                A ? qm(Object.values(Am(S, t))) : Number(S[b] ?? 0)
              ),
              formatter: (S) => S ? jt(S, _?.format ?? "number") : "",
              ...We.tickProps,
              offset: 8,
              fontSize: "var(--dixa-typography-size-100)"
            }
          ),
          C.map((S, I) => {
            const $ = h.length > 1 ? P : st(
              I,
              a.options?.theme,
              // If there is only one series, the category color is used if specified, otherwise
              // the colors are determined by the category index, resulting in different colors
              // being used for each category and repeating as necessary.
              l[I]?.options?.color ?? _?.color
            ), M = n === null || n === I, F = r === null || r === b;
            return /* @__PURE__ */ y.jsx(
              No,
              {
                fill: $,
                fillOpacity: M && F ? 1 : 0.4
              },
              `${b}-${I}`
            );
          })
        ] });
        return {
          key: b,
          dataKey: b,
          stackId: A,
          fill: P,
          radius: T ? p : 0,
          maxBarSize: 80,
          hide: !t.includes(b),
          children: w
        };
      }
    );
  }, [a, n, r, i, t]), s = G(() => {
    const { series: l } = a;
    return l.map(({ label: f, options: g }, p) => {
      const m = st(
        p,
        a.options?.theme,
        g?.color
      );
      return {
        key: f,
        type: "monotone",
        dot: !1,
        activeDot: { r: 5 },
        dataKey: f,
        stroke: m,
        strokeWidth: 2,
        strokeOpacity: r === null || r === f ? 1 : 0.4,
        connectNulls: !0,
        hide: !t.includes(f)
      };
    });
  }, [a, r, t]), c = G(() => {
    const { series: l } = a;
    return l.map(({ label: f, options: g }, p) => {
      const m = st(
        p,
        a.options?.theme,
        g?.color
      ), b = r === null || r === f;
      return {
        key: f,
        type: "monotone",
        dot: !1,
        activeDot: { r: 5 },
        dataKey: f,
        stackId: g?.stack,
        stroke: m,
        strokeWidth: 2,
        fill: m,
        fillOpacity: b ? 0.9 : 0.2,
        strokeOpacity: b ? 1 : 0,
        connectNulls: !0,
        hide: !t.includes(f)
      };
    });
  }, [a, r, t]), u = G(
    (l) => {
      const { categories: h, series: f } = a, g = h.map(
        ({ label: p, options: m }, b) => {
          const _ = st(
            b,
            a.options?.theme,
            m?.color
          );
          return /* @__PURE__ */ y.jsx(No, { fill: _, style: { outline: "none" } }, p);
        }
      );
      return {
        dataKey: f[0]?.label,
        cx: "50%",
        cy: "50%",
        label: Im,
        labelLine: !1,
        activeShape: jm,
        inactiveShape: {
          fillOpacity: 0.4
        },
        stroke: Tl.neutral["000"],
        strokeWidth: 1.5,
        innerRadius: l === "donut" ? "50%" : 0,
        outerRadius: "80%",
        startAngle: 90,
        endAngle: -270,
        children: g
      };
    },
    [a]
  );
  return { getSeriesProps: G(
    (l) => {
      switch (l) {
        case "bar":
          return o();
        case "line":
          return s();
        case "area":
          return c();
        case "pie":
        case "donut":
          return u(
            l
          );
        default:
          return [];
      }
      return [];
    },
    [c, o, s, u]
  ) };
}, Ny = Ce(function({
  instrument: t,
  panel: r,
  timezone: n,
  syncOptions: a,
  onChangeGranularity: i,
  onChangeVisualization: o
}) {
  const [s, c] = Z(
    r.controls?.settings.visualization ?? t.visualization
  ), [u, d] = Z(null), { data: l, layout: h, title: f } = t, g = h === "horizontal", p = h === "vertical", m = K(
    () => Xv(l, { omitZero: s === "bar" }),
    [l, s]
  ), b = K(
    () => l.granularities?.find(({ selected: q }) => q)?.value,
    [l.granularities]
  ), _ = K(() => {
    if (!l.options?.visualizations) return [];
    const q = ["bar"], k = l.series.length === 1;
    return l.categories.every(
      ({ label: Q }) => or(Q)
    ) ? q.push("line", "area") : k && q.push("pie", "donut"), q;
  }, [l.categories, l.options?.visualizations, l.series.length]), { xAxisProps: C, yAxisProps: R } = Cg({
    instrument: t,
    granularity: b,
    timezone: n,
    syncOptions: a
  }), { legend: P, legendProps: A, hoveredLegend: T } = Ig({
    instrument: t,
    visualization: s
  }), { getSeriesProps: x } = Mm({
    instrument: t,
    legend: P,
    hoveredLegend: T,
    hoveredCategory: u
  });
  Tt(() => {
    c(
      r.controls?.settings.visualization ?? t.visualization
    );
  }, [r.controls?.settings.visualization, t.visualization]);
  const w = G(
    (q) => {
      c(q), o?.(q);
    },
    [o]
  ), E = (q) => {
    if (!q?.isTooltipActive) {
      d(null);
      return;
    }
    const k = q.activeTooltipIndex;
    if (typeof k != "number") return;
    const L = Object.values(m[k] ?? {}).length > 1;
    d(L ? k : null);
  }, S = () => {
    d(null);
  }, I = () => s === "line" ? x(s).map(({ key: k, ...L }) => /* @__PURE__ */ y.jsx(Od, { ...L }, k)) : s === "bar" ? x(s).map(({ key: k, ...L }) => /* @__PURE__ */ y.jsx(Td, { ...L }, k)) : s === "area" ? x(s).map(({ key: k, ...L }) => /* @__PURE__ */ y.jsx($d, { ...L }, k)) : s === "pie" || s === "donut" ? /* @__PURE__ */ y.jsx(qd, { data: m, ...x(s) }) : null, $ = () => {
    const q = l.options?.legend?.layout, k = 16, L = {
      layout: h,
      syncId: a?.tooltip ? r.id : void 0,
      data: m,
      margin: {
        top: g ? k : 0,
        right: p || q === "vertical" ? k : 0,
        bottom: q === "horizontal" ? k / 2 : 0,
        left: 0
      }
    }, Q = s === "bar" || s === "line" || s === "area", ae = /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
      Q && /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
        /* @__PURE__ */ y.jsx(bd, { ...C }),
        /* @__PURE__ */ y.jsx(yd, { ...R })
      ] }),
      Q && l.options?.cartesian && /* @__PURE__ */ y.jsx(
        _d,
        {
          vertical: p,
          horizontal: g,
          stroke: "var(--dixa-color-neutral-200)"
        }
      ),
      Q && l.references?.map(({ value: re, label: pe }, oe) => /* @__PURE__ */ y.jsx(
        xd,
        {
          ...g ? { y: re } : { x: re },
          stroke: "var(--dixa-color-neutral-500)",
          strokeDasharray: "5 5",
          isFront: !0,
          children: /* @__PURE__ */ y.jsx(
            wd,
            {
              value: pe,
              offset: 8,
              fontSize: "var(--dixa-typography-size-200)",
              position: g ? "insideBottomLeft" : "insideTopLeft"
            }
          )
        },
        oe
      )),
      l.options?.legend && /* @__PURE__ */ y.jsx(Cd, { ...A }),
      l.options?.tooltip && /* @__PURE__ */ y.jsx(
        Rd,
        {
          content: (re) => /* @__PURE__ */ y.jsx(
            gg,
            {
              instrument: t,
              granularity: b,
              timezone: n,
              tooltipProps: re
            }
          ),
          cursor: { fill: "transparent" }
        }
      ),
      I()
    ] });
    switch (s) {
      case "bar":
        return /* @__PURE__ */ y.jsx(
          Ad,
          {
            ...L,
            barGap: "1",
            onMouseMove: E,
            onMouseLeave: S,
            children: ae
          }
        );
      case "line":
        return /* @__PURE__ */ y.jsx(Ed, { ...L, children: ae });
      case "area":
        return /* @__PURE__ */ y.jsx(Pd, { ...L, children: ae });
      case "pie":
      case "donut":
        return /* @__PURE__ */ y.jsx(Sd, { ...L, children: ae });
    }
  };
  if (!l.categories.length || !l.series.length)
    return /* @__PURE__ */ y.jsx(
      Y,
      {
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        children: /* @__PURE__ */ y.jsx(
          El,
          {
            title: "No data available",
            description: "There is no data available for the selected period and filters.",
            icon: We.visualizationIcons[s]
          }
        )
      }
    );
  const M = [
    l.granularities && l.granularities.length > 1 ? /* @__PURE__ */ y.jsx(
      Nv,
      {
        granularities: l.granularities,
        onChangeGranularity: i
      }
    ) : null,
    l.options?.visualizations ? /* @__PURE__ */ y.jsx(
      wg,
      {
        visualization: s,
        visualizations: _,
        onChangeVisualization: w
      }
    ) : null
  ], F = M.some(Boolean);
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    f && /* @__PURE__ */ y.jsx("div", { children: /* @__PURE__ */ y.jsx(W.Heading, { variant: "heading-4", children: f }) }),
    F && /* @__PURE__ */ y.jsx(Y, { alignSelf: "flex-end", gap: "300", children: M.map((q, k) => /* @__PURE__ */ y.jsx(Rl, { children: q }, k)) }),
    /* @__PURE__ */ y.jsx(
      md,
      {
        className: Fv.container,
        width: "100%",
        height: "100%",
        debounce: 100,
        children: $()
      }
    )
  ] });
});
var Ma, lu;
function Dm() {
  if (lu) return Ma;
  lu = 1;
  var e = yr();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return Ma = t, Ma;
}
var Da, fu;
function Fm() {
  if (fu) return Da;
  fu = 1;
  function e(t) {
    var r = this.__data__, n = r.delete(t);
    return this.size = r.size, n;
  }
  return Da = e, Da;
}
var Fa, du;
function Nm() {
  if (du) return Fa;
  du = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return Fa = e, Fa;
}
var Na, hu;
function km() {
  if (hu) return Na;
  hu = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return Na = e, Na;
}
var ka, pu;
function Lm() {
  if (pu) return ka;
  pu = 1;
  var e = yr(), t = mo(), r = bo(), n = 200;
  function a(i, o) {
    var s = this.__data__;
    if (s instanceof e) {
      var c = s.__data__;
      if (!t || c.length < n - 1)
        return c.push([i, o]), this.size = ++s.size, this;
      s = this.__data__ = new r(c);
    }
    return s.set(i, o), this.size = s.size, this;
  }
  return ka = a, ka;
}
var La, vu;
function jf() {
  if (vu) return La;
  vu = 1;
  var e = yr(), t = Dm(), r = Fm(), n = Nm(), a = km(), i = Lm();
  function o(s) {
    var c = this.__data__ = new e(s);
    this.size = c.size;
  }
  return o.prototype.clear = t, o.prototype.delete = r, o.prototype.get = n, o.prototype.has = a, o.prototype.set = i, La = o, La;
}
var Ba, gu;
function Bm() {
  if (gu) return Ba;
  gu = 1;
  var e = "__lodash_hash_undefined__";
  function t(r) {
    return this.__data__.set(r, e), this;
  }
  return Ba = t, Ba;
}
var Va, mu;
function Vm() {
  if (mu) return Va;
  mu = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return Va = e, Va;
}
var Ha, bu;
function Hm() {
  if (bu) return Ha;
  bu = 1;
  var e = bo(), t = Bm(), r = Vm();
  function n(a) {
    var i = -1, o = a == null ? 0 : a.length;
    for (this.__data__ = new e(); ++i < o; )
      this.add(a[i]);
  }
  return n.prototype.add = n.prototype.push = t, n.prototype.has = r, Ha = n, Ha;
}
var za, yu;
function zm() {
  if (yu) return za;
  yu = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length; ++n < a; )
      if (r(t[n], n, t))
        return !0;
    return !1;
  }
  return za = e, za;
}
var Ua, _u;
function Um() {
  if (_u) return Ua;
  _u = 1;
  function e(t, r) {
    return t.has(r);
  }
  return Ua = e, Ua;
}
var Wa, xu;
function If() {
  if (xu) return Wa;
  xu = 1;
  var e = Hm(), t = zm(), r = Um(), n = 1, a = 2;
  function i(o, s, c, u, d, l) {
    var h = c & n, f = o.length, g = s.length;
    if (f != g && !(h && g > f))
      return !1;
    var p = l.get(o), m = l.get(s);
    if (p && m)
      return p == s && m == o;
    var b = -1, _ = !0, C = c & a ? new e() : void 0;
    for (l.set(o, s), l.set(s, o); ++b < f; ) {
      var R = o[b], P = s[b];
      if (u)
        var A = h ? u(P, R, b, s, o, l) : u(R, P, b, o, s, l);
      if (A !== void 0) {
        if (A)
          continue;
        _ = !1;
        break;
      }
      if (C) {
        if (!t(s, function(T, x) {
          if (!r(C, x) && (R === T || d(R, T, c, u, l)))
            return C.push(x);
        })) {
          _ = !1;
          break;
        }
      } else if (!(R === P || d(R, P, c, u, l))) {
        _ = !1;
        break;
      }
    }
    return l.delete(o), l.delete(s), _;
  }
  return Wa = i, Wa;
}
var Ga, wu;
function Wm() {
  if (wu) return Ga;
  wu = 1;
  var e = Oe(), t = e.Uint8Array;
  return Ga = t, Ga;
}
var Ka, Cu;
function Gm() {
  if (Cu) return Ka;
  Cu = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(a, i) {
      n[++r] = [i, a];
    }), n;
  }
  return Ka = e, Ka;
}
var Ya, Ru;
function Km() {
  if (Ru) return Ya;
  Ru = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(a) {
      n[++r] = a;
    }), n;
  }
  return Ya = e, Ya;
}
var Xa, Su;
function Ym() {
  if (Su) return Xa;
  Su = 1;
  var e = It(), t = Wm(), r = go(), n = If(), a = Gm(), i = Km(), o = 1, s = 2, c = "[object Boolean]", u = "[object Date]", d = "[object Error]", l = "[object Map]", h = "[object Number]", f = "[object RegExp]", g = "[object Set]", p = "[object String]", m = "[object Symbol]", b = "[object ArrayBuffer]", _ = "[object DataView]", C = e ? e.prototype : void 0, R = C ? C.valueOf : void 0;
  function P(A, T, x, w, E, S, I) {
    switch (x) {
      case _:
        if (A.byteLength != T.byteLength || A.byteOffset != T.byteOffset)
          return !1;
        A = A.buffer, T = T.buffer;
      case b:
        return !(A.byteLength != T.byteLength || !S(new t(A), new t(T)));
      case c:
      case u:
      case h:
        return r(+A, +T);
      case d:
        return A.name == T.name && A.message == T.message;
      case f:
      case p:
        return A == T + "";
      case l:
        var $ = a;
      case g:
        var M = w & o;
        if ($ || ($ = i), A.size != T.size && !M)
          return !1;
        var F = I.get(A);
        if (F)
          return F == T;
        w |= s, I.set(A, T);
        var q = n($(A), $(T), w, E, S, I);
        return I.delete(A), q;
      case m:
        if (R)
          return R.call(A) == R.call(T);
    }
    return !1;
  }
  return Xa = P, Xa;
}
var Ja, Pu;
function Xm() {
  if (Pu) return Ja;
  Pu = 1;
  var e = qf(), t = Pe();
  function r(n, a, i) {
    var o = a(n);
    return t(n) ? o : e(o, i(n));
  }
  return Ja = r, Ja;
}
var Za, Eu;
function Jm() {
  if (Eu) return Za;
  Eu = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length, i = 0, o = []; ++n < a; ) {
      var s = t[n];
      r(s, n, t) && (o[i++] = s);
    }
    return o;
  }
  return Za = e, Za;
}
var Qa, Au;
function Zm() {
  if (Au) return Qa;
  Au = 1;
  function e() {
    return [];
  }
  return Qa = e, Qa;
}
var ei, Ou;
function Qm() {
  if (Ou) return ei;
  Ou = 1;
  var e = Jm(), t = Zm(), r = Object.prototype, n = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, i = a ? function(o) {
    return o == null ? [] : (o = Object(o), e(a(o), function(s) {
      return n.call(o, s);
    }));
  } : t;
  return ei = i, ei;
}
var ti, Tu;
function eb() {
  if (Tu) return ti;
  Tu = 1;
  function e(t, r) {
    for (var n = -1, a = Array(t); ++n < t; )
      a[n] = r(n);
    return a;
  }
  return ti = e, ti;
}
var wt = { exports: {} }, ri, $u;
function tb() {
  if ($u) return ri;
  $u = 1;
  function e() {
    return !1;
  }
  return ri = e, ri;
}
wt.exports;
var qu;
function Mf() {
  return qu || (qu = 1, (function(e, t) {
    var r = Oe(), n = tb(), a = t && !t.nodeType && t, i = a && !0 && e && !e.nodeType && e, o = i && i.exports === a, s = o ? r.Buffer : void 0, c = s ? s.isBuffer : void 0, u = c || n;
    e.exports = u;
  })(wt, wt.exports)), wt.exports;
}
var ni, ju;
function rb() {
  if (ju) return ni;
  ju = 1;
  var e = Ye(), t = xo(), r = Xe(), n = "[object Arguments]", a = "[object Array]", i = "[object Boolean]", o = "[object Date]", s = "[object Error]", c = "[object Function]", u = "[object Map]", d = "[object Number]", l = "[object Object]", h = "[object RegExp]", f = "[object Set]", g = "[object String]", p = "[object WeakMap]", m = "[object ArrayBuffer]", b = "[object DataView]", _ = "[object Float32Array]", C = "[object Float64Array]", R = "[object Int8Array]", P = "[object Int16Array]", A = "[object Int32Array]", T = "[object Uint8Array]", x = "[object Uint8ClampedArray]", w = "[object Uint16Array]", E = "[object Uint32Array]", S = {};
  S[_] = S[C] = S[R] = S[P] = S[A] = S[T] = S[x] = S[w] = S[E] = !0, S[n] = S[a] = S[m] = S[i] = S[b] = S[o] = S[s] = S[c] = S[u] = S[d] = S[l] = S[h] = S[f] = S[g] = S[p] = !1;
  function I($) {
    return r($) && t($.length) && !!S[e($)];
  }
  return ni = I, ni;
}
var ai, Iu;
function Df() {
  if (Iu) return ai;
  Iu = 1;
  var e = rb(), t = po(), r = wf(), n = r && r.isTypedArray, a = n ? t(n) : e;
  return ai = a, ai;
}
var ii, Mu;
function nb() {
  if (Mu) return ii;
  Mu = 1;
  var e = eb(), t = _o(), r = Pe(), n = Mf(), a = yo(), i = Df(), o = Object.prototype, s = o.hasOwnProperty;
  function c(u, d) {
    var l = r(u), h = !l && t(u), f = !l && !h && n(u), g = !l && !h && !f && i(u), p = l || h || f || g, m = p ? e(u.length, String) : [], b = m.length;
    for (var _ in u)
      (d || s.call(u, _)) && !(p && // Safari 9 has enumerable `arguments.length` in strict mode.
      (_ == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      f && (_ == "offset" || _ == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      g && (_ == "buffer" || _ == "byteLength" || _ == "byteOffset") || // Skip index properties.
      a(_, b))) && m.push(_);
    return m;
  }
  return ii = c, ii;
}
var oi, Du;
function ab() {
  if (Du) return oi;
  Du = 1;
  var e = Object.prototype;
  function t(r) {
    var n = r && r.constructor, a = typeof n == "function" && n.prototype || e;
    return r === a;
  }
  return oi = t, oi;
}
var si, Fu;
function ib() {
  if (Fu) return si;
  Fu = 1;
  function e(t, r) {
    return function(n) {
      return t(r(n));
    };
  }
  return si = e, si;
}
var ci, Nu;
function ob() {
  if (Nu) return ci;
  Nu = 1;
  var e = ib(), t = e(Object.keys, Object);
  return ci = t, ci;
}
var ui, ku;
function sb() {
  if (ku) return ui;
  ku = 1;
  var e = ab(), t = ob(), r = Object.prototype, n = r.hasOwnProperty;
  function a(i) {
    if (!e(i))
      return t(i);
    var o = [];
    for (var s in Object(i))
      n.call(i, s) && s != "constructor" && o.push(s);
    return o;
  }
  return ui = a, ui;
}
var li, Lu;
function wo() {
  if (Lu) return li;
  Lu = 1;
  var e = Af(), t = xo();
  function r(n) {
    return n != null && t(n.length) && !e(n);
  }
  return li = r, li;
}
var fi, Bu;
function Co() {
  if (Bu) return fi;
  Bu = 1;
  var e = nb(), t = sb(), r = wo();
  function n(a) {
    return r(a) ? e(a) : t(a);
  }
  return fi = n, fi;
}
var di, Vu;
function cb() {
  if (Vu) return di;
  Vu = 1;
  var e = Xm(), t = Qm(), r = Co();
  function n(a) {
    return e(a, r, t);
  }
  return di = n, di;
}
var hi, Hu;
function ub() {
  if (Hu) return hi;
  Hu = 1;
  var e = cb(), t = 1, r = Object.prototype, n = r.hasOwnProperty;
  function a(i, o, s, c, u, d) {
    var l = s & t, h = e(i), f = h.length, g = e(o), p = g.length;
    if (f != p && !l)
      return !1;
    for (var m = f; m--; ) {
      var b = h[m];
      if (!(l ? b in o : n.call(o, b)))
        return !1;
    }
    var _ = d.get(i), C = d.get(o);
    if (_ && C)
      return _ == o && C == i;
    var R = !0;
    d.set(i, o), d.set(o, i);
    for (var P = l; ++m < f; ) {
      b = h[m];
      var A = i[b], T = o[b];
      if (c)
        var x = l ? c(T, A, b, o, i, d) : c(A, T, b, i, o, d);
      if (!(x === void 0 ? A === T || u(A, T, s, c, d) : x)) {
        R = !1;
        break;
      }
      P || (P = b == "constructor");
    }
    if (R && !P) {
      var w = i.constructor, E = o.constructor;
      w != E && "constructor" in i && "constructor" in o && !(typeof w == "function" && w instanceof w && typeof E == "function" && E instanceof E) && (R = !1);
    }
    return d.delete(i), d.delete(o), R;
  }
  return hi = a, hi;
}
var pi, zu;
function lb() {
  if (zu) return pi;
  zu = 1;
  var e = Ze(), t = Oe(), r = e(t, "DataView");
  return pi = r, pi;
}
var vi, Uu;
function fb() {
  if (Uu) return vi;
  Uu = 1;
  var e = Ze(), t = Oe(), r = e(t, "Promise");
  return vi = r, vi;
}
var gi, Wu;
function db() {
  if (Wu) return gi;
  Wu = 1;
  var e = Ze(), t = Oe(), r = e(t, "Set");
  return gi = r, gi;
}
var mi, Gu;
function hb() {
  if (Gu) return mi;
  Gu = 1;
  var e = Ze(), t = Oe(), r = e(t, "WeakMap");
  return mi = r, mi;
}
var bi, Ku;
function pb() {
  if (Ku) return bi;
  Ku = 1;
  var e = lb(), t = mo(), r = fb(), n = db(), a = hb(), i = Ye(), o = Of(), s = "[object Map]", c = "[object Object]", u = "[object Promise]", d = "[object Set]", l = "[object WeakMap]", h = "[object DataView]", f = o(e), g = o(t), p = o(r), m = o(n), b = o(a), _ = i;
  return (e && _(new e(new ArrayBuffer(1))) != h || t && _(new t()) != s || r && _(r.resolve()) != u || n && _(new n()) != d || a && _(new a()) != l) && (_ = function(C) {
    var R = i(C), P = R == c ? C.constructor : void 0, A = P ? o(P) : "";
    if (A)
      switch (A) {
        case f:
          return h;
        case g:
          return s;
        case p:
          return u;
        case m:
          return d;
        case b:
          return l;
      }
    return R;
  }), bi = _, bi;
}
var yi, Yu;
function vb() {
  if (Yu) return yi;
  Yu = 1;
  var e = jf(), t = If(), r = Ym(), n = ub(), a = pb(), i = Pe(), o = Mf(), s = Df(), c = 1, u = "[object Arguments]", d = "[object Array]", l = "[object Object]", h = Object.prototype, f = h.hasOwnProperty;
  function g(p, m, b, _, C, R) {
    var P = i(p), A = i(m), T = P ? d : a(p), x = A ? d : a(m);
    T = T == u ? l : T, x = x == u ? l : x;
    var w = T == l, E = x == l, S = T == x;
    if (S && o(p)) {
      if (!o(m))
        return !1;
      P = !0, w = !1;
    }
    if (S && !w)
      return R || (R = new e()), P || s(p) ? t(p, m, b, _, C, R) : r(p, m, T, b, _, C, R);
    if (!(b & c)) {
      var I = w && f.call(p, "__wrapped__"), $ = E && f.call(m, "__wrapped__");
      if (I || $) {
        var M = I ? p.value() : p, F = $ ? m.value() : m;
        return R || (R = new e()), C(M, F, b, _, R);
      }
    }
    return S ? (R || (R = new e()), n(p, m, b, _, C, R)) : !1;
  }
  return yi = g, yi;
}
var _i, Xu;
function Ro() {
  if (Xu) return _i;
  Xu = 1;
  var e = vb(), t = Xe();
  function r(n, a, i, o, s) {
    return n === a ? !0 : n == null || a == null || !t(n) && !t(a) ? n !== n && a !== a : e(n, a, i, o, r, s);
  }
  return _i = r, _i;
}
var xi, Ju;
function gb() {
  if (Ju) return xi;
  Ju = 1;
  var e = Ro();
  function t(r, n) {
    return e(r, n);
  }
  return xi = t, xi;
}
var mb = gb();
const bb = /* @__PURE__ */ Se(mb);
var wi, Zu;
function yb() {
  if (Zu) return wi;
  Zu = 1;
  var e = Ye(), t = Xe(), r = "[object Number]";
  function n(a) {
    return typeof a == "number" || t(a) && e(a) == r;
  }
  return wi = n, wi;
}
var _b = yb();
const Ff = /* @__PURE__ */ Se(_b), xb = "_trigger_1mrk9_1", wb = {
  trigger: xb
}, Cb = Ce(function({
  title: t,
  metrics: r,
  children: n
}) {
  const a = /* @__PURE__ */ y.jsxs(Y, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "1", color: "inherit", children: t }),
    r.length > 0 && /* @__PURE__ */ y.jsx(eo, { bounded: !0, children: r.map((i, o) => /* @__PURE__ */ y.jsx(mf, { instrument: i, theme: "dark" }, o)) })
  ] });
  return /* @__PURE__ */ y.jsx(
    Ot,
    {
      content: a,
      wrap: "div",
      wrapProps: { className: wb.trigger },
      children: n
    }
  );
}), Rb = "_cell_hfkay_1", Sb = "_cellText_hfkay_11", Pb = "_cellDimmed_hfkay_14", Eb = "_cellContent_hfkay_18", yt = {
  cell: Rb,
  cellText: Sb,
  cellDimmed: Pb,
  cellContent: Eb
}, Gt = Ce(function({
  cell: t,
  dimmed: r = !1,
  background: n = "transparent",
  tooltipProps: a,
  textProps: i = {},
  onMouseEnter: o
}) {
  const [s, c] = Z(!1), u = Ol(t?.value);
  Tt(() => {
    if (t?.value !== u) {
      c(!0);
      const h = setTimeout(() => {
        c(!1);
      }, 200);
      return () => {
        clearTimeout(h);
      };
    }
  }, [t?.value]);
  const d = K(() => {
    if (!t) return null;
    const { value: h, format: f } = t;
    return typeof h == "string" ? h : typeof h == "number" && f ? jt(h, f) : "—";
  }, [t]);
  if (!t)
    return /* @__PURE__ */ y.jsx(
      "div",
      {
        className: yt.cell,
        onMouseEnter: o,
        "data-testid": "heatmap-instrument-cell"
      }
    );
  const l = /* @__PURE__ */ y.jsx("div", { className: yt.cellContent, children: /* @__PURE__ */ y.jsx(
    W.Paragraph,
    {
      className: qe({
        [yt.cellText]: typeof t.value == "string"
      }),
      variant: "3",
      subdued: !Ff(t.value),
      ...i,
      children: d
    }
  ) });
  return /* @__PURE__ */ y.jsx(
    "div",
    {
      className: qe(yt.cell, {
        [yt.cellDimmed]: r || s
      }),
      onMouseEnter: o,
      style: { backgroundColor: n },
      "data-animating": s,
      "data-testid": "heatmap-instrument-cell",
      children: a?.enabled ? /* @__PURE__ */ y.jsx(Cb, { ...a, children: l }) : l
    }
  );
}), Ab = "_grid_1qk2p_1", Ob = "_row_1qk2p_7", Ci = {
  grid: Ab,
  row: Ob
};
var Qu = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function Tb(e, t) {
  return !!(e === t || Qu(e) && Qu(t));
}
function $b(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (!Tb(e[r], t[r]))
      return !1;
  return !0;
}
function qb(e, t) {
  t === void 0 && (t = $b);
  var r = null;
  function n() {
    for (var a = [], i = 0; i < arguments.length; i++)
      a[i] = arguments[i];
    if (r && r.lastThis === this && t(a, r.lastArgs))
      return r.lastResult;
    var o = e.apply(this, a);
    return r = {
      lastResult: o,
      lastArgs: a,
      lastThis: this
    }, o;
  }
  return n.clear = function() {
    r = null;
  }, n;
}
const jb = [
  "100",
  "200",
  "400",
  "500",
  "700"
].map((e) => `var(--dixa-color-purple-${e})`), Ib = qb(
  (e) => {
    if (e === null)
      return {
        backgroundColor: "var(--dixa-color-neutral-000)",
        color: "tertiary"
      };
    const t = Math.min(
      4,
      Math.floor(Math.min(e, 100) * (5 / 100))
    );
    return {
      backgroundColor: jb?.[t] ?? "var(--dixa-color-neutral-000)",
      color: t >= 3 ? "white" : "primary"
    };
  }
);
function Mb(e) {
  return typeof e == "number" && !Number.isNaN(e) && e >= 0;
}
const Db = (e) => {
  const t = e.flatMap(({ data: a }) => a.map((i) => pr(i).value)).filter(Mb), r = Math.min(...t), n = Math.max(...t);
  return { min: r, max: n };
}, Fb = (e, { min: t, max: r }) => t === r ? 100 : Math.round(100 * (e - t) / (r - t)), ky = ({
  instrument: e
}) => {
  const {
    data: { categories: t, series: r }
  } = e, n = ne(null), [a, i] = vd({
    cell: null,
    column: null,
    row: null
  }), o = K(
    () => Object.values(a).some((f) => f !== null),
    [a]
  ), s = K(() => Db(r), [r]);
  At(() => {
    const f = (g) => {
      n.current && !n.current.contains(g.target) && o && i.reset();
    };
    return window.addEventListener("mousemove", f, !0), () => {
      window.removeEventListener("mousemove", f, !0);
    };
  }, [o, i]);
  const c = G(
    (f) => {
      if (!o)
        return !1;
      const [g, p] = f;
      return a.cell ? !bb(a.cell.id, f) : a.column !== null ? a.column !== p : a.row !== null ? a.row !== g : !1;
    },
    [o, a.cell, a.column, a.row]
  ), u = G(
    (f) => i.setAll({
      cell: null,
      column: f,
      row: null
    }),
    [i]
  ), d = G(
    (f) => i.setAll({
      cell: null,
      column: null,
      row: f
    }),
    [i]
  ), l = G(
    (f) => {
      (o || f !== null) && i.setAll({
        cell: f,
        column: null,
        row: null
      });
    },
    [o, i]
  ), h = G(() => {
    o && i.reset();
  }, [o, i]);
  return /* @__PURE__ */ y.jsxs(
    "div",
    {
      ref: n,
      className: Ci.grid,
      onMouseLeave: () => i.reset(),
      "data-testid": "heatmap-instrument",
      children: [
        /* @__PURE__ */ y.jsxs("div", { className: Ci.row, children: [
          /* @__PURE__ */ y.jsx(Gt, { onMouseEnter: h }),
          r.map((f, g) => {
            const p = r[g].metrics ?? [];
            return /* @__PURE__ */ y.jsx(
              Gt,
              {
                cell: { id: [0, g], value: f.label },
                tooltipProps: {
                  enabled: p.length > 0,
                  title: f.label,
                  metrics: p
                },
                onMouseEnter: () => u(g)
              },
              f.label
            );
          })
        ] }),
        t.map((f, g) => {
          const p = t[g].metrics ?? [];
          return /* @__PURE__ */ y.jsxs("div", { className: Ci.row, children: [
            /* @__PURE__ */ y.jsx(
              Gt,
              {
                cell: { id: [g, 0], value: f.label },
                tooltipProps: {
                  enabled: p.length > 0,
                  title: f.label,
                  metrics: p
                },
                onMouseEnter: () => d(g)
              }
            ),
            r.map((m, b) => {
              const _ = [g, b], { value: C, metrics: R } = pr(
                m.data[g]
              ), P = m.options?.format ?? "number", A = Ff(C), { backgroundColor: T, color: x } = Ib(
                A ? Fb(C, s) : null
              );
              return /* @__PURE__ */ y.jsx(
                Gt,
                {
                  cell: { id: _, value: C, format: P },
                  dimmed: c(_),
                  background: T,
                  tooltipProps: {
                    enabled: A,
                    title: `${f.label}, ${m.label}`,
                    metrics: R?.length ? R : [
                      {
                        type: "metric",
                        title: "Total",
                        data: C,
                        format: P === "count" ? "number" : P
                      }
                    ]
                  },
                  textProps: { color: x },
                  onMouseEnter: () => l(A ? { id: _, value: C } : null)
                },
                _.join(",")
              );
            })
          ] }, f.label);
        })
      ]
    }
  );
}, Nb = "_legend_bx9pd_48", kb = "_trigger_bx9pd_52", Lb = "_popover_bx9pd_58", Bb = "_breakdown_bx9pd_77", Kt = {
  legend: Nb,
  trigger: kb,
  popover: Lb,
  breakdown: Bb
}, Ly = Ce(function({
  instrument: t
}) {
  const {
    data: { availability: r, media_type: n, away: a }
  } = t, i = [
    "var(--dixa-color-purple-700)",
    "var(--dixa-color-neutral-200)"
  ], o = "No data available", s = {
    // Primitive way to ensure the labels are the same width, by deriving it from the longest
    // The number 7 is roughly the average width of a lowercase character
    labelWidth: Math.max(...n.map((l) => l.label.length)) * 7,
    theme: i
  }, c = () => /* @__PURE__ */ y.jsx(
    Zt,
    {
      ...s,
      value: 0,
      label: "n.a.",
      theme: ["var(--dixa-color-neutral-200)", "var(--dixa-color-neutral-200)"],
      showFullBar: !0
    }
  ), u = () => {
    if (!a || !a.length) return null;
    const [l, h, ...f] = a;
    return /* @__PURE__ */ y.jsxs(ff, { children: [
      /* @__PURE__ */ y.jsx(df, { asChild: !0, children: /* @__PURE__ */ y.jsx(
        no,
        {
          variant: "tertiary",
          icon: "dots-h",
          className: Kt.trigger
        }
      ) }),
      /* @__PURE__ */ y.jsx(hf, { children: /* @__PURE__ */ y.jsx(pf, { side: "right", className: Kt.popover, children: /* @__PURE__ */ y.jsxs("ul", { className: Kt.breakdown, children: [
        /* @__PURE__ */ y.jsxs("li", { children: [
          /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "1", children: l.label }),
          /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "1", children: Ue(l.value) })
        ] }),
        /* @__PURE__ */ y.jsxs("li", { children: [
          /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "2", subdued: !0, children: h.label }),
          /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "2", subdued: !0, children: Ue(h.value) })
        ] }),
        /* @__PURE__ */ y.jsx(sd, {}),
        f.map((g, p) => /* @__PURE__ */ y.jsxs("li", { children: [
          /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "2", children: g.label }),
          /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "1", children: Ue(g.value) })
        ] }, p))
      ] }) }) })
    ] });
  }, d = () => /* @__PURE__ */ y.jsxs(Y, { gap: "300", className: Kt.legend, children: [
    r.map((l, h) => /* @__PURE__ */ y.jsxs(Y, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ y.jsx(
        ao,
        {
          width: "6px",
          height: "6px",
          background: i[h],
          borderRadius: "50%"
        }
      ),
      /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "4", children: l.label })
    ] }, h)),
    u()
  ] });
  return /* @__PURE__ */ y.jsxs(Y, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ y.jsxs(Y, { flexDirection: "column", gap: "300", children: [
      /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "4", subdued: !0, children: r.length ? "Availability" : o }),
      r.length ? /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
        d(),
        /* @__PURE__ */ y.jsx(
          Zt,
          {
            ...s,
            value: r[0].value,
            label: "Total",
            showFullBar: !0,
            showDifference: !0
          }
        )
      ] }) : c()
    ] }),
    /* @__PURE__ */ y.jsxs(Y, { flexDirection: "column", gap: "300", children: [
      /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "4", subdued: !0, children: n.length ? "Availability per channel" : o }),
      n.length > 0 ? /* @__PURE__ */ y.jsx(Y, { flexDirection: "column", gap: "200", children: n.map((l, h) => /* @__PURE__ */ H(
        Zt,
        {
          ...s,
          key: h,
          value: l.value,
          label: l.label
        }
      )) }) : c()
    ] })
  ] });
}), Vb = "_tooltip_h4i5v_1", Hb = "_trigger_h4i5v_5", el = {
  tooltip: Vb,
  trigger: Hb
}, zb = ({
  text: e
}) => /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
  /* @__PURE__ */ y.jsx("span", { children: e }),
  /* @__PURE__ */ y.jsx(
    Ot,
    {
      className: el.tooltip,
      content: e,
      wrap: "div",
      wrapProps: { className: el.trigger }
    }
  )
] }), Ub = Ce(
  function({
    value: t
  }) {
    const [r, ...n] = t;
    return /* @__PURE__ */ y.jsxs(Y, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "2", as: "span", children: r }),
      n.length > 0 && /* @__PURE__ */ y.jsx(Ot, { content: n.join(", "), children: /* @__PURE__ */ y.jsxs(W.ExternalLink, { as: "span", children: [
        "+ ",
        n.length,
        " more"
      ] }) })
    ] });
  }
), Wb = ({
  cell: e,
  format: t,
  timezone: r,
  customFormats: n
}) => {
  const a = K(() => {
    if (!e || Gb(e.value))
      return /* @__PURE__ */ y.jsx(W.Paragraph, { variant: "2", color: "neutral.500", children: "n.a." });
    const { value: i, label: o } = e;
    if (o) return o;
    if (n?.[t])
      return n[t]?.({ value: i });
    switch (t) {
      case "boolean":
        return i ? "Y" : "N";
      case "date":
        return ut.tz(i, r).format("L, LT");
      case "count":
        return vf(i);
      case "number":
        return Et(i);
      case "percentage":
        return `${Et(i)}%`;
      case "duration":
        return Ue(i);
      case "csid":
        return `#${i}`;
      case "rating":
        return `${i}`;
      case "presence":
        return /* @__PURE__ */ y.jsx(Zt, { value: i, showFullBar: !0 });
      case "tags":
        return /* @__PURE__ */ y.jsx(Id, { tags: i, limit: 1 });
      case "text":
        return /* @__PURE__ */ y.jsx(zb, { text: i });
      case "list":
        return /* @__PURE__ */ y.jsx(Ub, { value: i });
      case "string":
      default:
        return `${i}`;
    }
  }, [e, n, t, r]);
  return e?.ui?.type === "badge" ? /* @__PURE__ */ y.jsx(cd, { variant: e.ui.variant, size: "medium", children: /* @__PURE__ */ y.jsx(y.Fragment, { children: a }) }) : /* @__PURE__ */ y.jsx(y.Fragment, { children: a });
};
function Gb(e) {
  const t = e === null, r = typeof e == "string" && e.trim() === "", n = Array.isArray(e) && !e.length;
  return t || r || n;
}
const Kb = "_tableWrapper_1xmkm_1", Yb = "_tableWrapperEmpty_1xmkm_4", Xb = "_thCell_1xmkm_8", Jb = "_tdCell_1xmkm_12", Zb = "_tooltip_1xmkm_20", _t = {
  tableWrapper: Kb,
  tableWrapperEmpty: Yb,
  thCell: Xb,
  tdCell: Jb,
  tooltip: Zb
};
var Ri, tl;
function Qb() {
  if (tl) return Ri;
  tl = 1;
  function e(t) {
    return t == null;
  }
  return Ri = e, Ri;
}
var ey = Qb();
const ty = /* @__PURE__ */ Se(ey);
var Si, rl;
function ry() {
  if (rl) return Si;
  rl = 1;
  var e = jf(), t = Ro(), r = 1, n = 2;
  function a(i, o, s, c) {
    var u = s.length, d = u, l = !c;
    if (i == null)
      return !d;
    for (i = Object(i); u--; ) {
      var h = s[u];
      if (l && h[2] ? h[1] !== i[h[0]] : !(h[0] in i))
        return !1;
    }
    for (; ++u < d; ) {
      h = s[u];
      var f = h[0], g = i[f], p = h[1];
      if (l && h[2]) {
        if (g === void 0 && !(f in i))
          return !1;
      } else {
        var m = new e();
        if (c)
          var b = c(g, p, f, i, o, m);
        if (!(b === void 0 ? t(p, g, r | n, c, m) : b))
          return !1;
      }
    }
    return !0;
  }
  return Si = a, Si;
}
var Pi, nl;
function Nf() {
  if (nl) return Pi;
  nl = 1;
  var e = Je();
  function t(r) {
    return r === r && !e(r);
  }
  return Pi = t, Pi;
}
var Ei, al;
function ny() {
  if (al) return Ei;
  al = 1;
  var e = Nf(), t = Co();
  function r(n) {
    for (var a = t(n), i = a.length; i--; ) {
      var o = a[i], s = n[o];
      a[i] = [o, s, e(s)];
    }
    return a;
  }
  return Ei = r, Ei;
}
var Ai, il;
function kf() {
  if (il) return Ai;
  il = 1;
  function e(t, r) {
    return function(n) {
      return n == null ? !1 : n[t] === r && (r !== void 0 || t in Object(n));
    };
  }
  return Ai = e, Ai;
}
var Oi, ol;
function ay() {
  if (ol) return Oi;
  ol = 1;
  var e = ry(), t = ny(), r = kf();
  function n(a) {
    var i = t(a);
    return i.length == 1 && i[0][2] ? r(i[0][0], i[0][1]) : function(o) {
      return o === a || e(o, a, i);
    };
  }
  return Oi = n, Oi;
}
var Ti, sl;
function iy() {
  if (sl) return Ti;
  sl = 1;
  var e = wr();
  function t(r, n, a) {
    var i = r == null ? void 0 : e(r, n);
    return i === void 0 ? a : i;
  }
  return Ti = t, Ti;
}
var $i, cl;
function oy() {
  if (cl) return $i;
  cl = 1;
  var e = Ro(), t = iy(), r = $f(), n = vo(), a = Nf(), i = kf(), o = Dt(), s = 1, c = 2;
  function u(d, l) {
    return n(d) && a(l) ? i(o(d), l) : function(h) {
      var f = t(h, d);
      return f === void 0 && f === l ? r(h, d) : e(l, f, s | c);
    };
  }
  return $i = u, $i;
}
var qi, ul;
function sy() {
  if (ul) return qi;
  ul = 1;
  var e = wr();
  function t(r) {
    return function(n) {
      return e(n, r);
    };
  }
  return qi = t, qi;
}
var ji, ll;
function cy() {
  if (ll) return ji;
  ll = 1;
  var e = Cf(), t = sy(), r = vo(), n = Dt();
  function a(i) {
    return r(i) ? e(n(i)) : t(i);
  }
  return ji = a, ji;
}
var Ii, fl;
function uy() {
  if (fl) return Ii;
  fl = 1;
  var e = ay(), t = oy(), r = Cr(), n = Pe(), a = cy();
  function i(o) {
    return typeof o == "function" ? o : o == null ? r : typeof o == "object" ? n(o) ? t(o[0], o[1]) : e(o) : a(o);
  }
  return Ii = i, Ii;
}
var Mi, dl;
function ly() {
  if (dl) return Mi;
  dl = 1;
  function e(t) {
    return function(r, n, a) {
      for (var i = -1, o = Object(r), s = a(r), c = s.length; c--; ) {
        var u = s[t ? c : ++i];
        if (n(o[u], u, o) === !1)
          break;
      }
      return r;
    };
  }
  return Mi = e, Mi;
}
var Di, hl;
function fy() {
  if (hl) return Di;
  hl = 1;
  var e = ly(), t = e();
  return Di = t, Di;
}
var Fi, pl;
function dy() {
  if (pl) return Fi;
  pl = 1;
  var e = fy(), t = Co();
  function r(n, a) {
    return n && e(n, a, t);
  }
  return Fi = r, Fi;
}
var Ni, vl;
function hy() {
  if (vl) return Ni;
  vl = 1;
  var e = wo();
  function t(r, n) {
    return function(a, i) {
      if (a == null)
        return a;
      if (!e(a))
        return r(a, i);
      for (var o = a.length, s = n ? o : -1, c = Object(a); (n ? s-- : ++s < o) && i(c[s], s, c) !== !1; )
        ;
      return a;
    };
  }
  return Ni = t, Ni;
}
var ki, gl;
function py() {
  if (gl) return ki;
  gl = 1;
  var e = dy(), t = hy(), r = t(e);
  return ki = r, ki;
}
var Li, ml;
function vy() {
  if (ml) return Li;
  ml = 1;
  var e = py(), t = wo();
  function r(n, a) {
    var i = -1, o = t(n) ? Array(n.length) : [];
    return e(n, function(s, c, u) {
      o[++i] = a(s, c, u);
    }), o;
  }
  return Li = r, Li;
}
var Bi, bl;
function gy() {
  if (bl) return Bi;
  bl = 1;
  function e(t, r) {
    var n = t.length;
    for (t.sort(r); n--; )
      t[n] = t[n].value;
    return t;
  }
  return Bi = e, Bi;
}
var Vi, yl;
function my() {
  if (yl) return Vi;
  yl = 1;
  var e = Mt();
  function t(r, n) {
    if (r !== n) {
      var a = r !== void 0, i = r === null, o = r === r, s = e(r), c = n !== void 0, u = n === null, d = n === n, l = e(n);
      if (!u && !l && !s && r > n || s && c && d && !u && !l || i && c && d || !a && d || !o)
        return 1;
      if (!i && !s && !l && r < n || l && a && o && !i && !s || u && a && o || !c && o || !d)
        return -1;
    }
    return 0;
  }
  return Vi = t, Vi;
}
var Hi, _l;
function by() {
  if (_l) return Hi;
  _l = 1;
  var e = my();
  function t(r, n, a) {
    for (var i = -1, o = r.criteria, s = n.criteria, c = o.length, u = a.length; ++i < c; ) {
      var d = e(o[i], s[i]);
      if (d) {
        if (i >= u)
          return d;
        var l = a[i];
        return d * (l == "desc" ? -1 : 1);
      }
    }
    return r.index - n.index;
  }
  return Hi = t, Hi;
}
var zi, xl;
function yy() {
  if (xl) return zi;
  xl = 1;
  var e = yf(), t = wr(), r = uy(), n = vy(), a = gy(), i = po(), o = by(), s = Cr(), c = Pe();
  function u(d, l, h) {
    l.length ? l = e(l, function(p) {
      return c(p) ? function(m) {
        return t(m, p.length === 1 ? p[0] : p);
      } : p;
    }) : l = [s];
    var f = -1;
    l = e(l, i(r));
    var g = n(d, function(p, m, b) {
      var _ = e(l, function(C) {
        return C(p);
      });
      return { criteria: _, index: ++f, value: p };
    });
    return a(g, function(p, m) {
      return o(p, m, h);
    });
  }
  return zi = u, zi;
}
var Ui, wl;
function _y() {
  if (wl) return Ui;
  wl = 1;
  var e = yy(), t = Pe();
  function r(n, a, i, o) {
    return n == null ? [] : (t(a) || (a = a == null ? [] : [a]), i = o ? void 0 : i, t(i) || (i = i == null ? [] : [i]), e(n, a, i));
  }
  return Ui = r, Ui;
}
var xy = _y();
const wy = /* @__PURE__ */ Se(xy), Cy = (e) => typeof e == "string" || typeof e == "number" || typeof e == "boolean", Cl = (e, t) => {
  const r = e.cells.find((n) => n.column === t.key);
  return !r || r.value === null ? null : (Cy(r.value), r.value);
}, Ry = ({
  data: { columns: e, rows: t },
  limit: r = 50,
  sortStatus: n
}) => {
  const i = Math.ceil(t.length / r), [o, s] = Z(1);
  Tt(() => {
    o !== 1 && s(1);
  }, [n, i]);
  const c = K(() => {
    if (!n) return t;
    const d = e.find(({ key: l }) => l === n.sortBy);
    return d ? wy(
      t,
      [
        (l) => !ty(Cl(l, d)),
        (l) => Cl(l, d)
      ],
      ["desc", n.direction]
    ) : t;
  }, [e, t, n]);
  return {
    rows: K(
      () => c.slice((o - 1) * r, o * r),
      [o, r, c]
    ),
    currentPage: o,
    totalPages: i,
    setPage: s
  };
}, By = ({
  instrument: e,
  timezone: t,
  onReadInstruments: r,
  onLoadAll: n,
  onSortChange: a,
  customFormats: i
}) => {
  const {
    title: o,
    data: s,
    data: { columns: c, options: u }
  } = e, [d, l] = Z(null), h = ne(null), f = u?.limit ?? 50, { rows: g, currentPage: p, totalPages: m, setPage: b } = Ry({
    data: s,
    limit: f,
    sortStatus: d
  }), _ = s.rows.length === 0, C = !!u?.next_page, R = !C && m > 1;
  Tt(() => {
    h.current && (h.current.scrollTop = 0);
  }, [p]);
  const P = G(() => (n?.(), r({
    meta: {
      pagination: {
        limit: null
      }
    }
  })), [n, r]), A = G(
    async (T) => {
      C && await P(), l(T), a?.(T);
    },
    [P, a, C]
  );
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    o && /* @__PURE__ */ y.jsx("div", { children: /* @__PURE__ */ y.jsx(W.Heading, { variant: "heading-4", children: o }) }),
    /* @__PURE__ */ y.jsxs(
      Re,
      {
        stickyHeader: !0,
        sortingProps: {
          sortStatus: d,
          onSortChange: A
        },
        wrapperProps: {
          className: qe(_t.tableWrapper, {
            [_t.tableWrapperEmpty]: _
          })
        },
        wrapperRef: h,
        hoverable: !_,
        children: [
          /* @__PURE__ */ y.jsx(Re.Thead, { children: /* @__PURE__ */ y.jsx(Re.Tr, { children: c.map(({ key: T, label: x, sortable: w }) => /* @__PURE__ */ y.jsx(
            Re.Th,
            {
              className: _t.thCell,
              columnId: w ? T : null,
              children: x
            },
            x
          )) }) }),
          /* @__PURE__ */ y.jsxs(Re.Tbody, { children: [
            _ && /* @__PURE__ */ y.jsx(Re.Tr, { children: /* @__PURE__ */ y.jsx(Re.Td, { colSpan: c.length, children: /* @__PURE__ */ y.jsx(
              El,
              {
                title: "No data available",
                description: "There is no data available for the selected period and filters.",
                icon: "th"
              }
            ) }) }),
            g.map((T, x) => {
              const w = `row-${x}`;
              return /* @__PURE__ */ y.jsx(Re.Tr, { children: c.map(({ key: E, format: S }, I) => {
                const $ = T.cells.find((M) => M.column === E);
                return /* @__PURE__ */ y.jsx(
                  Re.Td,
                  {
                    className: _t.tdCell,
                    children: /* @__PURE__ */ y.jsx(
                      Wb,
                      {
                        cell: $,
                        format: S,
                        timezone: t,
                        customFormats: i
                      }
                    )
                  },
                  `${w}-cell-${I}`
                );
              }) }, w);
            })
          ] }),
          C && /* @__PURE__ */ y.jsx(Re.Footer, { children: /* @__PURE__ */ y.jsxs(Y, { alignItems: "center", justifyContent: "center", gap: "300", children: [
            /* @__PURE__ */ y.jsxs(Y, { gap: "100", alignItems: "center", children: [
              /* @__PURE__ */ y.jsx(
                ud,
                {
                  tooltipClassName: _t.tooltip,
                  text: `By default we only load the first ${f} results. If you need to see all available results, click on the button, but beware that this may take a bit of time to load depending on the number of results.`
                }
              ),
              /* @__PURE__ */ y.jsxs(W.Paragraph, { variant: "2", children: [
                "Showing only the ",
                /* @__PURE__ */ y.jsxs("b", { children: [
                  "first ",
                  f,
                  " results"
                ] })
              ] })
            ] }),
            /* @__PURE__ */ y.jsx(Pl, { variant: "secondary", onClick: P, children: "Load all results" })
          ] }) }),
          R && /* @__PURE__ */ y.jsx(Re.Footer, { children: /* @__PURE__ */ y.jsx(Y, { alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ y.jsx(
            ld,
            {
              pageCount: m,
              currentPage: p,
              pageRangeDisplayed: 6,
              onPageChange: b
            }
          ) }) })
        ]
      }
    )
  ] });
};
export {
  Dy as AnalyticsMenu,
  Ny as ChartInstrument,
  ky as HeatmapInstrument,
  mf as MetricInstrument,
  Uv as MetricInstrumentData,
  eo as MetricInstrumentsGrid,
  Zt as PercentageBar,
  Ly as PresenceInstrument,
  By as TableInstrument,
  Fy as categorizeInstruments,
  We as chartAppearance,
  vf as formatAbbreviateNumber,
  jt as formatInstrumentNumber,
  Et as formatLocalizedNumber,
  Ue as formatMillisecondsToDuration,
  pr as getChartSeriesValue,
  jv as isAIInsightInstrument,
  Ov as isChartInstrument,
  or as isDateLikeString,
  Tv as isHeatmapInstrument,
  Av as isMetricInstrument,
  qv as isPresenceInstrument,
  $v as isTableInstrument,
  Cy as isTableInstrumentDataValuePrimitive,
  st as resolveChartElementColor,
  gf as resolveInstrumentColor
};
//# sourceMappingURL=index.js.map
